module.exports={
    "areg": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. جائزة دعوة مُستخدم واحد <%=gto%> من جوائز GTO، تُقسم ويتم ارسالها <%=count%> مرة",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. تم اختيار جميع المُبارايات طبقًا لشعبيتها وشهرتها بين اغلب المُستخدمين\n@@@@2. نتيجة المُباراة هي فقط النتيجة الخاصة بالمباراة لمُدة 90 دقيقة (بما في ذلك وقت إصابات اللاعبين فقط ، وغير متضمنه ركلات الجزاء والوقت المحتسب بدل من الضائع)\n@@@@3. يتم إلغاء المُباراة بسبب أي صعوبات في تحديد النتيجة من تغييرات في المُباراة أو الفريق أو اعاداة المُباراة ، أو أي أسباب خاصة أخرى.ويتم إرجاع قيمة التخمين إلى حساب المستخدم .\n@@@@4. احتمالات الفوز الظاهرة على الصفحة هي للتوضيح فقط ، الاحتمالات الفعلية خاضعة لمعايير أُخرى طبقًا لقيمة التخمين.",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. عند فوز تخمين الشخص الذي تمت دعوته، يقوم النظام بارسال الجوائز تلقائيًا",
        "<%=count%>GTO": "<%=count%> من جوائز GTO",
        "<%=count%>场比赛可投": "لا يزال بإمكانك تخمين <%=count%> مُباراة",
        "<%=count%>次奖励发放如下：": "ارسال الجائزة <%=count%> مرات يكون  كالآتي:",
        "<%=count%>竞猜记录": "سجل تخمينات <%=count%>",
        "<%=name%>暂时没有贡献": "<%=name%> لا يوجد انجازات مؤقتًا",
        "<%=name%>的邀请码": "  كود الدعوة الخاص ب <%=name%>",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> حصل على <span><%=gto%> من جوائز GTO </span><span><%=eth%>ETH</span><span><%=uz%> من الماس </span>",
        "<em><%=name%></em>的房间": "استاد <em><%=name%></em>",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p> عند تحويل جميع ما تم شراؤه من GTO الجوائز،</p><p> يتم التحويل مُباشرةً إلى عنوان حساب Gifto الخاص بك، </p><p> سارع وقُم بمُراجعة الحساب الخاص بك الآن!</p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p> سيتم تحويل جميع ال ETH إلى حساب Gifto الخاص بالمُستخدم، </p><p> سارع وقُم بمراجعة حسابك الآن! </p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@ تم تصميم لعبة توقع مُباريات كرة القدم من خلال منصة البث المباشر Uplive. يمكن للمستخدمين بسهولة الفوز بالجوائز عن طريق تخمين نتائج مباريات كرة القدم.\n@@@@1. عادة تكون اختيارات تخمين المُباراة تتمثل في 3 اختيارات (فوز الفريق المُضيف- التعادل - فوز الفريق الزائر) فجوائز فوز اي تخمين منهم تختلف نسبة مُضاعفته عن الأخرى\n@@@@2. حجم مُضاعفة الجائزة يتناسب عكسيا مع قوة الفريق ، وكلما زادت قوة الفريق ، كلما قلت مُضاعفة الجائزة . يُمكنك الآن اتخاذ قرارك الخاص ، باختيار اكثر فريق مُرجح فوزه!.\n@@@@3. للتخمين يجب أولًا وضع القيمة المطلوبة من العملات المتاحة للتخمين، فالمنصة تدعم التخمين ب (الماس / GTO / ETH).\n@@@@4. بعد وضع القيمة المطلوبة يُمكنك الاستمرار في التخمين، وكذلك يُمكنك مُراجعة تفاصيل الطلب.\n@@@@ قُم بالتخمين الآن وفُز بالجواز!",
        "GTO投注量": "قيمة التخمين من GTO",
        "U钻": "ماسة",
        "U钻投注量": "كمية ماس التخمين",
        "U钻投注量奖励": "كمية ماس التخمين الجائزة",
        "上一页": "الصفحة السابقة",
        "下一页": "الصفحة التالية",
        "下拉更新": "قُم بالإزاحة للأسفل للتحديث!",
        "下载": "تنزيل",
        "不中返本金": "لن يتم استرجاع القيمة اذا لم تفُز",
        "不中返还": "لن يتم استرجاع القيمة اذا لم تفُز",
        "不再提示": "لا تُذكرني مرة أُخرى",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "جوائز كأس العالم لا تنتهي<br> أسرع وقم بتخمين نتائج المباريات، وفز بالعديد من الجوائز القيمة الآن",
        "两个用户不能相互绑定邀请码,请重新填写": "لا يستطيع مستخدمين اثنين ربط  كود الدعوة ببعضهما البعض ، يُرجى إعادة الإدخال.",
        "中奖计算": "طريقة حساب الفوز",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "بُشرى سارة للمستخدمين الجدد والقدامى، يمكنكم الآن التخمين عن طريق GTO خلال مدة النشاط، ولكن يجب أن يكون التخمين من الرصيد الأساسي للGTO ( ولايتضمن ذلك ال GTO الذي تم الحصول عليها من خلال دعوة الأصدقاء، أو إرسال ظرف المكافأة)، وبعد التخمين فسيحصل المستخدم على عدد من GTO كجائزة له.\nوكلما زاد عدد مرات التخمين، كلما زادت فرصتك في الفوز بجوائز قيمة، وسيتم إرسال الجوائز خلال 7 أيام بعد انتهاء فترة النشاط",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "تقديرا منا للمستخدمين القدامى والجدد المشاركون فى لعبة تخمين كرة القدم، سيتم إرسال جوائز من الماس لهم وذلك مقابل كل الماس الذين قاموا بانفاقة لتخمين مباريات كرة القدم خلال مدة المسابقة ( لا يتضمن الماس الذي تم الحصول عليه بعد إرسال دعوات للأصدقاء) كلما كان إجمالي ماس التخمين أكثر، كلما ازدادت فرصة الحصول على جوائز أكثر، سيتم إرسال جوائز الماس بعد انتهاء المسابقة ب 7 أيام عمل. ",
        "主胜": "فوز الفريق المُضيف",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "عزيزي المستخدم <%=username%> تهانينا لفوزك في مسابقة تخمين مباريات كرة القدم، لقد فزت بجائزة <%=count%> من <%=currency%>",
        "充值": "الشحن",
        "全选": "اختر الكل",
        "全部": "الكل",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "إجمالي <%=count%> من سجل التخمين،  <span class=\"cur-page-box\"> الحالية <%=curPage%> / <%=pages%> الصفحة </span> ",
        "关于我们": "حولنا",
        "分享到Facebook": "مشاركة إلى الفيسبوك",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "يُمكن اختيار أي طريقة من الطرق التالية للقيام بالدفع：إما عن طريق <p class='green'> الماس أو GTO أو ETH للدفع </p>",
        "切换语言": "تبديل اللغة",
        "切换语言版本": "تبديل اللغة",
        "加载中……": "جارِ التحميل......",
        "单个玩法竞猜金额超出上限": "قيمة اللعبة الفردية تجاوزت الحد المسموح به",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "عندما يتجاوز عدد جوائز تخمين المُباريات عدد محدد، يقوم الموظفين بإرسال الجوائز يدويًا ، لذا يُرجى الانتظار أو الاتصال بخدمة العملاء.",
        "单次最大可投<%=count%><%=unit%>": "أكبر تخمين فى المرة الواحدة هو <%=count%> من <%=unit%>",
        "单次竞猜金额超出上限": "قيمة التخمين الفردي تجاوزت الحد المسموح به",
        "去充值": "اذهب للشحن",
        "去登录": "قُم بتسجيل الدخول",
        "参与成功": "تم التخمين بنجاح",
        "参与详情": "تفاصيل المُشاركة",
        "反选": "إلغاء الاختيار",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "شروط الارسال:كل مرة يقوم بها المُستخدم الذي قُمت بدعوته بالتخمين، تحصل حينها على جائزة فورًا.",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "نظرًا للقوانين والسياسات المحلية، فلا يمكن استخدام هذا المنتج مؤقتًا في هذه المنطقة.",
        "可领取奖励": "الجوائز التى يمكن الحصول عليها",
        "可领取奖励：": "الجوائز التى يمكن الحصول عليها :",
        "同一台设备不可多次绑定邀请码": "لا يمكن ربط كود الدعوة بنفس الجهاز أكثر من مرة",
        "含获赠的": "الذي تم الحصول عليه",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "خلال مبارتي <%=hostname%> ضد <%=guestname%> ،أكبر تخمين فى المرة الواحدة هو <%=max%> من <%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "عند نجاح ربط كود الدعوة، ستحصل على <%=count%> من جوائز GTO",
        "复制成功": "تم النسخ بنجاح",
        "复制邀请地址": "نسخ عنوان الرابط",
        "大奖派发": "ارسال الجوائز",
        "奖励": "الجوائز",
        "奖励规则如下：": "قواعد الجوائز كما يلي:",
        "好友猜中比赛后，你也可以获得奖励哦~~": "إذا قام أصدقاؤك بالتخمين معك، فيمكنك الحصول على العديد من الجوائز أيضا!",
        "如何邀请？": "كيفية القيام بالدعوة؟",
        "客胜": "فوز الفريق الزائر",
        "小视频": "فيديو قصير",
        "尾页": "إنهاء",
        "已中奖": "تم الفوز",
        "已使用": "تم الاستخدام",
        "已取消": "تم الإلغاء",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "تم نسخ عنوان الدعوة الخاص بك <br /> سارع وقُم بدعوة أصدقائك واستمتعوا باللعب سويًا الآن!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "لا يُمكن تخمين هذه المُباراة، انتهى التخمين لتلك المُباراة<br/> يُرجى القيام بتخمين مُباراة أُخرى! ",
        "已选<%=count%>场比赛": "تم اختيار  <%=count%> مُباراة",
        "帮助": "مساعدة",
        "平": "التعادل",
        "平局": "التعادل",
        "开赛": "بدء المُباراة",
        "当前是最后一页": "أنت الآن في الصفحة الأخيرة",
        "当前是第一页": "أنت الآن في الصفحة الأولى",
        "待揭晓": "لم ينتهى بعد",
        "快来和我一起赢大奖吧": "جوائز كثيرة في انتظارك! انضم الآن",
        "总投注额10%": "إجمالي قيمة التخمين 10%",
        "总投注额15%": "إجمالي قيمة التخمين 15%",
        "总投注额20%": "إجمالي قيمة التخمين 20%",
        "总投注额25%": "إجمالي قيمة التخمين 25%",
        "总投注额3%": "3% من إجمالى التخمين ",
        "总投注额30%": "إجمالي قيمة التخمين 30%",
        "总投注额5%": "إجمالي قيمة التخمين 5%",
        "总投注额8%": "إجمالي قيمة التخمين 8%",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "تهانينا ل <%=name%> على نجاحة في دعوة اصدقائه وحصوله على <%=count%> من GTO كجائزة له!",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "تهانينا ل <%=name%> لحصوله على <span> عدد <%=count%> من <%=type%> كجائزة له </span>",
        "您已绑定的邀请码": "كود الدعوة الذي قُمت بربطه ",
        "您最多还能投<%=max%><%=unit%>": "يُمكنك التخمين حتى تصل إلى <%=max%> من <%=unit%>",
        "您的<%=type%>不足": "<%=type%> الخاص بك غير كافٍ",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "عند نجاح ربط كود الدعوة <p> سيتم الحصول على <span class='green bold'%> عدد <%=count%> من جوائز GTO كجائزة لك</span> </p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "تم بنجاح ربط كود الدعوة والحصول على <%=count%> من جوائز GTO على الفور",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "عند دعوة الأصدقاء بنجاح ستحصل على <%=count%> من جوائز GTO ",
        "我已成功邀请<%=count%>个好友": "قُمت بدعوة <%=count%> صديق حتى الآن",
        "我的投注量：": "قيمة التخمين الخاصة بي:",
        "我的收益": "أرباحي",
        "我的订单": "الطلب الخاص بي",
        "我的贡献": "انجازاتي",
        "我的邀请码": "كود الدعوة الخاص بي",
        "我邀请的好友": "الأصدقاء الذين تمت دعوتهم",
        "截止": "موعد توقف التخمينات",
        "投注越多 奖励越丰厚": "كلما زاد عدد مرات تخمينك، كلما زادت الجوائز التي ستحصل عليها",
        "抱歉,没有更多数据啦~": "عذرًا، لا يوجد المزيد من البيانات~",
        "排行榜": "قائمة الترتيب",
        "提交": "متابعة",
        "提示：即使活动结束，此奖励政策依然有效。": "تنبيه: حتى وعند انتهاء المُسابقة، ستظل الجوائز سارية المفعول!",
        "支持GTO、ETH、U钻": "يدعم GTO و ETH و الماس",
        "收益": "الأرباح",
        "收益明细": "تفاصيل الأرباح",
        "收起": "الحصول عليه",
        "时间": "الوقت",
        "星期一": "الإثنين",
        "星期三": "الأربعاء",
        "星期二": "الثلاثاء",
        "星期五": "الجمعة",
        "星期六": "السبت",
        "星期四": "الخميس",
        "星期日": "الأحد",
        "暂无满足奖励条件的用户": "لا يوجد مستخدمون يستوفون معايير الجوائز في الوقت الحالي",
        "暂无记录": "لا يوجد سجل مؤقتًا",
        "暂无赛事": "لا يوجد مُباراة مؤقتًا",
        "更新中": "جارِ التحديث",
        "最多选择8场比赛": "اختيار 8 مباريات على الأكثر",
        "最新中奖名单": "أحدث قائمة للفائزين",
        "服务器链接中断!": "توقف رابط السيرفر!",
        "未中奖": "لم تفُز",
        "未使用": "لم يتم الاستخدام",
        "松开更新": "اتركه للتحديث",
        "查看你的竞猜记录": "عرض سجل التخمينات الخاص بك",
        "查看全部": "عرض الكل",
        "查看我邀请的好友": "عرض أصدقائي المدعوين",
        "查看明细": "عرض التفاصيل",
        "查看竞猜玩法规则": "عرض قواعد طريقة التخمين",
        "查看竞猜记录": "عرض سجل التخمينات",
        "正在加载": "جارِ التحميل",
        "此邀请码绑定人数已达上限": "لقد وصل عدد ربط أكواد الدعوة للحد الأقصى ",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "لكل مستخدم صفحة دعوة، عند مُشاركة صفحة الدعوة مع الآخرين ، وإذا قام مستخدمون جدد بالتسجيل خلال 24 ساعة باستخدام كود الدعوة الخاص بك ، فسوف تحصل على جوائز GTO !",
        "比赛已停止竞猜": "توقف تخمين المُباراة",
        "比赛已取消": "تم إلغاء المُباراة",
        "比赛结果:": "نتيجة المُباراة:",
        "没有权限，如有疑问请联系客服！": "غيرمسموح، من فضلك تواصل مع خدمة العملاء إذا كان لديك أي مشكلة أو استفسار !",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "جميع جوائز GTO يتم استخدمها خلال عملية التخمين، ولا يُمكن تحويلها أو استبدالها. وبعد الفوز تتحول تلقائيًا إلى GTO عادية.",
        "活动时间：": "مدة النشاط:",
        "消耗": "تستهلك",
        "清空": "الرجوع فى الاختيار",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "قُم بتسجيل الدخول واربط كود الدعوة وفو بالجوائز! ",
        "点击复制": "انقر للنسخ",
        "热门直播": "البث الأكثر مشاهدة",
        "特别提醒：": "تنبيه هام:",
        "猜中最大可获得": "الحد الأقصى المُتوقع الحصول عليه ",
        "猜中获得": "خمن للحصول على",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "الجوائز التي تم الحصول عليها من خلال التخمين=  قيمة التخمين× احتمالات الفوز",
        "猜中记录": "سجل التخمين",
        "玩法": "طريقة اللعب",
        "玩法规则": "قواعد اللعب",
        "用户名": "اسم المستخدم",
        "用户网络不稳定": "شبكة الانترنت غير مُستقرة",
        "登出": "تسجيل الخروج",
        "登录": "تسجيل الدخول",
        "登录后才能执行此操作": "قُم بتسجيل الدخول للقيام بذلك",
        "知道了": "أعلم ذلك",
        "确定": "تأكيد",
        "禁止绑定自己邀请码": "لا يُمكنك ربط كود الدعوة الخاص بك",
        "立即参与": "متابعة الآن",
        "立即参与竞猜": "اسرع وشارك في التخمين الآن !",
        "立即邀请好友，赢大奖": "قُم بدعوة أصدقائك الآن وفز بجوائز قيمة!",
        "竞猜下单赠送": "جائزة تخمين صديقك للمُباراة",
        "竞猜中奖赠送": "جائزة فوز تخمين صديقك للمُباراة",
        "竞猜介绍": "مُقدمة عن التخمين",
        "竞猜内容": "مُحتوى التخمين",
        "竞猜排行榜": "قائمة متصدرى التخمينات",
        "竞猜方式": "طريقة التخمين",
        "竞猜时间": "موعد التخمين",
        "第<%=count%>次奖励": "جائزة المرة <%=count%>",
        "筛选": "اختيار",
        "类型": "الأنواع",
        "绑定成功立即获得<%=count%>GTO": "تم الربط بنجاح اذهب للحصول على <%=count%> من جوائز GTO",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": " لقد تم الربط بنجاح، وستحصل حالا على <%=count%> من GTO كجائزة لك، إن كل مستخدم لديه كود دعوة خاص به، فأسرع واسأل أصدقاءك على كود الدعوة الخاص بهم.",
        "绑定邀请码": "ربط كود الدعوة",
        "绑定邀请码成功!": "تم ربط كود الدعوة بنجاح!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "يمكن استخدام جوائز GTO لتوقع مباريات كرة القدم  فقط ولا يمكن تحويلها أو سحبها!",
        "继续参与": "الاستمرار في المشاركة",
        "继续游戏": "استمرار اللعب",
        "网络有点问题哦": "يوجد مشكلة في شبكة الإنترنت!",
        "网络连接异常": "الاتصال بالشبكة غير مستقر",
        "联系我们": "التواصل معنا",
        "胜": "الفوز",
        "胜平负": "تخمين فوز أو تعادل أو خسارة الفريق المضيف",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "خلال 6 أشهر بعد نجاح دعوة الأصدقاء، سيقوم النظام بارسال الجوائز إلى الشخص الذي قام بالدعوة في كل مرة يفوز فيها التخمين الخاص بالشخص الذي تمت دعوته .\nالقواعد كالآتي:\nتكون الجائزة هي نسبة  3% من الفرق بين (قيمة النجاح وقيمة التخمين ) من الربح الأساسي للشخص الذي تمت دعوته، وهذه النسبة لا تؤثر على الربح الأساسي للشخص الذي تم دعوته",
        "获得": "الحصول عليه",
        "获得<%=count%>个<%=currency%>": "حصلت على <%=count%> من <%=currency%>",
        "被邀请人奖励：": "جوائز الذي تمت دعوته:",
        "设备标识为空": "رمز تعريف الجهاز فارغ",
        "话题竞猜": "موضوع التخمين",
        "该浏览器不支持自动复制": "لا يدعم هذا المتصفح النسخ التلقائي",
        "详情": "التفاصيل",
        "请您至少选择一场比赛": "يُرجى تحديد مُباراة واحدة على الأقل",
        "请输入正确页码": "من فضلك أدخل رقم الصفحة الصحيح",
        "请输入邀请码": "يرجى إدخال كود الدعوة",
        "请选择最小筹码": "يرجى اختيار أقل قيمة للتخمين",
        "负": "الخسارة",
        "贡献用户": "انجازات المُستخدم",
        "赛事竞猜": "تخمين المُباراة",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "نتيجة المُباراة هي فقط النتيجة الخاصة بالمباراة لمُدة 90 دقيقة (بما في ذلك وقت إصابات اللاعبين فقط ، وغير متضمنه ركلات الجزاء والوقت المحتسب بدل من الضائع)\n",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "نتيجة المُباراة هي فقط النتيجة الخاصة بالمباراة لمُدة 90 دقيقة (بما في ذلك وقت إصابات اللاعبين فقط ، وغير متضمنه ركلات الجزاء والوقت المحتسب بدل من الضائع)",
        "赢<%=count%>倍": "الفوز <%=count%> مرة",
        "足球竞猜": "توقع مباريات كرة القدم ",
        "跳转": "الانتقال إلى",
        "输入内容不能为空": "لا يُمكن ترك هذا المكان فارغًا",
        "输入的邀请码为空": " كود الدعوة الذي تم إدخاله فارغ",
        "返还": "عودة",
        "选好了": "تم الاختيار بنجاح",
        "选择国家或地区": "اختر الدولة أو المنطقة",
        "选择登录方式": "من فضلك اختر طريقة تسجيل الدخول",
        "选择语言": "اختيار اللغة",
        "邀请人奖励：": "جائزة دعوة الأصدقاء:",
        "邀请好友": "دعوة الأصدقاء",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "عند نجاح أصدقائك فى ربط كود الدعوة، يُمكنك الحصول على<span class='green bold'%> عدد <%=count%> من جوائز GTO كجائزة لك</span> </p>",
        "邀请好友赢大奖": "اضغط هنا لدعوة أصدقائك والفوز بجوائز GTO",
        "邀请码不存在": "كود الدعوة غير موجود",
        "重新加载": "التحديث مرة أُخرى",
        "页": "صفحة",
        "首页": "الصفحة الرئيسية",
        "马上去参与": "المُشاركة الآن",
        "马上去竞猜": "الذهاب إلى توقع مباريات كرة القدم  حالًا",
        "马上开始竞猜": "بدء التخمين الآن"
    },
    "enus": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. For each friend invited, win up to <%=gto%> GTO",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. Prediction topics include match outcomes, individual player performance,  and much more.  @@@@ 2. Match prediction results are based on the full regulation 90 minutes of match play and injury time; it does not include overtime and penalty shootout. @@@@3. If the match results are difficult to determine due to abstentions, replays, game changes or other special reasons, match predictions will be cancelled and all virtual currency will be returned to the user. @@@@4. The odds on the page are for reference only, actual odds are subject to order details. ",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. Each time an invitee makes a correct prediction, the inviter will be issued a reward",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "Place predictions on up to <%=count%> matches",
        "<%=count%>次奖励发放如下：": "<%=count%> rewards issued as follows: ",
        "<%=count%>竞猜记录": "<%=count%> prediction records",
        "<%=name%>暂时没有贡献": "<%=name%> did not contribute anything",
        "<%=name%>的邀请码": "<%=name%>'s invitation code",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> contributed <span><%=gto%> GTO</span><span><%=eth%> ETH</span><span><%=uz%> uDiamond</span>.",
        "<em><%=name%></em>的房间": "<em><%=name%>'s</em> room",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Buy GTO on an exchange, </p><p>transfer to your GIFTO wallet address. </p><p>View wallet address now? </p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Transfer ETH to your GIFTO wallet address. </p><p>View wallet address now? </p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@Soccer predicting is built on top of Uplive's Livestreaming Platform. Users can easily win cryptocurrency by accurately predicting soccer match outcomes. @@@@1. You can choose from 3 predictions per match, win, tie, lose, every choice has different odds. @@@@2. The size of the multiplier is inversely proportional to the strength of the team. The stronger the team, the smaller the multiplier. You can make your own judgement on who has the better chance of winning. @@@@3. Preditctions require investing a certain amount of cryptocurrency, the platform supports Udiamond, GTO and ETH. @@@@4. After you have placed orders, you can either choose from more matches or check the details of your order. @@@@5. If the match outcome is the same as your prediction, then congrats, you will win corresponding rewards! Make predictions now to win! ",
        "GTO投注量": "GTO bet amount",
        "U钻": "uDiamond",
        "U钻投注量": "U diamond bet amount",
        "U钻投注量奖励": "U diamond bet amount reward",
        "上一页": "Last Page",
        "下一页": "Next Page",
        "下拉更新": "Pull to refresh",
        "下载": "Download",
        "不中返本金": "Principal returned no matter the outcome",
        "不中返还": "Principal can be returned if not winning",
        "不再提示": "Do not remind again ",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "World Cup Rewards Don't Stop!  <br> Guess Match Results, and Win Big Rewards",
        "两个用户不能相互绑定邀请码,请重新填写": "You cannot be referred by a friend you already referred, please enter another one!",
        "中奖计算": "Calculate winnings",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "In order to give back to the new and old users of the soccer prediction platform, the accumulated bet GTO reaches a certain amount during the event (the bet amount does not include the rewards for inviting friends, the reward from the red packets, and the extra reward for the invited friends to win the prize in the soccer prediction). You will receive the corresponding GTO reward, As the more you bet, the more reward you will get. Event rewards will be issued within 7 working days after the event ends.",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "To express our gratefulness to the new and old users of the Soccer prediction platform, during the event, the accumulated bet U diamond reaches a certain amount (The amount of bet does not include the bonus that was awarded after the invited friends won the prize.), the corresponding U diamond reward will be obtained, the more the bet, the more reward . Event rewards will be issued within 7 working days after the event ends.",
        "主胜": "Home team wins ",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "Dear <%=username%>, congrats on placing your soccer prediction order, you won <%=count%> <%=currency%>",
        "充值": "Recharge",
        "全选": "Select all ",
        "全部": "All orders",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "Total <%=count%> Records, <span class=\"cur-page-box\">Current <%=curPage%>/<%=pages%> Page</span>",
        "关于我们": "About us",
        "分享到Facebook": "Share to facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "switch payment method, options include: <p class='green'>GTO, ETH and uDiamond</p>",
        "切换语言": "Switch language",
        "切换语言版本": "Switch Language ",
        "加载中……": "Loading......",
        "单个玩法竞猜金额超出上限": "Single game prediction fee exceeds the limit ",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "When the number of bonuses in a single game exceeds a certain number, customer service will send prizes manually. Please wait or contact us with questions.",
        "单次最大可投<%=count%><%=unit%>": "Max prediction you can make at a time is <%=count%> <%=unit%>",
        "单次竞猜金额超出上限": "Single prediction fee exceeds the limit",
        "去充值": "Recharge ",
        "去登录": "Login ",
        "参与成功": "Thanks for participating",
        "参与详情": "Participation details ",
        "反选": "Reverse",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "Each time your friend places a prediction,you receive a bonus! ",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "Restricted by local laws and policies, this product will not be used in current area temporarily.",
        "可领取奖励": "Available rewards",
        "可领取奖励：": "Available rewards: ",
        "同一台设备不可多次绑定邀请码": "The same device can't bind the invitation code multiple times.",
        "含获赠的": "Including the given",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "During <%=hostname%> vs <%=guestname%>, the max amount you can predict is <%=max%> <%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "You will be rewarded <%=count%> GTO instantly for using a friend's invite code",
        "复制成功": "Copied successfully",
        "复制邀请地址": "Copy link",
        "大奖派发": "Big earnings distribution",
        "奖励": "Rewarded",
        "奖励规则如下：": "The reward rules are as follows:",
        "好友猜中比赛后，你也可以获得奖励哦~~": "When you friends place predictions, you can win rewards too! ",
        "如何邀请？": "How to invite?",
        "客胜": "Away team wins ",
        "小视频": "Short video",
        "尾页": "End",
        "已中奖": "You won",
        "已使用": "Used",
        "已取消": "Cancelled ",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "Copied your invitation address successfully~<br / >Send to your friends and invite them to play together!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "Any match is no longer accepting predictions.<br/>Please refresh your match choices",
        "已选<%=count%>场比赛": "Selected <%=count%> of matches ",
        "帮助": "Help",
        "平": "tie",
        "平局": "Tie ",
        "开赛": "start time",
        "当前是最后一页": "Currently on the last page",
        "当前是第一页": "Currently on the first page",
        "待揭晓": "Not yet announced ",
        "快来和我一起赢大奖吧": "Great benefits, come and win the reward with me.",
        "总投注额10%": "10 percent of total bet amount",
        "总投注额15%": "15 percent of total bet amount",
        "总投注额20%": "20 percent of total bet amount",
        "总投注额25%": "25 percent of total bet amount",
        "总投注额3%": "Total bet amount 3%",
        "总投注额30%": "30 percent of total bet amount",
        "总投注额5%": "5 percent of total bet amount",
        "总投注额8%": "8 percent of total bet amount",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "<%=name%> invited a friend and won <%=count%> GTO!",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "Congratulations <%=name%>, you won <span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "Bound invitation code",
        "您最多还能投<%=max%><%=unit%>": "You can still predict up to <%=max%> <%=unit%>",
        "您的<%=type%>不足": "Your <%=type%> balance is insufficient ",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "You will be rewarded <span class='green bold'><%=count%> GTO</span> instantly for using a friends Invite code",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "Bind the Invitation successfully, win <%=count%> GTOs! ",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "Refer a friend successfully, win <%=count%> GTOs! ",
        "我已成功邀请<%=count%>个好友": "I successfully invited <%=count%> friends",
        "我的投注量：": "My bet amount: ",
        "我的收益": "My earnings",
        "我的订单": "Order record",
        "我的贡献": "My contribution",
        "我的邀请码": "My invitation code",
        "我邀请的好友": "My referrals",
        "截止": "end of sale",
        "投注越多 奖励越丰厚": "Bet more Earn more",
        "抱歉,没有更多数据啦~": "Sorry, no more data~",
        "排行榜": "Leaderboard",
        "提交": "Submit",
        "提示：即使活动结束，此奖励政策依然有效。": "Notice: Even if this event ends, the reward policy is still valid. ",
        "支持GTO、ETH、U钻": "Supports GTO, ETH and Udiamond",
        "收益": "Earnings",
        "收益明细": "Earnings details ",
        "收起": "Collapse",
        "时间": "Time",
        "星期一": "Monday",
        "星期三": "Wednesday",
        "星期二": "Tuesday",
        "星期五": "Friday",
        "星期六": "Saturday",
        "星期四": "Thursday",
        "星期日": "Sunday",
        "暂无满足奖励条件的用户": "No users who meet the reward criteria",
        "暂无记录": "No record",
        "暂无赛事": "Currently no matches ",
        "更新中": "Refreshing",
        "最多选择8场比赛": "You can choose a maximum of 8 matches",
        "最新中奖名单": "Latest list of winners ",
        "服务器链接中断!": "Connection is broken!",
        "未中奖": "You lost",
        "未使用": "Unused",
        "松开更新": "Release to refresh",
        "查看你的竞猜记录": "Check your prediction record",
        "查看全部": "Check all",
        "查看我邀请的好友": "Check my referals ",
        "查看明细": "Check details",
        "查看竞猜玩法规则": "Check prediction game rules ",
        "查看竞猜记录": "Check prediction record",
        "正在加载": "Loading",
        "此邀请码绑定人数已达上限": "The number of the invitation code be bound reached the maximum number.",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "Each user has an invite page, share the invite page with others, and if new users register within 24 hours using your invite code, you will receive Gifto! ",
        "比赛已停止竞猜": "Match Prediction submissions have already closed",
        "比赛已取消": "Match cancelled",
        "比赛结果:": "Match result:",
        "没有权限，如有疑问请联系客服！": "No authorization, please contact customer service if you have any questions!",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "All GTOs rewarded through the referral program may only be used to place predictions on matches, you may not directly exchange or redeem them. After prediction results are realized, the GTOs can be withdrawn.",
        "活动时间：": "Event time:",
        "消耗": "Spent ",
        "清空": "Clear",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "The hot soccer prediction platform, register and bind my invitation code to win rewards!",
        "点击复制": "Copy code",
        "热门直播": "Hot Broadcasts",
        "特别提醒：": "Special reminder: ",
        "猜中最大可获得": "Highest reward",
        "猜中获得": "Win",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "Prediction winnings= total amout of principal placed  * odds of winning  ",
        "猜中记录": "Wins",
        "玩法": "Prediction type",
        "玩法规则": "Rules of play",
        "用户名": "Username",
        "用户网络不稳定": "Unstable network connection",
        "登出": "Logout ",
        "登录": "Login",
        "登录后才能执行此操作": "Please login first! ",
        "知道了": "I understand",
        "确定": "Confirm",
        "禁止绑定自己邀请码": "Cannot use your own invitation code",
        "立即参与": "Submit now",
        "立即参与竞猜": "Join the prediction now",
        "立即邀请好友，赢大奖": "Invite friends, win prizes! ",
        "竞猜下单赠送": "Reward from your friend making predictions ",
        "竞猜中奖赠送": "Reward from your friend's accurate prediction",
        "竞猜介绍": "Prediction introduction",
        "竞猜内容": "Prediction details",
        "竞猜排行榜": "Prediction leaderboard",
        "竞猜方式": "Ways to predict",
        "竞猜时间": "Time of submission ",
        "第<%=count%>次奖励": "<%=count%> reward",
        "筛选": "Filter",
        "类型": "Details",
        "绑定成功立即获得<%=count%>GTO": "Receive <%=count%> GTO for successfully referring ",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "Receive <%=count%> GTO for successfully referring,  and each user has his own invitation code, please ask for the invitation code from your friends.",
        "绑定邀请码": "Bind invitation code",
        "绑定邀请码成功!": "Bound the invitation code successfully! ",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "GTOs rewarded through invite promo can only be used for placing predictions, direct transfers and withdrawals are not permitted! ",
        "继续参与": "Continue predicting",
        "继续游戏": "Continue playing",
        "网络有点问题哦": "Network error",
        "网络连接异常": "Unstable network connection",
        "联系我们": "Contact us",
        "胜": "win",
        "胜平负": "Predict the winning, draw, or failure of the home team",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "For each time the invitee makes an accurate prediction, the inviter will receive 3% of the invitee's earnings. These bonus rewards will be issued by the platform and do not affect the invitee's total winnings. (Bonus applies for the first 6 months of play) ",
        "获得": "Win",
        "获得<%=count%>个<%=currency%>": "Win <%=count%> <%=currency%>",
        "被邀请人奖励：": "invitee rewards: ",
        "设备标识为空": "Device ID is blank",
        "话题竞猜": "Prediction topics",
        "该浏览器不支持自动复制": "The browser does not support auto copy ",
        "详情": "Details",
        "请您至少选择一场比赛": "Please select at least one match",
        "请输入正确页码": "Please enter the right page number",
        "请输入邀请码": "Please enter the code",
        "请选择最小筹码": "Please choose the smallest chips",
        "负": "lose",
        "贡献用户": "Contributor",
        "赛事竞猜": "Match predictions",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "Match prediction results are based on the full regulation 90 minutes of match play and injury time; it does not include overtime and penalty shootout",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "Match results are based on 90 minutes of regulation  play",
        "赢<%=count%>倍": "Win <%=count%> times",
        "足球竞猜": "Soccer Predicting",
        "跳转": "Jump to",
        "输入内容不能为空": "The input text cannot be empty",
        "输入的邀请码为空": "Invite code is blank",
        "返还": "Return",
        "选好了": "Done",
        "选择国家或地区": "Please select your country or region",
        "选择登录方式": "Choose login method",
        "选择语言": "Choose language",
        "邀请人奖励：": "Inviter Reward: ",
        "邀请好友": "Invite friends",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "Use this referral code to invite friends and win <span class='green bold'><%=count%> GTO</span> ",
        "邀请好友赢大奖": "Invite friends and win big prize",
        "邀请码不存在": "Invitation code incorrect",
        "重新加载": "Reload",
        "页": "Page",
        "首页": "Homepage",
        "马上去参与": "Join now! ",
        "马上去竞猜": "Start predicting now",
        "马上开始竞猜": "Start predicting now"
    },
    "eses": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. Recompensa por cada invitación exitosa <%=gto%>GTO，Dividir en <%=count%> veces para enviar",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. La tema del juego se creado el operator depende de la populación del juego @@@@ 2. El tiempo del juego totalmente hay 90 minutos.(Incluido la lesión, detención y tiempo adicional. No incluido horas extras y penales ) @@@@3. va a cancelar el juego, Si los resultados del partido son difíciles de determinar debido a abstenciones, repeticiones, cambios en el juego u otras razones especiales, pero te regresa el dinero que habías pagado. @@@@4.Las probabilidades en la página son solo de referencia, las probabilidades reales están sujetas a los detalles de la orden.",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. Cada vez que un invitado toca la loterá, ingresa la comprensa al invitador",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "<%=count%>juegos puedes jugar",
        "<%=count%>次奖励发放如下：": "veces de recompensas:",
        "<%=count%>竞猜记录": "<%=count%> historías del juego",
        "<%=name%>暂时没有贡献": "<%=name%> No contribución todavía",
        "<%=name%>的邀请码": "codigo del invitación",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> contribuido <span><%=gto%> GTO</span><span><%=eth%> ETH</span><span><%=uz%> U-Diamante</span>.",
        "<em><%=name%></em>的房间": "<em><%=name%>'s</em> Habitación",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Compra GTO en el intercambio, </p><p>hace transferencia a tus GIFTO wallet. </p><p>ver la dirección del wallet </p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Hace transferencia desde ETH a GIFTO wallet. </p><p>ver la dirección del wallet</p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@Lotería del futbol es un juego de la plataforma del Uplive, los usuarios puedes jugarla y ganará dinero virtual facilmente. @@@@1，Normalmente hay 3 selecciones para cada partido, equipo local ganará,empate,equipo fuera ganará, cada elegido con diferentes recompensas.@@@@2，El tamaño del multiplicador es inversamente proporcional a la fuerza del equipo. Cuanto más fuerte sea el equipo, será menor el multiplicador. Puede hacer su propio juicio sobre quién tiene más posibilidades de ganar.@@@@3，para jugar la lotería tienes que pagar con dinero virtual,la plataforma admite U-diamante / GTO / ETH。@@@@4，despúes de la compra,puedes continua a jugar o ver mas detalles del comprados.@@@@5，si hubieses tocado la lotería, vas a tener el permiso. @@@@vas a jugar ahora y tacate el premio.",
        "GTO投注量": "Candidad de la apuesta GTO",
        "U钻": "U-Diamante",
        "U钻投注量": "La cantidad del apuesta Udianmantes",
        "U钻投注量奖励": "Las recompensas de la apuesta",
        "上一页": "Página anterior",
        "下一页": "Página siguiente",
        "下拉更新": "Tire para actualizar",
        "下载": "Descargar",
        "不中返本金": "Si no hubiese tocado, regresamos el ingreso",
        "不中返还": "Si no hubiese tocado, regresamos el ingreso",
        "不再提示": "No solicita nueva",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "El premio de la Copa del mundo no se detienen! Adivine los resultados del partido y gane grandes premio",
        "两个用户不能相互绑定邀请码,请重新填写": "Dos usuarios no pueden enlazar el código de invitación entre sí. Vuelva a ingresar.",
        "中奖计算": "Calcular ganancias",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Recompensas: si apuesta una cantidad del GTO (la apuesta no incluido los regalos por la invitacion, recompensas por sobre rojo ni por recompensas de su amigo tacado), Le da recopensas, apuesta más, más reconpensas. ingresa su recompensas depues de 7 días del evento",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Las Recompensas de la apuesta: Si va a apostar un cantidad Udiamante (La cantidad que apuesta no incluido recompensas había tenido por invita a sus amigos a apostar en app.) Obtenga un porcentaje del Udiamante, Apuesta más, más recompensas. Las recompensas ingresará a su cuenta Udiamante despúes del 7 días del evento apuesta.",
        "主胜": "Equipo local ganó ",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "Estimado <%=username%>, Felicidades por has tocado la lotería, has ganado <%=count%> <%=currency%>",
        "充值": "Recargar",
        "全选": "marca todo",
        "全部": "Total",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "Total <%=count%> Registros, <span class = \"cur-page-box\"> Actual <%=curPage%> / <%=pages%> Página </ span>",
        "关于我们": "Sobre nosotros",
        "分享到Facebook": "Compartir a Facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "Cambia el metodo de pago, elegir entre: <p class='green'>GTO, ETH and uDiamond</p>",
        "切换语言": "Cambia idioma",
        "切换语言版本": "Cambia la idioma",
        "加载中……": "Cargando......",
        "单个玩法竞猜金额超出上限": "Llegado el limitado de la cantidad por cada juego",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "Cuándo la cantidad del premio del cada juego llegará la maximo, las compensas tiene que enviarte manualmente, por tanto, espera un rato o contactate con la atención del servicio.",
        "单次最大可投<%=count%><%=unit%>": "La cantidad máxima que puede apostar a la vez es  <%=count%> <%=unit%>",
        "单次竞猜金额超出上限": "Llegado el limitado de la cantidad por cada vez",
        "去充值": "Regargar",
        "去登录": "Inicio sesión",
        "参与成功": "Gracias por participación",
        "参与详情": "Detalles de participación",
        "反选": "Marca atrás",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "Condiciones para obtener la recompensas: el usuario invitado ponga cada apuesta,\n\nPuede obtener una recompensa",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "Debido a las leyes y políticas locales, este producto no está disponible temporalmente en la zona.",
        "可领取奖励": "Obtenga las recompensas",
        "可领取奖励：": "Obtenga las recompensas: ",
        "同一台设备不可多次绑定邀请码": "No puede usar la reutilización de un código de invitación desde el mismo dispositivo",
        "含获赠的": "incluido las recompensas",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "Durante <%=hostname%> vs <%=guestname%>, la cantidad máxima que puede apostar es <%=max%> <%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "Despúes de vinculado el código de invitación,Obtenga recompensa de <%=count%> GTO",
        "复制成功": "copiado con éxito",
        "复制邀请地址": "Copiar el link",
        "大奖派发": "Distribuido del premio",
        "奖励": "Recompensas",
        "奖励规则如下：": "Reglas del recompensas",
        "好友猜中比赛后，你也可以获得奖励哦~~": "cuándo tus amigos ganará, tu podría obtener la recompensa!  ",
        "如何邀请？": "El Método de invitación",
        "客胜": "Equipo de fuera ganó ",
        "小视频": "Videos cortos",
        "尾页": "Última página",
        "已中奖": "Había tacado",
        "已使用": "usado",
        "已取消": "Cancelado",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "Había copiado correcto la dirrección del invitación~<br / >enviala y jugate con tus amigos",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "Había partido terminado jugar<br/>por favor,elegir otros",
        "已选<%=count%>场比赛": "Elegido <%=count%> partidos",
        "帮助": "Ayuda",
        "平": "Empate",
        "平局": "Empate ",
        "开赛": "Comience a jugar",
        "当前是最后一页": "Actualmente en la última página",
        "当前是第一页": "Actualmente en la primera página",
        "待揭晓": "Será anunciado",
        "快来和我一起赢大奖吧": "Grandes beneficios, venga y gane la recompensa ETH conmigo.",
        "总投注额10%": "Apuesta total 10%",
        "总投注额15%": "Apuesta total 15%",
        "总投注额20%": "Apuesta total 20%",
        "总投注额25%": "Apuesta total 25%",
        "总投注额3%": "Apuesta total 3%",
        "总投注额30%": "Apuesta total 30%",
        "总投注额5%": "Apuesta total 5%",
        "总投注额8%": "Apuesta total 8%",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "Enhorabuena <%=name%> amigo invitado con éxito y obtener<%=count%> GTO",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "Enhorabuena <%=name%> por obtener <span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "códigos de invitación había usado",
        "您最多还能投<%=max%><%=unit%>": "Todavía puede apostar hasta <%=max%> <%=unit%>",
        "您的<%=type%>不足": "Tus <%=type%> balance es insuficiente",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "Enlace el codigo de invitacion correcto, <p>obtine<span class='green bold'><%=count%> GTO</span> para recompensas</p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "Por enlace codigo de invitación con éxito, obtenga <%=count%> GTOs",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "Por amigo invitados con éxitos,Obtenga  <%=count%> GTO",
        "我已成功邀请<%=count%>个好友": "Lo invité exitosamente <%=count%> amigos",
        "我的投注量：": "Mi candidad del apuesta: ",
        "我的收益": "ingresos mios",
        "我的订单": "Mi pedido",
        "我的贡献": "Mi contribución",
        "我的邀请码": "el codigo del invitación",
        "我邀请的好友": "Mis amigos invitados",
        "截止": "Fin del",
        "投注越多 奖励越丰厚": "Apuesta más, más recompensas",
        "抱歉,没有更多数据啦~": "Lo siento,no hay más datos",
        "排行榜": "Top de la apuesta",
        "提交": "Enviar",
        "提示：即使活动结束，此奖励政策依然有效。": "Noticia: incluso si este evento finaliza, la política de recompensa sigue siendo válida.",
        "支持GTO、ETH、U钻": "Admite U-diamante / GTO / ETH。",
        "收益": "Ingresos",
        "收益明细": "Detalles del ingresos",
        "收起": "Ocultar",
        "时间": "Tiempo",
        "星期一": "Lunes",
        "星期三": "Miércoles ",
        "星期二": "Martes",
        "星期五": "Viernes ",
        "星期六": "Sábado ",
        "星期四": "Jueves",
        "星期日": "Domingo",
        "暂无满足奖励条件的用户": "No hay ningún usuario llega el requisito de recompensa",
        "暂无记录": "No hay historia",
        "暂无赛事": "No hay partido todavía",
        "更新中": "Actualizando",
        "最多选择8场比赛": "Puedes elegir 8 juegos maximos",
        "最新中奖名单": "Ultima lista de ganador",
        "服务器链接中断!": "La conexión Inutilizable",
        "未中奖": "No esta tocado",
        "未使用": "No usado",
        "松开更新": "Suéltelo para actualizar",
        "查看你的竞猜记录": "Historia del juego",
        "查看全部": "Todos",
        "查看我邀请的好友": "Amigos invitados",
        "查看明细": "Detalles",
        "查看竞猜玩法规则": "Las reglas del juego",
        "查看竞猜记录": "Historía del juego",
        "正在加载": "Cargando",
        "此邀请码绑定人数已达上限": "Ya llegado el limite del vinculado del codigo del invitación",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "Cada usuario de la plataforma tiene una página de invitación dedicada (incluido un código de invitación) y reenvía la página de invitación a otras personas. El nuevo usuario tiene que vincular correctamente el código de invitación dentro de las 24 horas posteriores al registro, es decir, la invitación se realiza correctamente.",
        "比赛已停止竞猜": "Partido terminó",
        "比赛已取消": "El partido había cancelado",
        "比赛结果:": "Resultado del juego",
        "没有权限，如有疑问请联系客服！": "Sin Autolización, Dudas con el servicio de atención al cliente .",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "Todos recompensas ganado solo puede jugar la lotería en la plataforma, no puede hacer transferencia y retiros.",
        "活动时间：": "Horarios de el evento",
        "消耗": "Consumido",
        "清空": "Vaciar",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "La famosa plataforma del lotería del fotbol, incluido Copa Mudial,Registrarte y vincula la código del invitación a ganará le compresas!",
        "点击复制": "click por copia",
        "热门直播": "Transmisión popular",
        "特别提醒：": "Noticia especial",
        "猜中最大可获得": "Recompensas máximo por ganar",
        "猜中获得": "Ganaste",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "La cantidad del premio=la cantidad pagado* veces del ganado",
        "猜中记录": "La historía del premio",
        "玩法": "El metodo del juego",
        "玩法规则": "Las reglas del juego",
        "用户名": "Usuario",
        "用户网络不稳定": "La red de usuario es inestable",
        "登出": "Cerrar sesión",
        "登录": "Iniciar sesión",
        "登录后才能执行此操作": "Inicio sesión primero",
        "知道了": "Entiendo",
        "确定": "Confirmado",
        "禁止绑定自己邀请码": "No enlace su propio código de invitación",
        "立即参与": "jugar ahora",
        "立即参与竞猜": "Apuesta Ahora",
        "立即邀请好友，赢大奖": "Invita amigos ahora y saca premios grandes",
        "竞猜下单赠送": "Regalos por había jugado",
        "竞猜中奖赠送": "Regalos por ganaste",
        "竞猜介绍": "La introducción del juego",
        "竞猜内容": "Detalles del juego",
        "竞猜排行榜": "Top de la apuesta",
        "竞猜方式": "El metodo del juego",
        "竞猜时间": "El tiempo del juego",
        "第<%=count%>次奖励": "<%=count%> recompensas",
        "筛选": "Filtro",
        "类型": "Tipo",
        "绑定成功立即获得<%=count%>GTO": "Enlazar con éxito y obtener de inmediato",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "Vincular con éxito e inmediatamente obtener <%=count%>GTO，Cada usuario tiene un código de invitación único, ve y pide un código de invitación de amigo",
        "绑定邀请码": "Enlace el código de invitación",
        "绑定邀请码成功!": "Enlace el código de invitación con éxito",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "¡Estos GTO obtenidos por codigo de invitacion solo se pueden usar para  jugar la lotería del futbol, no puede hacer transferencias y retiros!",
        "继续参与": "Continua a juagar",
        "继续游戏": "Continua a jugar",
        "网络有点问题哦": "Error de red",
        "网络连接异常": "Conexión de red inestable",
        "联系我们": "Conunicate con nosotros",
        "胜": "Ganó",
        "胜平负": "Predecir el ganador, empate o perdido del equipo local",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "Por cada vez que el invitado hace una predicción precisa dentro de los primeros 6 meses de ser referido, el invitador recibirá el 3% de los inviernos totales del invitado. Esta ganancia adicional será emitida por la plataforma y no afecta las ganancias del invitado.",
        "获得": "Ganó",
        "获得<%=count%>个<%=currency%>": "Ganó <%=count%> <%=currency%>",
        "被邀请人奖励：": "Recompensas para invitado",
        "设备标识为空": "La identificación del dispositivo está en blanco",
        "话题竞猜": "La tema del juego",
        "该浏览器不支持自动复制": "Este navegador no admite la copia automática",
        "详情": "Detalles",
        "请您至少选择一场比赛": "Elegir uno partido minimo, por favor",
        "请输入正确页码": "Por favor ingrese el número de la página correcta",
        "请输入邀请码": "Por favor ingrese el código de invitación",
        "请选择最小筹码": "Por favor, elija las fichas más pequeñas",
        "负": "perdido",
        "贡献用户": "Contribuidor",
        "赛事竞猜": "lotería de futbol",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "El tiempo del juego totalmente hay 90 minutos.(Incluido la lesión, detención y tiempo adicional. No incluido horas extras y penales ) ",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "El Juego hay 90 minutos totalmente(Incluido la lesión, detención y tiempo adicional. No incluido horas extras y penales )",
        "赢<%=count%>倍": "gana <%=count%> veces",
        "足球竞猜": "lotería de futbol",
        "跳转": "Saltar",
        "输入内容不能为空": "El texto de entrada no puede estar vacío",
        "输入的邀请码为空": "El código de invitación está vacío",
        "返还": "Regreso",
        "选好了": "Hecho",
        "选择国家或地区": "Seleccione su país o región,Por favor ",
        "选择登录方式": "Elija el método del inicio sesión",
        "选择语言": "Elija idioma",
        "邀请人奖励：": "Recompensas para invitador",
        "邀请好友": "Invitar a amigos",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "Invita a tus amigos a usar tus codigo del invitación, puedes obtener <span class='green bold'><%=count%> GTO</span> ",
        "邀请好友赢大奖": "Invitar a amigos a ganar premio",
        "邀请码不存在": "El código de invitación no existe",
        "重新加载": "Recargar",
        "页": "Página",
        "首页": "Página principal",
        "马上去参与": "jugar ahora",
        "马上去竞猜": "voy a juagar",
        "马上开始竞猜": "Comience a jugar"
    },
    "frfr": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. Pour chaque utilisateur invité, vous recevez <%=gto%> GTO, délivré <%=count%> times",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. Les sujets de prédiction sont basés sur le choix des opérateur concernant les matches populaires et les sujets personnel de prédictions. @@@@2.Les résultats des prédictions de matches sont basés sur la réglementation totale des 90 minutes de jeu et du temps additionnel; elle n'inclue pas le temps supplémentaire et les reconnaissances. @@@@3.Si le résultat du match est difficile à déterminer à cause d'abstentions, ralentis, changements ou d'autres raisons spéciales, les prédictions du match seront annulées et toutes les monnaies virtuelles seront rendues aux utilisateurs. @@@@4. les probabilités sur la page sont à usage de référence seulement, les probabilités véritables sont soumises à d'autre détails.",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. Chaque fois qu'un invité fait une prédiction exacte, l'inviteur se verra délivré une récompense",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "Placez vos prédictions sur <%=count%> de matches au plus",
        "<%=count%>次奖励发放如下：": "<%=count%> récompenses délivrées comme suit:",
        "<%=count%>竞猜记录": "<%=count%> records de prédictions",
        "<%=name%>暂时没有贡献": "<%=name%> n'a contribué en rien",
        "<%=name%>的邀请码": "Le code d'invitation de <%=name%>",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> contribué <span><%=gto%> GTO</span><span><%=eth%> ETH</span><span><%=uz%> uDiamond</span>.",
        "<em><%=name%></em>的房间": "Vous êtes chez <em><%=name%></em>",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Achetez GTO dans un échange, </p><p>transférez vers votre adresses porte-feuille GIFTO. </p><p>Voir l'adresse du porte-feuille maintenant? </p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Transférez ETH vers votre adresse porte-feuille GIFTO. </p><p>Voir l'adresse porte-feuille maintenant? </p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@prédiction footballistique est intégrée à la Pateforme Livestreaming d'Uplive. Les utilisateurs peuvent facilement gagner de la crypto-monnaie en réalisant des prédictions exactes de résultats de matches. @@@@1. Vous pouvez choisir entre 3 prédictions par match, victoire, match nul, défaite, chaque choix a différentes probabilités. @@@@2. la valeur du multiplicateur est inversement proportionnelle à la force de l'équipe. Plus l'équipe est forte, moins grand sera le multiplicateur. Vous pourrez juger par vous même qui a les meilleurs chances de remporter la victoire.@@@@ 3.Faire des prédictions requiert d'investir un certain montant de cryto-monnaie, la plateforme supporte les Udimaond, GTO et ETH. @@@@4. Après avoir placé une commande, vous pouvez soit choisir à travers plus de matches ou consulter les details de votre commande.@@@@5.Si le resultat du match et similaire à votre prédiction, alors félicitation, vous gagnerez les récompenses qui correspendent!@@@@ Faîtes des prédictions maintenant pour gagner!",
        "GTO投注量": "la quantité de l'enjeu de GTO",
        "U钻": "uDiamond",
        "U钻投注量": "l'enjeu ",
        "U钻投注量奖励": "Récompense pour les enjeux de Udiamond",
        "上一页": "Page précédente",
        "下一页": "Page suivante",
        "下拉更新": "Tirer pour actualiser",
        "下载": "télécharger",
        "不中返本金": "Principal peut être rendu en cas de perte",
        "不中返还": "Principal peut être rendu en cas de perte",
        "不再提示": "Ne pas rappeller encore une fois",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "Beaucoup de bénéfices avec la Coupe du Monde<br>,venez jouez aux devinettes et gagnez des récompenses simplement",
        "两个用户不能相互绑定邀请码,请重新填写": "Vous ne pouvez être référencié par un ami que vous avec déjà renvoyé, veuillez en saisir un autre!",
        "中奖计算": "Calcule de gains",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Récompense: si vore enjeu de GTO peut atteindre une quantité pendant l'événement ( y'a pas compris la récompense d'invitation, de l'enveloppe rouge, la récompense des amis invités), on va vous donner GTO comme cadeau, le plus d'enjeu, la plus de récompense, ils seront dans votre compte après l'événement pendant 7 journée.",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Pour récompenser tous les joueurs du jeu de devinettes du foot, si vos enjeux peut atteindre une certaine quantité pendant l'activité (à l'excécution des extra récompenses de l'invitation), vous allez recevoir des récompenses relatives des diamonds differents. Plus des enjeux, plus de diamonds. Les récompenses vont être distribuées pendant les 7 jours après l'activité.",
        "主胜": "Equipe locale gagne ",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "Cher/Chère <%=username%>, félicitations, vous avez gagné une récompense <%=count%> <%=currency%>",
        "充值": "Recharge",
        "全选": "Sélectionner tout",
        "全部": "Total",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "Il y a <%=count%> pièces de record<span class=\"cur-page-box\">Maintenant vous êtes à la page <%=curPage%>/<%=pages%></span>",
        "关于我们": "en ce qui nous concernant ",
        "分享到Facebook": "Veuillez partager à Facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "Changer de méthode de paiement, les options disponibles incluent: <p class='green'>GTO, ETH et uDiamond</p>",
        "切换语言": "Changer la langue",
        "切换语言版本": "Changer de langue",
        "加载中……": "Chargement……",
        "单个玩法竞猜金额超出上限": "Frais d'une prédiction de jeu unique dépasse la limite",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "Lorsque le nombre de bonus dépasse un certain nombre dans une seule partie, le service clientèle enverra les prix manuellement. Veuillez patientier s'il vous plait ou contactez nous avec vos questions.",
        "单次最大可投<%=count%><%=unit%>": "L'enjeu pour chaque fois au maximum est <%=count%><%=unit%>",
        "单次竞猜金额超出上限": "frais d'une prédiction unique dépasse la limite",
        "去充值": "Recharger",
        "去登录": "Connexion",
        "参与成功": "Merci d'avoir participé",
        "参与详情": "Les détails de la participation",
        "反选": "Inverser",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "Termes et conditions: chaque fois qu'un invité fait une prédiction, l'inviteur reçoit une récompense!",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "Restreinte par la législation, cette application ne peut pas être utilisée dans cet entroit.",
        "可领取奖励": "la récompense disponible",
        "可领取奖励：": "la récompense disponible: ",
        "同一台设备不可多次绑定邀请码": "Désolé, on peut pas lier plusieurs codes d'invitation sur un téléphone.",
        "含获赠的": "Incluant ce qui a été donné",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "En match de <%=hostname%>vs<%=guestname%>, vous pouvez miser au maximum un enjeu de<%=max%><%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "Vous recevrez <%=count%> récompenses GTO quand vous aurez lié le code d'invitation avec succès.",
        "复制成功": "Copié avec succès",
        "复制邀请地址": "Veuillez copier le link pour inviter",
        "大奖派发": "Distribution de gros gains",
        "奖励": "récompensé",
        "奖励规则如下：": "les règlements de récompense:",
        "好友猜中比赛后，你也可以获得奖励哦~~": "Quand ils font des prédictions, vous receverez des récompenses aussi! ",
        "如何邀请？": "Comment inviter?",
        "客胜": "équipe exterieure gagne ",
        "小视频": "vidéo courte",
        "尾页": "Page dernière",
        "已中奖": "gagnant",
        "已使用": "Utilisé",
        "已取消": "annulé",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "Votre adresse d'invitation a été copié avec succès~<br / >Envoyez à vos amis et invitez les à jouer ensemble!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "Aucun match n'accepte de plus de prédictions.<br/>Veuillez actualiser vos choix de matches.",
        "已选<%=count%>场比赛": "Séléctionner <%=count%> de matches",
        "帮助": "Aide",
        "平": "égalité",
        "平局": "Attache ",
        "开赛": "Commencez le match",
        "当前是最后一页": "Maintenant vous êtes à la dernière page",
        "当前是第一页": "Maintenant vous êtes à la première page",
        "待揭晓": "Sera annoncé",
        "快来和我一起赢大奖吧": "Beaucoup de bénéfices,venez et gagnez des récompenses ETH avec moi.",
        "总投注额10%": "10% de la totalité de l'enjeu",
        "总投注额15%": "15% de la totalité de l'enjeu",
        "总投注额20%": "20% de la totalité de l'enjeu",
        "总投注额25%": "25% de la totalité de l'enjeu",
        "总投注额3%": "3% de l'enjeu total ",
        "总投注额30%": "30% de la totalité de l'enjeu",
        "总投注额5%": "5% de la totalité de l'enjeu",
        "总投注额8%": "8% de la totalité de l'enjeu",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "Félicitation à <%=name%>à inviter son ami avec succès et a eu <%=count%> GTO",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "Félicitation à <%=name%> a eu <span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "lier le code d'invitation",
        "您最多还能投<%=max%><%=unit%>": "Vous pouvez miser au maximum un enjeu de<%=max%><%=unit%> ",
        "您的<%=type%>不足": "Votre <%=type%> de balance est insuffisente",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "Liez correctement le code d'invitation, <p>vous recevrez <span class='green bold'><%=count%> GTO</span> instantly</p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "Nous renvoyer un ami,gagnez <%=count%> GTOs!",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "Si vous nous renvoyez un ami, gagnez <%=count%> GTO!",
        "我已成功邀请<%=count%>个好友": "J'ai invité avec succès <%=count%> amis",
        "我的投注量：": "mon enjeu: ",
        "我的收益": "Mes gains",
        "我的订单": "Ma commande",
        "我的贡献": "Ma contribution",
        "我的邀请码": "Mon code d'invitation",
        "我邀请的好友": "Mes orientations",
        "截止": "Fin des ventes",
        "投注越多 奖励越丰厚": "le plus d'enjeu, le plus de récompense",
        "抱歉,没有更多数据啦~": "Desolé, plus de donnée",
        "排行榜": "le classement ",
        "提交": "Envoyer",
        "提示：即使活动结束，此奖励政策依然有效。": "Notice: même après la fin de cet événement la politique de récompenses et toujours valide.",
        "支持GTO、ETH、U钻": "Supporte GTO, ETH et Udiamond",
        "收益": "Gains",
        "收益明细": "Détails des gains",
        "收起": "S'effondre",
        "时间": "Temps",
        "星期一": "Lundi",
        "星期三": "Mercredi",
        "星期二": "Mardi",
        "星期五": "Vendredi",
        "星期六": "Samedi",
        "星期四": "Jeudi",
        "星期日": "Dimanche",
        "暂无满足奖励条件的用户": "il n'y a pas d'utilisateur qui peut prendre la récompense mnt",
        "暂无记录": "Pas de record",
        "暂无赛事": "Aucun match actuellement",
        "更新中": "Actualisation",
        "最多选择8场比赛": "Vous pouvez choisir 8 matches au maximum",
        "最新中奖名单": "Dernière liste de gagnants",
        "服务器链接中断!": "Connexion est coupée",
        "未中奖": "pas gagnant",
        "未使用": "Non utilisié",
        "松开更新": "Relâcher pour actualiser",
        "查看你的竞猜记录": "Consulter votre archive de prédictions",
        "查看全部": "Consulter tout",
        "查看我邀请的好友": "Consulter mes renvoies",
        "查看明细": "Consulter les details",
        "查看竞猜玩法规则": "Consulter les règles de prédiction de jeu",
        "查看竞猜记录": "Consultez l'archive de prédiction",
        "正在加载": "Chargement",
        "此邀请码绑定人数已达上限": "Ce code d'invitation est lié par trop de monde et le nombre est dépassé la limité",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "Chaque utilisateur a une page d'invitation, partagez la page d'invitation avec les autres, et si un nouvel utilisateur s'inscrit dans les 24 heures en utilisant votre code d'invitation, vous recevrez GIFTO !",
        "比赛已停止竞猜": "La communication de prédictions de matches est déjà close",
        "比赛已取消": "Match annulé",
        "比赛结果:": "Résultat du match:",
        "没有权限，如有疑问请联系客服！": "Vous n'avez pas de autorisation! Contactez le service si vous avez des quations.",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "Toutes les récompenses sous forme de GTO reçus à travers le programme de référencement peuvent seulement servir à placer des prédictions, vous ne pourrez ni les échanger ou vous les faire rembourser. Après avoir gagné, les GTOs se transformeront en GTOs à usage normal.",
        "活动时间：": "l'horaire de cet événement",
        "消耗": "Consommation",
        "清空": "Vide",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "La plateforme tendance de prédictions footballistique, inscrivez-vous et liez mon code d'invitation pour gagner des récompenses!",
        "点击复制": "Copiez le lien",
        "热门直播": "Hot live",
        "特别提醒：": "Rappel special:",
        "猜中最大可获得": "Récompense la plus élevée",
        "猜中获得": "Gagner",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "Gains de prédictions= montant total de placements principaux * probabilités de gagner",
        "猜中记录": "Prédiction exacte",
        "玩法": "Type de jeu",
        "玩法规则": "Règles de jeu",
        "用户名": "utilisateur",
        "用户网络不稳定": "Connexion internet instable",
        "登出": "Déconnexion",
        "登录": "Connexion",
        "登录后才能执行此操作": "Veuillez vous connecter d'abord!",
        "知道了": "Je comprend",
        "确定": "Confirmer",
        "禁止绑定自己邀请码": "Vous ne pouvez pas utiliser votre propre code d'invitation",
        "立即参与": "Soumettre maintenant",
        "立即参与竞猜": "je voudrais participer aux devinettes tout de suite",
        "立即邀请好友，赢大奖": "Invitez des amis, gagnez des prix !",
        "竞猜下单赠送": "Récompenses grâce aux prédictions de vos amis",
        "竞猜中奖赠送": "Récompenses grâce aux prédictions exactes de vos amis",
        "竞猜介绍": "Introduction à la prédiction",
        "竞猜内容": "Détails de prédiction",
        "竞猜排行榜": "le classement des devinettes",
        "竞猜方式": "Manières de prédire",
        "竞猜时间": "Temps de prédiction",
        "第<%=count%>次奖励": "Les <%=count%> récompenses",
        "筛选": "Filtre",
        "类型": "Type",
        "绑定成功立即获得<%=count%>GTO": "Recevez <%=count%> GTO pour avoir référencié avec succès",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "Réussir à lier le code d'invitation vous permettre de gagner <%=count%>GTO. Chacun a son propre code d'invitation, veulliez le demander à votre ami.",
        "绑定邀请码": "Lié le code d'invitation",
        "绑定邀请码成功!": "Liez le code d'invitation avec succès!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "Ces extra GTO ne peuvent être utilisés que pour prédire les matches,Les transferts et les abondons ne sont pas permis.",
        "继续参与": "Continuez à prédire",
        "继续游戏": "Continuez à jouer",
        "网络有点问题哦": "Erreur de connectivité",
        "网络连接异常": "Connexion internet instable",
        "联系我们": "veuillez contacter avec nous",
        "胜": "gagné",
        "胜平负": "Prédire la victoire, le match nul, ou échec de l'équipe locale",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "Chaque fois qu'un invité fait une prédiction exacte durant les 6 premiers mois après avoir été référencié, l'inviteur recevra 3% des gains totaux de l'invité. Ces gains supplémentaires seront délivrés par la plateforme et n'affectent pas les gains de l'invité.",
        "获得": "Gagné",
        "获得<%=count%>个<%=currency%>": "Gagné <%=count%> <%=currency%>",
        "被邀请人奖励：": "Récompenses de l'invité",
        "设备标识为空": "Vous n'avez pas encore donner l'identification de votre téléphone",
        "话题竞猜": "Sujet de prédiction",
        "该浏览器不支持自动复制": "Le navigateur ne supporte pas la copie automatique",
        "详情": "Détails",
        "请您至少选择一场比赛": "Veuillez sélectionner au moins un match",
        "请输入正确页码": "Écrivez le correct numéro de page,svp",
        "请输入邀请码": "Veuillez saisir le code",
        "请选择最小筹码": "Veuillez choisir le jeton le plus petit",
        "负": "perdu",
        "贡献用户": "Contributeurs",
        "赛事竞猜": "Prédictions de matches",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "Les résultats des prédictions de matches sont basés sur la réglementation totale des 90 minutes de jeu et du temps additionnel; elle n'inclue pas le temps supplémentaire et les reconnaissances.",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "Les resultats des matches sont basés sur 90 minutes de jeu réglementaire",
        "赢<%=count%>倍": "Gagné <%=count%> fois",
        "足球竞猜": "Prédiction Footballistique",
        "跳转": "Déplacer à",
        "输入内容不能为空": "Le champ de saisie de texte ne peut être vide",
        "输入的邀请码为空": "Vous n'avez pas encore donner le code d'invitation",
        "返还": "Retourner",
        "选好了": "Terminé",
        "选择国家或地区": "Veuillez sélectionner votre pays ou région",
        "选择登录方式": "Choisir la façon de login ",
        "选择语言": "Choisir la langue",
        "邀请人奖励：": "Récompense d'inviteur:",
        "邀请好友": "Inviter des amis",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "Utilisez ce code d'envoie pour inviter des amis et vous pourrez gagner <span class='green bold'><%=count%> GTO</span>",
        "邀请好友赢大奖": "Veuillez inviter votre ami à gagner la récompense",
        "邀请码不存在": "Code d'invitation incorrecte",
        "重新加载": "Rechargement",
        "页": "Page",
        "首页": "Première page",
        "马上去参与": "rejoindre maintenant!",
        "马上去竞猜": "Commencez à prédire maintenant",
        "马上开始竞猜": "Commencez à prédire maintenant"
    },
    "idid": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. Untuk setiap pengguna yang diundang, Anda menerima <%= gto%> GTO, mengeluarkan <%=count%> kali",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. Prediksi topik didasarkan pada pilihan operator dari kecocokan populer dan prediksi topik pribadi. @@@@ 2. Hasil prediksi pertandingan didasarkan pada peraturan lengkap 90 menit pertandingan bermain dan waktu tambahan; itu tidak termasuk kerja lembur dan tembak-menembak. @@@@ 3. Jika hasil pertandingan sulit ditentukan karena abstensi, pemutaran ulang, perubahan permainan atau alasan khusus lainnya, prediksi pertandingan akan dibatalkan dan semua mata uang virtual akan dikembalikan kepada pengguna. @@@@ 4. Peluang di halaman hanya sebagai referensi, peluang sebenarnya tergantung pada detail pesanan.",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. Setiap kali orang yang diundang membuat prediksi yang benar, pengundang akan diberikan hadiah",
        "<%=count%>GTO": "<%=count%> GTO",
        "<%=count%>场比赛可投": "Letakkan prediksi pada <%=count%> pertandingan paling banyak",
        "<%=count%>次奖励发放如下：": "<%=count%> penghargaan yang dikeluarkan sebagai berikut:",
        "<%=count%>竞猜记录": "Data prediksi <%=count%>",
        "<%=name%>暂时没有贡献": "<%=name%> tidak berkontribusi apa-apa",
        "<%=name%>的邀请码": "<%=name%> kode undangan",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> berkontribusi <span> <%=gto%> GTO </ span> <span> <%=eth%> ETH </ span> <span> <%=uz%> uDiamond </ span>.",
        "<em><%=name%></em>的房间": "Room <em><%=name%></em>",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p> Beli GTO dalam pertukaran, </ p> <p> transfer ke alamat dompet GIFTO Anda. </ p> <p> Lihat alamat dompet sekarang? </ p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p> Transfer ETH ke alamat dompet GIFTO Anda. </ p> <p> Lihat alamat dompet sekarang? </ p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "Prediction dibangun di atas Platform Live-Dreaming Uplive. Pengguna dapat dengan mudah memenangkan cryptocurrency dengan memprediksi secara akurat hasil pertandingan sepak bola. @@@@ 1. Anda dapat memilih dari 3 prediksi per pertandingan, menang, seri, kalah, setiap pilihan memiliki peluang yang berbeda. @@@@ 2. Ukuran pengganda berbanding terbalik dengan kekuatan tim. Semakin kuat tim, semakin kecil pengganda. Anda dapat membuat penilaian sendiri tentang siapa yang memiliki peluang menang yang lebih baik. @@@@ 3. Preditctions memerlukan investasi sejumlah cryptocurrency, platform mendukung B111+B111+B111 GTO dan ETH. @@@@ 4. Setelah Anda melakukan pemesanan, Anda dapat memilih dari lebih banyak pertandingan atau memeriksa detail pesanan Anda. @@@@ 5. Jika hasil pertandingan sama dengan prediksi Anda, maka selamat, Anda akan memenangkan hadiah yang sesuai! Buat prediksi sekarang untuk menang!D110",
        "GTO投注量": "Taruhan GTO",
        "U钻": "U diamond",
        "U钻投注量": "Taruhan U diamond",
        "U钻投注量奖励": "Hadiah taruhan U diamond",
        "上一页": "Kembali",
        "下一页": "Berikut",
        "下拉更新": "Tarik untuk menyegarkan",
        "下载": "Download",
        "不中返本金": "Modal dapat dikembalikan jika tidak menang",
        "不中返还": "Modal dapat dikembalikan jika tidak menang",
        "不再提示": "Jangan ingatkan lagi",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "Tebakkan Hasil Bola<br>, Dapatkan Hadiah",
        "两个用户不能相互绑定邀请码,请重新填写": "Anda tidak dapat dirujuk oleh teman yang sudah Anda sebutkan, harap masukkan yang lain!",
        "中奖计算": "Hitung kemenangan",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Kabar gembira. Platform tebakan bola akan memberikan hadiah kepada user-user berdasarakan total taruhan GTO. (Tidak termasuk GTO dari bonus mengundang teman, Angpao atau teman yang Anda undang menang di event). Semakin banyak taruhan Anda, semakin banyak hadiahnya. Hadiah ini akan diberikan 7 hari kerja setelah event berakhir.",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Kabar gembira. Platform tebakan bola akan memberikan hadiah kepada user-user berdasarakan total taruhan U diamond. (Tidak termasuk U diamond dari bonus mengundang teman, Angpao atau teman yang Anda undang menang di event). Semakin banyak taruhan Anda, semakin banyak hadiahnya. Hadiah ini akan diberikan 7 hari kerja setelah event berakhir.",
        "主胜": "Tim tuan rumah menang ",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "Selamat kepada <%=username%>, Anda mendapatkan hadiah <%=count%> <%=currency%>",
        "充值": "Top up",
        "全选": "Pilih semua",
        "全部": "Total",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "Total <%=count%> , <span class=\"cur-page-box\">Ini <%=curPage%>/<%=pages%> Halaman</span>",
        "关于我们": "Tentang Kami",
        "分享到Facebook": "Berbagi ke facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "beralih metode pembayaran, opsi termasuk: <p class = 'green'> GTO, ETH dan U diamond </ p>",
        "切换语言": "Ganti bahasa",
        "切换语言版本": "Ganti Bahasa",
        "加载中……": "Pemuatan......",
        "单个玩法竞猜金额超出上限": "Biaya prediksi melebihi batas",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "Ketika jumlah bonus dalam satu pertandingan melebihi jumlah tertentu, layanan pelanggan akan mengirim hadiah secara manual. Silakan tunggu atau hubungi kami dengan pertanyaan.",
        "单次最大可投<%=count%><%=unit%>": "Anda dapat menaruh maksimal <%=count%><%=unit%> per kali",
        "单次竞猜金额超出上限": "Biaya prediksi melebihi batas",
        "去充值": "Top up",
        "去登录": "Login",
        "参与成功": "Terima kasih telah berpartisipasi",
        "参与详情": "Rincian partisipasi",
        "反选": "Reverse",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "Syarat dan ketentuan: setiap kali seorang undangan menempatkan prediksi, pengundang menerima hadiah!",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "Belum tersedia pada wilayah Anda",
        "可领取奖励": "Hadiah yang dapat diambil",
        "可领取奖励：": "Hadiah yang dapat diambil: ",
        "同一台设备不可多次绑定邀请码": "Kode undangan hanya berlaku untuk satu perangkat.",
        "含获赠的": "Termasuk yang diberikan",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "Anda masih dapat menaruh maksimal <%=max%><%=unit%> pada pertandingan antara <%=hostname%>vs<%=guestname%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "Anda akan menerima <%=count%> hadiah GTO bila Anda berhasil mengikat kode undangan.",
        "复制成功": "Berhasil disalin",
        "复制邀请地址": "Salin tautan",
        "大奖派发": "Distribusi penghasilan besar",
        "奖励": "Imbalan",
        "奖励规则如下：": "Tentang event:",
        "好友猜中比赛后，你也可以获得奖励哦~~": "Ketika mereka menempatkan prediksi, Anda dapat memenangkan hadiah juga ! ",
        "如何邀请？": "Bagaimana cara mengundang?",
        "客胜": "Tim tamu menang ",
        "小视频": "Short Video",
        "尾页": "Tidak ada lagi",
        "已中奖": "Kemenangan",
        "已使用": "Digunakan",
        "已取消": "Dibatalkan",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "Menyalin alamat undangan Anda dengan sukses ~ <br /> Kirim ke teman Anda dan undang mereka untuk bermain bersama!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "Pertandingan tidak lagi menerima prediksi. <br/> Memilih ulang pertandingan Anda",
        "已选<%=count%>场比赛": "Dipilih <%=count%> pertandingan",
        "帮助": "Help",
        "平": "seimbang",
        "平局": "Seimbang ",
        "开赛": "Memulai Pertandingan",
        "当前是最后一页": "Ini halaman terakhir",
        "当前是第一页": "Ini halaman pertama",
        "待揭晓": "Akan diumumkan",
        "快来和我一起赢大奖吧": "Manfaat luar biasa, datang dan menangkan hadiah ETH dengan saya.",
        "总投注额10%": "10% dari total taruhan GTO",
        "总投注额15%": "15% dari total taruhan GTO",
        "总投注额20%": "20% dari total taruhan GTO",
        "总投注额25%": "25% dari total taruhan GTO",
        "总投注额3%": "Total taruhan 3%",
        "总投注额30%": "30% dari total taruhan GTO",
        "总投注额5%": "5% dari total taruhan GTO",
        "总投注额8%": "8% dari total taruhan GTO",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "Selamat kepada <%=name%> untunk berhasil mengundang teman dan mendapatkan bonus <%=count%> GTO",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "Selamat kepada <%=name%> mendapatkan <span> <%=count%> <%=type%> </ span>",
        "您已绑定的邀请码": "Kode undangan tersambung",
        "您最多还能投<%=max%><%=unit%>": "Anda masih dapat menaruh maksimal <%=max%><%=unit%>",
        "您的<%=type%>不足": "Saldo <%=type%> Anda tidak mencukupi",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "Kode undangan yang tersambung dengan benar, <p> Anda akan mendapatkan <span class = 'green bold'> <%=count%> GTO </ span> secara instan </ p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "Mengundang teman, menangkan <%=count%> GTO!",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "Jika Anda mengundang teman, menangkan <%=count%> GTO!",
        "我已成功邀请<%=count%>个好友": "Saya berhasil mengundang <%=count%> teman",
        "我的投注量：": "Taruhan saya: ",
        "我的收益": "Penghasilan saya",
        "我的订单": "Pesanan Saya",
        "我的贡献": "Kontribusi saya",
        "我的邀请码": "Kode undangan saya",
        "我邀请的好友": "Referensi saya",
        "截止": "limit",
        "投注越多 奖励越丰厚": "Bet More, Earn More",
        "抱歉,没有更多数据啦~": "Maaf, tidak ada lagi data ~",
        "排行榜": "Ranking",
        "提交": "Submit",
        "提示：即使活动结束，此奖励政策依然有效。": "Pemberitahuan: bahkan jika acara ini berakhir, kebijakan hadiah masih berlaku.",
        "支持GTO、ETH、U钻": "Mendukung GTO, ETH, dan U diamond",
        "收益": "Pendapatan",
        "收益明细": "Detail penghasilan",
        "收起": "Close",
        "时间": "Waktu",
        "星期一": "Senin",
        "星期三": "Rabu",
        "星期二": "Selasa",
        "星期五": "Juma'at",
        "星期六": "Sabtu",
        "星期四": "Kamis",
        "星期日": "Minggu",
        "暂无满足奖励条件的用户": "Saat ini tidak ada user yang memenuhi syarat",
        "暂无记录": "Tidak ada data",
        "暂无赛事": "Saat ini tidak ada pertandingan",
        "更新中": "Menyegarkan",
        "最多选择8场比赛": "Anda dapat memilih maksimal 8 pertandingan",
        "最新中奖名单": "Daftar pemenang terbaru",
        "服务器链接中断!": "Koneksi error",
        "未中奖": "Tidak menang",
        "未使用": "Tidak digunakan",
        "松开更新": "Lepaskan untuk menyegarkan",
        "查看你的竞猜记录": "Periksa catatan prediksi Anda",
        "查看全部": "Cek semuanya",
        "查看我邀请的好友": "Cek referensi saya",
        "查看明细": "Cek detailnya",
        "查看竞猜玩法规则": "Cek aturan permainan prediksi",
        "查看竞猜记录": "Periksa catatan prediksi",
        "正在加载": "Sedang memuat",
        "此邀请码绑定人数已达上限": "Kode invite ini telah mencapai limit.",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "Setiap pengguna memiliki halaman undangan, berbagi halaman undangan dengan orang lain, dan jika pengguna baru mendaftar dalam 24 jam menggunakan kode undangan Anda, Anda akan menerima Gifto!",
        "比赛已停止竞猜": "Pengajuan prediksi telah selesai",
        "比赛已取消": "Pertandingan dibatalkan",
        "比赛结果:": "Hasil pertandingan:",
        "没有权限，如有疑问请联系客服！": "Anda tidak memenuhi syarat untuk login, silakan hubungi CS.",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "Semua GTO yang diberi hadiah melalui program rujukan hanya dapat digunakan untuk menempatkan prediksi, Anda tidak boleh menukarkan atau menebus. Setelah menang, GTO akan berubah menjadi GTO yang biasa digunakan.",
        "活动时间：": "Periode Event: ",
        "消耗": "Konsumsi",
        "清空": "Dikosongkan",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "Platform prediksi sepak bola panas, daftar dan ikat kode undangan saya untuk memenangkan hadiah!",
        "点击复制": "Salin",
        "热门直播": "Hotlist",
        "特别提醒：": "Tips:",
        "猜中最大可获得": "Hadiah tertinggi:",
        "猜中获得": "Menangkan",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "Kemenangan prediksi = jumlah total pokok yang ditempatkan * peluang untuk menang",
        "猜中记录": "Prediksi",
        "玩法": "Cara bermain",
        "玩法规则": "Cara Bermain",
        "用户名": "Username",
        "用户网络不稳定": "Koneksi jaringan tidak stabil",
        "登出": "Logout",
        "登录": "Login",
        "登录后才能执行此操作": "Silahkan masuk terlebih dahulu!",
        "知道了": "Ok",
        "确定": "Memastikan",
        "禁止绑定自己邀请码": "Tidak dapat menggunakan kode undangan Anda sendiri",
        "立即参与": "Submit sekarang",
        "立即参与竞猜": "Segera bergabung",
        "立即邀请好友，赢大奖": "Undang teman, menangkan hadiah!",
        "竞猜下单赠送": "Hadiah dari temanmu membuat prediksi",
        "竞猜中奖赠送": "Hadiah dari prediksi akurat teman Anda",
        "竞猜介绍": "Prediksi pembukaan",
        "竞猜内容": "Detail prediksi",
        "竞猜排行榜": "Ranking Prediksi",
        "竞猜方式": "Cara memprediksi",
        "竞猜时间": "Waktu Prediksi",
        "第<%=count%>次奖励": "<%=count%> hadiah",
        "筛选": "Filter",
        "类型": "Tipe",
        "绑定成功立即获得<%=count%>GTO": "Dapatkan <%=count%> GTO dengan mengundang",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "Setelah berhasil mengundang teman, Anda akan mendapatkan <%=count%> GTO",
        "绑定邀请码": "Masukkan kode undangan",
        "绑定邀请码成功!": "Mengikat kode undangan dengan sukses!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "GTO tambahan ini hanya dapat digunakan untuk memprediksi kecocokan, transfer, dan penarikan tidak diizinkan!",
        "继续参与": "Melanjutkan prediksi",
        "继续游戏": "Terus main",
        "网络有点问题哦": "Jaringan error",
        "网络连接异常": "Koneksi jaringan tidak stabil",
        "联系我们": "Hubungi Kami",
        "胜": "menang",
        "胜平负": "Memprediksi kemenangan, imbang, atau kegagalan tim tuan rumah",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "Untuk setiap kali orang yang diundang membuat prediksi yang akurat dalam 6 bulan pertama setelah dirujuk, pengundang akan menerima 3% dari total kemenangan yang diundang. Kemenangan ekstra ini akan dikeluarkan oleh platform dan tidak mempengaruhi kemenangan peserta.",
        "获得": "Menangkan",
        "获得<%=count%>个<%=currency%>": "Menangkan<%=currency%> x<%=count%>",
        "被邀请人奖励：": "hadiah undangan:",
        "设备标识为空": "Perangkat error",
        "话题竞猜": "Prediksi topik",
        "该浏览器不支持自动复制": "Browser ini tidak mendukung salinan otomatis",
        "详情": "Keterangan",
        "请您至少选择一场比赛": "Harap pilih setidaknya satu pertandingan",
        "请输入正确页码": "Mohon masukkan urutan halaman",
        "请输入邀请码": "Silakan masukkan kode",
        "请选择最小筹码": "Silakan pilih taruhan",
        "负": "kalah",
        "贡献用户": "Penyumbang",
        "赛事竞猜": "Prediksi pertandingan",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": " Hasil prediksi pertandingan didasarkan pada peraturan lengkap 90 menit pertandingan bermain dan waktu tambahan; itu tidak termasuk kerja lembur dan tembak-menembak. ",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "Hasil pertandingan didasarkan pada regulasi 90 menit permainan",
        "赢<%=count%>倍": "Menangkan <%=count%> kali",
        "足球竞猜": "Prediksi Bola",
        "跳转": "Ke",
        "输入内容不能为空": "Teks input tidak boleh kosong",
        "输入的邀请码为空": "Kode undangan tidak boleh dikosongkan",
        "返还": "Kembali",
        "选好了": "Selesai",
        "选择国家或地区": "Silakan pilih negara atau wilayah Anda",
        "选择登录方式": "Pilih cara login",
        "选择语言": "Pilih bahasa",
        "邀请人奖励：": "Hadiah Pengundang:",
        "邀请好友": "Mengundang teman",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "Gunakan kode ini untuk mengundang teman dan dapat memenangkan <span class = 'green bold'> <%=count%> GTO </ span>",
        "邀请好友赢大奖": "Undang teman, menangkan hadiah!",
        "邀请码不存在": "Kode undangan salah",
        "重新加载": "Coba lagi",
        "页": "Halaman",
        "首页": "Beranda",
        "马上去参与": "Bergabung sekarang!",
        "马上去竞猜": "Mulai memprediksi sekarang",
        "马上开始竞猜": "Mulai memprediksi sekarang"
    },
    "jajp": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1，一人につき<%=gto%>GTOを獲得，<%=count%>回に分けてプレゼントされます",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1、トピック予想は、弊社が実際のデータを元に定めた内容に対して、予想ゲームを行うことです。@@@@2、対象は前後半90分間です(ロスタイムを含むが、延長とPKは含みません)@@@@3、延期やキャンセル、その他突発的な理由により変更が生じた場合は、キャンセル扱いになります。ベット金額は返還されます。@@@@4、獲得倍率はベット時の倍率を基準にします。",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. 毎回招待された人が当たると、プラットフォームから報酬が送られます。",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "<%=count%>試合に投入できます",
        "<%=count%>次奖励发放如下：": "<%=count%>回の報酬発送は下記の通り：",
        "<%=count%>竞猜记录": "<%=count%>予想記録",
        "<%=name%>暂时没有贡献": "<%=name%>データがありません",
        "<%=name%>的邀请码": "<%=name%>の招待コード",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%>貢献<span><%=gto%>個のGTO</span><span><%=eth%>ETH</span><span><%=uz%>個のダイヤ</span>",
        "<em><%=name%></em>的房间": "<em><%=name%></em>の部屋",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>取引所でGTOを購入し、</p><p>Giftoお財布のアドレス宛に送ります。</p><p>すぐにお財布をみますか？</p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>ETHをGiftoお財布のアドレスに送ります。</p><p>すぐにお財布をみますか？</p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@サッカー予想は、Uplive参加のプラットフォームで、ユーザーは、各種予想をし、その結果に応じて仮想通貨をゲットすることができます。@@@@1，通常予想は三種類あり、ホーム勝ち、引き分け、アウェー勝ちです。的中後の獲得倍率はそれぞれ異なる場合があります。@@@@2， 獲得倍率は、チームの実力や各種条件で決定されます。強いチームが勝利した場合は、獲得倍率も低くなります。@@@@3，ゲームへのベットは定められた額の仮想通貨を使用ください。弊社ではUダイヤ / GTO / ETHを使用できます。@@@@4，ベット後は、そのまま続けてベットするか、詳細に戻ることができます@@@@5， ベットした結果になれば、仮想通貨をゲット！@@@@今から初めて、ゲームを楽しもう！",
        "GTO投注量": "GTOベッド額",
        "U钻": "ダイヤ",
        "U钻投注量": "ダイヤ投入量",
        "U钻投注量奖励": "ダイヤ投入量報酬",
        "上一页": "前へ",
        "下一页": "次へ",
        "下拉更新": "下にスライドで更新",
        "下载": "ダウンロード",
        "不中返本金": "ハズレの場合も、元金は戻ります",
        "不中返还": "ハズレても戻る",
        "不再提示": "今後表示しない",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "ワールドカップの報酬は止まらない！ <br>試合の結果を予想し、大きな勝利を獲得",
        "两个用户不能相互绑定邀请码,请重新填写": "二人のユーザーはお互いに招待コードを登録できません。再度入力してください",
        "中奖计算": "報酬計算",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "サッカーイベントでベッド額（レッドパック、招待での獲得、招待した友達の獲得は含まれない）に応じて、相応のGTOをプレゼント！イベント終了後、７営業日以内にプレゼントします。",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "サッカー予想プラットフォームのユーザー様の為に、イベント期間中の累計投入ダイヤが一定の基準に達すると（投入量については、友達招待によって予想、的中後の報酬は含みません），相応な報酬がもらえます。投入量が多いほど報酬が多くなります。イベント報酬は、イベント後7日以内に送られます。",
        "主胜": "ホームチーム勝利",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "<%=username%>様，おめでとう、予想が的中しました、<%=count%><%=currency%>の報酬を獲得",
        "充值": "チャージ",
        "全选": "全て選択する",
        "全部": "全部",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "全部で<%=count%>つのデータ <span class=\"cur-page-box\">現在は第<%=curPage%>/<%=pages%>ページ</span>",
        "关于我们": "Upliveについて",
        "分享到Facebook": "Facebookにシェア",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "支払い方式を切り替え、選択できる方式は：<p class='green'>GTO、ETH、ダイヤ</p>",
        "切换语言": "言語を切り替える",
        "切换语言版本": "言語を切り替え",
        "加载中……": "ロード中",
        "单个玩法竞猜金额超出上限": "一回の遊びでベットできる金額の上限",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "一回の試合で当てた金額の累計が一定の数量を超えた時、公式サポートから手動で送る場合があります。しばらくお待ちいただくか、サポートに連絡ください。",
        "单次最大可投<%=count%><%=unit%>": "一回で最大<%=count%><%=unit%>投下できます",
        "单次竞猜金额超出上限": "一回の試合でベットできる金額の上限",
        "去充值": "チャージする",
        "去登录": "登録する",
        "参与成功": "参加成功",
        "参与详情": "参加案内",
        "反选": "逆を選択",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "発送条件：招待したユーザーが毎度予想すると、報酬が出ます。",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "このエリアは法律や政策の制限があり、本サービスを使用できません",
        "可领取奖励": "受け取れる報酬",
        "可领取奖励：": "受け取れる報酬",
        "同一台设备不可多次绑定邀请码": "同じデバイスで何回も招待コードを連携できません",
        "含获赠的": "プレゼントされたものを含む",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "この<%=hostname%>vs<%=guestname%>の試合中,最大であと<%=max%><%=unit%>投下できます",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "招待コードの登録成功後、すぐに<%=count%>GTO報酬が獲得可能。",
        "复制成功": "コピー成功",
        "复制邀请地址": "招待リンクをコピー",
        "大奖派发": "大賞の配布",
        "奖励": "報酬",
        "奖励规则如下：": "ルール：",
        "好友猜中比赛后，你也可以获得奖励哦~~": "友達が予想的中すると，試合後あなたも報酬をゲットできます",
        "如何邀请？": "招待の仕方は？",
        "客胜": "アウェイチーム勝利",
        "小视频": "ライブ動画",
        "尾页": "ページ下部",
        "已中奖": "当たりました",
        "已使用": "使用済",
        "已取消": "すでにキャンセルされました",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "あなたの招待リンク<br />をコピーしました。友達に送って一緒に予想しよう",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "すでに試合の予想期限を過ぎました<br/>再度選択してください",
        "已选<%=count%>场比赛": "すでに<%=count%>試合選択してます",
        "帮助": "ヘルプ",
        "平": "引き分け",
        "平局": "引き分け",
        "开赛": "試合開始",
        "当前是最后一页": "現在は最終ページ",
        "当前是第一页": "現在は先頭ページ",
        "待揭晓": "発表予定",
        "快来和我一起赢大奖吧": "ETHボーナス！みんな早くもらいに来よう！",
        "总投注额10%": "総ベッド額10％",
        "总投注额15%": "総ベッド額15％",
        "总投注额20%": "総ベッド額20％",
        "总投注额25%": "総ベッド額25％",
        "总投注额3%": "総投入額3%",
        "总投注额30%": "総ベッド額30％",
        "总投注额5%": "総ベッド額5％",
        "总投注额8%": "総ベッド額8％",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "おめでとう<%=name%>は友達招待に成功。<%=count%>GTOを獲得",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "おめでとう<%=name%>は、<span><%=count%><%=type%></span>を獲得",
        "您已绑定的邀请码": "使用済の招待コード",
        "您最多还能投<%=max%><%=unit%>": "この試合中最大で<%=max%><%=unit%>投下できます",
        "您的<%=type%>不足": "<%=type%>が不足しています",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "招待コードの連携成功、<p>すぐに<span class='green bold'><%=count%>個のGTO報酬を獲得</span></p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "招待コード登録成功で、すぐに<%=count%>GTO報酬獲得",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "友達招待に成功で、すぐに<%=count%>GTOゲット",
        "我已成功邀请<%=count%>个好友": "私はすでに<%=count%>人の友達を招待しました",
        "我的投注量：": "私のベッド額",
        "我的收益": "私の収益",
        "我的订单": "オーダー記録",
        "我的贡献": "私の貢献",
        "我的邀请码": "私の招待コード",
        "我邀请的好友": "招待した友達",
        "截止": "期限",
        "投注越多 奖励越丰厚": "ベッド額キックバック！",
        "抱歉,没有更多数据啦~": "他にデータがありません",
        "排行榜": "ランキング",
        "提交": "送信",
        "提示：即使活动结束，此奖励政策依然有效。": "ヒント：イベントが終わっても、報酬ルールは継続されます。",
        "支持GTO、ETH、U钻": "GTO、ETH、Uダイヤをサポートしています",
        "收益": "収益",
        "收益明细": "収益の詳細",
        "收起": "たたむ",
        "时间": "時間",
        "星期一": "月曜日",
        "星期三": "水曜日",
        "星期二": "火曜日",
        "星期五": "金曜日",
        "星期六": "土曜日",
        "星期四": "木曜日",
        "星期日": "日曜日",
        "暂无满足奖励条件的用户": "条件に達していません",
        "暂无记录": "記録がありません",
        "暂无赛事": "試合がありません",
        "更新中": "更新中",
        "最多选择8场比赛": "最多で8試合選択できます",
        "最新中奖名单": "最新の当たりリスト",
        "服务器链接中断!": "サーバーとのリンクが途切れました",
        "未中奖": "ハズレました",
        "未使用": "未使用",
        "松开更新": "離すと更新",
        "查看你的竞猜记录": "あなたの予想結果を見る",
        "查看全部": "詳細を全て見る",
        "查看我邀请的好友": "私の招待リストを見る",
        "查看明细": "詳細を見る",
        "查看竞猜玩法规则": "サッカー予想の遊び方を見る",
        "查看竞猜记录": "予想記録を見る",
        "正在加载": "読み込み中",
        "此邀请码绑定人数已达上限": "アカウントの連携人数が上限に達しています",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "各ユーザーには自身の招待画面(コードも記載)があり、他の人に転送できます。送信から24時間以内に、送信相手があなたのコードを登録すると、招待成功になります。",
        "比赛已停止竞猜": "この試合はすでに予想をストップ",
        "比赛已取消": "試合がキャンセルされました",
        "比赛结果:": "試合結果",
        "没有权限，如有疑问请联系客服！": "権限がありません、問題がありましたらカスタマーサポートまで連絡してください",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "イベントで獲得したGTOは、予想のベットにしか使用できません。試合ベット後、獲得する報酬は通用GTOになります。",
        "活动时间：": "イベント期間：",
        "消耗": "消費",
        "清空": "削除",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "サッカー予想プラットフォーム。アカウント開設、招待コード登録でボーナスあり",
        "点击复制": "タップでコピー",
        "热门直播": "人気ライブ",
        "特别提醒：": "特別なお知らせ",
        "猜中最大可获得": "的中で最大獲得",
        "猜中获得": "当たり！",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "獲得金額＝総消費金額 × 選択した倍数。",
        "猜中记录": "獲得記録",
        "玩法": "遊び方",
        "玩法规则": "ゲームのルール",
        "用户名": "ユーザー名",
        "用户网络不稳定": "ネットワーク環境が不安定です",
        "登出": "ログアウト",
        "登录": "ログイン",
        "登录后才能执行此操作": "登録後にこの操作が可能になります",
        "知道了": "OK",
        "确定": "確定する",
        "禁止绑定自己邀请码": "自分の招待コードは登録不可",
        "立即参与": "すぐに参加する",
        "立即参与竞猜": "すぐにベッドする",
        "立即邀请好友，赢大奖": "すぐに友達を招待して、報酬ゲットへ",
        "竞猜下单赠送": "ベットで報酬",
        "竞猜中奖赠送": "当たりで報酬",
        "竞猜介绍": "予想結果",
        "竞猜内容": "予想内容",
        "竞猜排行榜": "ランキング",
        "竞猜方式": "予想方法",
        "竞猜时间": "予想時間",
        "第<%=count%>次奖励": "第<%=count%>回目の報酬",
        "筛选": "フィルタ",
        "类型": "種類",
        "绑定成功立即获得<%=count%>GTO": "連携成功ですぐに<%=count%>GTO獲得",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "連携成功ですぐに<%=count%>GTO獲得，各ユーザーにつき一つの専用招待コードがあるので、早く友達を探して招待しよう",
        "绑定邀请码": "招待コードを登録する",
        "绑定邀请码成功!": "招待コードを登録成功",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "報酬のGTOはサッカー予想ベットのみに使用可能。口座振替や現金引き出しできません",
        "继续参与": "参加を続ける",
        "继续游戏": "ゲームを継続する",
        "网络有点问题哦": "ネットワークが不安定です",
        "网络连接异常": "ネットワーク接続異常",
        "联系我们": "お問い合わせ",
        "胜": "勝ち",
        "胜平负": "勝ち負け",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "招待成功後６ヶ月以内の、招待された人が的中すれば、招待した人にも報酬が！報酬は招待された人が的中し獲得した額の3%です。この報酬はプラットホームからのプレゼントで、招待された人の収益には影響しません。",
        "获得": "獲得",
        "获得<%=count%>个<%=currency%>": "獲得<%=count%>个<%=currency%>",
        "被邀请人奖励：": "招待された人の報酬：",
        "设备标识为空": "デバイスが認識されません",
        "话题竞猜": "予想についての話題",
        "该浏览器不支持自动复制": "このブラウザは自動コピーをサポートしていません",
        "详情": "詳細",
        "请您至少选择一场比赛": "少なくとも一つの試合を選択してください",
        "请输入正确页码": "正しいページを入力してください",
        "请输入邀请码": "招待コードを入力してください",
        "请选择最小筹码": "最小のチップを選択してください",
        "负": "負け",
        "贡献用户": "貢献ユーザー",
        "赛事竞猜": "イベント試合",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "対象は前後半90分間です(ロスタイムを含むが、延長とPKは含みません)",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "試合結果は選択した試合の90分とします（ロスタイムは含む。延長戦とPKは含みません）",
        "赢<%=count%>倍": "Win<%=count%>倍",
        "足球竞猜": "サッカー予想",
        "跳转": "ページジャンプ",
        "输入内容不能为空": "入力必須です",
        "输入的邀请码为空": "招待コードが打たれていません",
        "返还": "戻る",
        "选好了": "選択した",
        "选择国家或地区": "国と地区を選択する",
        "选择登录方式": "ログイン方法を選択",
        "选择语言": "言語を選択する",
        "邀请人奖励：": "招待報酬：",
        "邀请好友": "友達になろう",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "友達を招待して招待コードを認証すると、<span class='green bold'><%=count%>個のGTO</span>報酬が獲得できます",
        "邀请好友赢大奖": "友達を招待して大賞をゲット",
        "邀请码不存在": "招待コードがありません",
        "重新加载": "再ロード",
        "页": "ページ",
        "首页": "ホームページ",
        "马上去参与": "すぐ参加する",
        "马上去竞猜": "すぐに予想する",
        "马上开始竞猜": "予想スタート"
    },
    "kokr": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. 1명 유저 초대 시, <%=gto%>GTO를 <%=count%>번에 나누어 제공해드립니다.",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. 토픽 예측은 게임 매치 결과, 개개인 플레이어 성과 등이 포함됩니다. @@@@2. 매치 예측 결과는 90분의 전체 경기를 바탕으로 합니다.(오버타임 등 불포함)@@@@3. 게임 일정 변동, 선수 불참으로 인한 경기 결과 결정 난항 혹은 다른 특별한 이유 때문에 취소 될 수 있으며, 예측 게임으로 투입한 금액은 유저분들에게 돌려드릴 것입니다. @@@@4. 페이지에 있는 리워드 배수는 참고사항일 뿐이며, 실제 배수는 예측 내역에서 확인 할 수 있습니다.",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. 초대받은 친구가 예측한 결과를 맞추면, 초대하신 분은 리워드를 받을 수 있습니다.",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "<%=count%>매치 결과 예상",
        "<%=count%>次奖励发放如下：": "아래와 같이, <%=count%>번 리워드를 드립니다.：",
        "<%=count%>竞猜记录": "<%=count%> 퀴즈기록",
        "<%=name%>暂时没有贡献": "<%=name%>공헌 기록이 없습니다.",
        "<%=name%>的邀请码": "<%=name%>의 초대 코드",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%>공헌<span><%=gto%>개GTO</span><span><%=eth%>개ETH</span><span><%=uz%>개U다이아</span>",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>GTO를 구매하여 교환 시 </p><p>GIFTO 지갑 주소로 계좌이체 됩니다. </p><p> 지갑 주소를 보시겠습니까? </p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>ETH를 GIFTO 지갑 주소로 계좌이체하시면 됩니다. </p><p>지갑 주소를 보시겠습니까? </p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@축구 퀴즈는 업라이브 플랫폼 내에서 진행하는 인터렉티브 게임입니다. 유저는 해당 게임을 통해 축구 게임 결과를 예측하여 가상화폐 리워드를 받을 수 있습니다.@@@@1. 한번의 게임에서 홈팀 승리, 무승부, 상대팀 승리 이 세가지 중 예측하여 선택할 수 있으며, 모든 선택 항목에는 각기 다른 확률의 리워드를 제공합니다. @@@@2. 리워드 배수는 축구팀 실력에 따라 반비례합니다. 축구팀 실력이 높을수록 해당하는 리워드의 배수는 낮아집니다. 그러니, 어떤 축구팀을 응원해야 예측 성공률이 높을지는 이에 따라 판단하셔야 합니다.@@@@3.경기 결과 예측 시, 일정량의 가상화폐를 투자하여야 합니다. 플랫폼에서 U다이아 / GTO / ETH를 지원하고 있습니다.@@@@4. 결과 예측 완성 후, 계속 퀴즈를 할 수 있습니다. 또한 결과 예측 시스템을 통해 상세 내용을 볼 수 있습니다.@@@@5. 만약 게임 결과가 예측한 결과와 같다면, 해당 리워드를 받을 수 있습니다. @@@@지금 얼른 퀴즈에 참가하여 리워드를 받으세요~",
        "U钻": "U 다이아",
        "下拉更新": "아래로 밀어서 새로고침",
        "不中返本金": "승리하지 못할 시 원금 돌려드립니다.",
        "不中返还": "승리하지 못할 시 원금 돌려드립니다.",
        "不再提示": "다시 보지 않기",
        "两个用户不能相互绑定邀请码,请重新填写": "초대한 친구와 서로 코드 연동을 할 수 없습니다. 새로운 초대 코드를 입력해주세요.",
        "中奖计算": "리워드 계산",
        "主胜": "홈팀 우승",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "<%=username%>님, 축구 퀴즈에 당첨되셨습니다. 축하드려요! <%=count%> <%=currency%>리워드를 드리겠습니다!",
        "充值": "충전",
        "全选": "전체 선택",
        "全部": "Total",
        "分享到Facebook": "페이스북에 공유하기",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "결제 지불 방식 변경：<p class='green'>GTO、ETH、U다이아</p>",
        "切换语言": "언어 변경",
        "切换语言版本": "언어 변경",
        "加载中……": "로딩 중",
        "单个玩法竞猜金额超出上限": "일회성 예상 퀴즈 금액이 상한선을 초과하였습니다.",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "일회성 경기에서 예측 퀴즈 우승 금액이 일정량에 도달 할 시, 관리자가 상금을 계산하여 증정해드리오니 기다려주시면 감사하겠습니다. 해당 사항은 관리자에게 문의하여 주시기바랍니다.",
        "单次竞猜金额超出上限": "일회성 퀴즈 금액이 상한선을 초과하였습니다.",
        "去充值": "충전하러가기",
        "去登录": "로그인",
        "参与成功": "참가성공",
        "参与详情": "참가 상세내용",
        "反选": "선택 취소",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "친구가 경기 예측 퀴즈를 할 때 마다, 보너스를 드립니다!",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "해당 지역 법률 제한으로 인해, 해당 상품은 해당 지역에서 일정 기간 동안 사용 불가 합니다.",
        "同一台设备不可多次绑定邀请码": "같은 디바이스에서 초대 코드를 여러번 등록 할 수 없습니다.",
        "含获赠的": "획득 내용 포함",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "초대코드 승인 후에 바로 <%=count%>GTO를 받을수있습니다",
        "复制成功": "복사 성공",
        "复制邀请地址": "링크 복사",
        "大奖派发": "대상 증정",
        "奖励": "경품",
        "好友猜中比赛后，你也可以获得奖励哦~~": "친구가 게임 퀴즈를 맞추면, 리워드를 함께 증정드려요~~",
        "如何邀请？": "초대하는 법",
        "客胜": "상대편 우승",
        "已中奖": "승리하였습니다",
        "已使用": "이미 사용했어요",
        "已取消": "취소됨",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "초대 주소 복사 성공~<br />친구에게 초대 코드를 보내 같이 놀아요~",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "퀴즈 가능한 경기가 남아있지 않습니다.<br/>새로고침 하여 경기를 선택하세요",
        "已选<%=count%>场比赛": "<%=count%>개의 게임을 선택하였습니다.",
        "平": "무승부",
        "平局": "무승부",
        "开赛": "경기 시작",
        "待揭晓": "발표 전입니다.",
        "快来和我一起赢大奖吧": "어서 와서 저와 함께 축구 게임을 즐겨요~",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "축하해요 <%=name%>친구를 초대해서 <%=count%>GTO를 받았어요",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "축하합니다. <%=name%>, <span><%=count%><%=type%></span>를 획득하셨어요",
        "您已绑定的邀请码": "등록한 초대 코드",
        "您的<%=type%>不足": "님의<%=type%>가 부족합니다.",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "초대 코드 등록 성공<p>바로<span class='green bold'><%=count%>개GTO리워드 획득할 수 있습니다.</span></p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "초대 코드 연동 완료 <%=count%> GTO 리워드를 드립니다! ",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "친구초대 성공!, <%=count%>GTO 리워드를 드립니다.",
        "我已成功邀请<%=count%>个好友": "<%=count%>명 친구 초대 성공했습니다.",
        "我的收益": "나의 수익",
        "我的贡献": "나의 공헌",
        "我的邀请码": "나의 초대 코드",
        "我邀请的好友": "내가 초대한 친구",
        "抱歉,没有更多数据啦~": "죄송합니다. 추가적 데이터가 없어요",
        "提交": "제출",
        "提示：即使活动结束，此奖励政策依然有效。": "시스템 : 이벤트 종료후에도 리워드 정책은 유효합니다",
        "支持GTO、ETH、U钻": "GTO, ETH, U다이아 지원",
        "收益": "수익",
        "收益明细": "수익 상세 보기",
        "收起": "중지",
        "时间": "시간",
        "星期一": "월요일",
        "星期三": "수요일",
        "星期二": "화요일",
        "星期五": "금요일",
        "星期六": "토요일",
        "星期四": "목요일",
        "星期日": "일요일",
        "暂无记录": "기록 없음",
        "暂无赛事": "현재 게임 진행 중이 아닙니다.",
        "更新中": "새로고침 중",
        "最多选择8场比赛": "최고 8개 매치 선택 가능",
        "最新中奖名单": "최근 위너 리스트",
        "服务器链接中断!": "연결이 끊겼습니다.",
        "未中奖": "패배하였습니다",
        "未使用": "사용 전",
        "松开更新": "당김 풀어서 새로고침",
        "查看你的竞猜记录": "나의 퀴즈 기록 보기",
        "查看全部": "전부 보기",
        "查看我邀请的好友": "초대된 친구 보기",
        "查看明细": "상세보기",
        "查看竞猜玩法规则": "퀴즈 게임 방법 보기",
        "查看竞猜记录": "퀴즈 결과 보기",
        "正在加载": "로딩 중",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "모든 유저들은 각각 고유의 초대 페이지 및 코드를 가지고 있습니다. 초대 페이지를 친구들에게 보내서 초대해주세요. 새로운 유저는 회원 가입 후 24시간 내 해당 초대 코드를 연동하면 초대 가능 합니다.",
        "比赛已停止竞猜": "해당 경기의 퀴즈가 종료되었습니다.",
        "比赛已取消": "경기 취소",
        "比赛结果:": "경기결과:",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "이벤트 중 획득한 GTO는 퀴즈에서만 사용이 가능하며, 직접 환전이나 송금할 수 없습니다. 승리 후 사용할수있는 GTO로 변환해 드립니다.",
        "消耗": "사용",
        "清空": "클리어",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "HOT한 축구 퀴즈 플랫폼~ 월드컵이 기다리고 있어요! 초대 코드를 등록하여 경품을 타보아요!",
        "点击复制": "초대 코드 복사",
        "特别提醒：": "주의 사항:",
        "猜中最大可获得": "제일 높은 리워드",
        "猜中获得": "당첨",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "예측 우승 금액 = 전체 소모한 금액 x 우승 확률 배수",
        "猜中记录": "승리기록",
        "玩法": "게임 방법",
        "玩法规则": "게임 방법",
        "用户网络不稳定": "네트워트 환경을 확인 해 주세요",
        "登录": "로그인",
        "登录后才能执行此操作": "로그인을 먼저 해주세요",
        "知道了": "알겠습니다.",
        "确定": "확인",
        "禁止绑定自己邀请码": "본인의 초대 코드를 연동 할 수 없습니다.",
        "立即参与": "참가하기",
        "立即邀请好友，赢大奖": "친구초대하고 경품뽑기",
        "竞猜下单赠送": "예상에 따른 경품 증정",
        "竞猜中奖赠送": "정확한 예상에 따른 경품 증정",
        "竞猜介绍": "퀴즈 소개",
        "竞猜内容": "퀴즈 내용",
        "竞猜方式": "퀴즈 방식",
        "竞猜时间": "퀴즈 시간",
        "第<%=count%>次奖励": "제<%=count%>번 리워드",
        "筛选": "필터",
        "类型": "종류",
        "绑定成功立即获得<%=count%>GTO": "연동 성공 시<%=count%>GTO 리워드 증정!",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "등록 성공 후 곧바로<%=count%>GTO를 받을 수 있습니다. 모든 유저들은 고유한 초대 코드가 있으니, 친구에게 초대 코드를 보내서 초대해주세요!",
        "绑定邀请码": "초대코드 연동",
        "绑定邀请码成功!": "초대 코드 연동 성공!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "이벤트를 통한 GTO 리워드는 축구 이벤트에서만 사용 가능하며, 지갑 계좌로 입출 불가합니다.",
        "继续参与": "계속 참가하기",
        "继续游戏": "게임 계속하기",
        "网络有点问题哦": "네트워크 문제 발생",
        "网络连接异常": "인터넷 연결이 불안정합니다.",
        "胜": "승리 ",
        "胜平负": "게임 승리, 무승부, 패배",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "초대받은 친구가 정확한 예측을 했을 시, 초대한 유저는 초대받은 친구 수익(전체리워드에서 예측 시 들어간 원금의 차)의 3%를 리워드로 받을 수 있습니다.(리워드는 초대 성공 후 6개월 내 드립니다.) 해당 보너스 리워드는 플랫폼에서 발행할 것이며, 초대받은 친구의 전체 수익에 반영되지는 않습니다.",
        "获得": "획득",
        "获得<%=count%>个<%=currency%>": "획득 <%=count%> <%=currency%>",
        "被邀请人奖励：": "초대받은 친구의 리워드:",
        "设备标识为空": "디바이스 ID가 비었습니다.",
        "话题竞猜": "예상 토픽",
        "该浏览器不支持自动复制": "해당 브라우저는 자동 복사 지원 불가합니다.",
        "详情": "상세내용",
        "请您至少选择一场比赛": "최소 하나의 게임을 선택해주세요.",
        "请输入邀请码": "초대 코드 입력",
        "负": "패배",
        "贡献用户": "공헌 유저",
        "赛事竞猜": "매치 퀴즈",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "매치 결과는 90분의 경기 플레이를 바탕으로 선정됩니다.",
        "赢<%=count%>倍": "<%=count%>번 승리",
        "足球竞猜": "축구 퀴즈",
        "输入内容不能为空": "입력 내용에 공백으로 둘 수 없습니다.",
        "输入的邀请码为空": "초대 코드가 비었습니다.",
        "返还": "돌아가기",
        "选好了": "완료",
        "选择国家或地区": "국가 혹은 지역을 선택해주세요",
        "选择语言": "언어 선택",
        "邀请人奖励：": "초대 리워드:",
        "邀请好友": "친구를 초대해보세요",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "초대 코드를 보내 친구를 초대하는데 성공하였습니다.<span class='green bold'><%=count%>개GTO</span>리워드를 증정드릴게요!",
        "邀请好友赢大奖": "친구를 초대하고 빅 리워드를 받으세요!",
        "邀请码不存在": "초대 코드를 잘못 입력 하셨습니다.",
        "重新加载": "재로딩 중",
        "马上去参与": "참여하기",
        "马上去竞猜": "퀴즈가 곧 시작 됩니다.",
        "马上开始竞猜": "퀴즈 시작 하기"
    },
    "ruru": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. За каждошо приглашенного друга, выигрывай вплоть до <%=gto%> GTO",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. Тема прогнозов включает в себя исход матчей,  оценка индивидуальной игры футболиста, и многое другое. @@@@ 2. Результаты прогнозов расчитываются по истечению 90 минут основного времени и добавленного времени; дополнительные таймы и пенальти не включаются.  @@@@ 3. Если не удастся совершить прогноз на матч из-за неучастия команд, переигровки, изменений в игре или других обстоятельств, прием ставок на матч будет остановлен, а сами токены будут возвращены участникам.  @@@@4. Вероятность исходов тех или иных ивентов представлена только для ознакомления. ",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. Каждый раз приглашенный совершает успешный прогноз, пригласитель получает награду  ",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "Сделай прогноз на <%=count%> матчей",
        "<%=count%>次奖励发放如下：": "<%=count%> награды зачислены согласно: ",
        "<%=count%>竞猜记录": "<%=count%> история прогнозов",
        "<%=name%>暂时没有贡献": "<%=name%> ничем не отличился",
        "<%=name%>的邀请码": "Пригласительный код <%=name%> ",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> совершено <span><%=gto%> GTO</span><span><%=eth%> ETH</span><span><%=uz%> uDiamond</span>.",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Покупаете GTO на бирже, </p><p>Перевод ETH по адресу твоего GIFTO кошелька. </p><p>Посмотреть адрес кошелька? </p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Перевод ETH по адресу твоего GIFTO кошелька. </p><p>Посмотреть адрес кошелька? </p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@Футбольный прогноз постороен на базе стримминговой платформы Uplive. Пользователи легко могут выигрывать криптовалюты с точностью определяя исход футбольных матчей. @@@@1. Вы можете сделать выбор из трех исходов в одном матче, победа, поражение, ничья. Каждый прогноз имеет собственный коэффициент. @@@@2. Размер умножителя обратно пропорционален к силе той или иной команды. Чем сильнее команда, тем меньший умножитель. Вы можете сделать свой собственный прогноз, основываясь лучших шансах выиграть. @@@@3. Для прогноза Вам нужно иметь опеределенную сумму криптовалюты, платформа поддерживает Uдиаманты, GTO и ETH.  @@@@4. После того как Вы сделали прогноз, Вы можете совершать последующие ставки, либо следить за прогрессом текущей. @@@@5. Если результат матча совпадает с сделанным Вами прогнозом, поздравляем, Вы выиграли соответствующую награду! Больше прогнозов, больше побед! ",
        "U钻": "U-диамант",
        "上一页": "Последняя страница",
        "下一页": "Следующая страница",
        "下拉更新": "Потащи для обновления",
        "下载": "Загрузка",
        "不中返本金": "Вложенные средства ",
        "不再提示": "Не напоминать об этом",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "Награждения не останавливаются!  <br> Спрогнозируй правильные результаты матчей и выигрывай большие награды!",
        "两个用户不能相互绑定邀请码,请重新填写": "Вы не можете быть приглашены другом, которого Вы сами пригласили, пожалуйста введите другой код!",
        "中奖计算": "Посчитать награды",
        "主胜": "Победы домашних команд",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "Dear <%=username%>, congrats on placing your soccer prediction order, you won <%=count%> <%=currency%>",
        "充值": "Пополнить",
        "全选": "Выбрать все",
        "全部": "Все ставки",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "Общее количество<%=count%> записей<span class=\"cur-page-box\"> Текущее<%=curPage%>/<%=pages%></span>",
        "关于我们": "О нас",
        "分享到Facebook": "Поделиться в Фейсбуке",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "Поменять способ оплаты, выбор включает: <p class='green'>GTO, ETH and uDiamond</p>",
        "切换语言": "Переключить язык",
        "切换语言版本": "Поменять язык",
        "加载中……": "Загрузка.....",
        "单个玩法竞猜金额超出上限": "Сумма на одиночный исход превышает лимит",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "Когда число бонусов в одиночной игре превысит определенное число, награды будут отправлены с помощью нашего клиентского сервиса в ручном порядке. Пожалуйста, подождите или свяжитесь с нами.",
        "单次最大可投<%=count%><%=unit%>": "Максимальная ставка на прогноз <%=count%> <%=unit%>",
        "单次竞猜金额超出上限": "Сумма на одиночный исход превышает лимит",
        "去充值": "Пополнить",
        "去登录": "Логин",
        "参与成功": "Спасибо за участие",
        "参与详情": "Условия участия",
        "反选": "Реверс",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "Каждый раз твой друг делает ставку, Вы получаете приз!",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "Ограничен местным законодательством, временно недоступно в Вашем регионе.",
        "同一台设备不可多次绑定邀请码": "Вы не можете повторно использовать код с одного устройства",
        "含获赠的": "Включая полученные",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "Во время матча <%=hostname%> vs <%=guestname%>, максимальная сумма для прогноза составляет <%=max%> <%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "Вы будете награждены <%=count%> GTO сразу же после использования пригласительного кода друга.",
        "复制成功": "Скопировано",
        "复制邀请地址": "Скопировать ссылку",
        "大奖派发": "Лучшие награды",
        "奖励": "Вознагражден",
        "好友猜中比赛后，你也可以获得奖励哦~~": "Когда твои друзья делают прогнозы, ты тоже автоматически становишься участником розыгрыша",
        "如何邀请？": "Как пригласить?",
        "客胜": "Победы гостей",
        "小视频": "Короткие видео",
        "尾页": "Конец",
        "已中奖": "Вы выиграли",
        "已使用": "Использованный",
        "已取消": "Отменено",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "Ваш пригласительный код успешно скопирован~<br / >Отправь его друзьям и приглашай их играть вместе.",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "Прогнозы не принимаются на ни один из матчей.<br/>Please refresh your match choices",
        "已选<%=count%>场比赛": "Выбранные <%=count%> из матчей ",
        "平": "Ничья",
        "平局": "Ничья",
        "开赛": "Время старта",
        "当前是最后一页": "На данный момент на последней странице",
        "当前是第一页": "На данный момент на первой странице",
        "待揭晓": "Еще не объявлены",
        "快来和我一起赢大奖吧": "Большая выгода, выигрывай награды со мной!",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "<%=name%> invited a friend and won <%=count%> GTO!",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "Поздравляем <%=name%> por obtener <span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "Привязать пригласительный код",
        "您最多还能投<%=max%><%=unit%>": "Все еще можно спрогнозировать вплоть до <%=max%> <%=unit%>",
        "您的<%=type%>不足": "Your <%=type%> Недостаточно средств",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "Вы будете награждены <span class='green bold'><%=count%> GTO</span> instantly for using a friends Invite code",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "Успешно привяжи пригласительный, выигрывай <%=count%> GTO! ",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "Пригласи друга, выигрывай <%=count%> GTO! ",
        "我已成功邀请<%=count%>个好友": "Я успешно пригласил <%=count%> друзей",
        "我的收益": "Мой зароботок",
        "我的贡献": "Мои достижения",
        "我的邀请码": "Мой пригласительный код",
        "我邀请的好友": "Приглашенные мною",
        "截止": "Время истекло",
        "抱歉,没有更多数据啦~": "К сожалению, информация отсутствует",
        "提交": "Подтвердить",
        "提示：即使活动结束，此奖励政策依然有效。": "Замечание: даже когда это соревнование закончится, политика вознаграждения останется действительной.",
        "支持GTO、ETH、U钻": "Поддерживает GTO, ETH и U-диаманты",
        "收益": "Заработок",
        "收益明细": "Условия выигрыша",
        "收起": "Неудача",
        "时间": "Время",
        "星期一": "Понедельник",
        "星期三": "Среда",
        "星期二": "Вторник",
        "星期五": "Пятница",
        "星期六": "Суббота",
        "星期四": "Четверг",
        "星期日": "Воскресенье",
        "暂无记录": "Нет записей",
        "暂无赛事": "Нет доступных матчей",
        "更新中": "Идет обновление",
        "最多选择8场比赛": "Вы максимально можете выбрать 8 матчей",
        "最新中奖名单": "Список последних победителей",
        "服务器链接中断!": "Сеть нестабильна",
        "未中奖": "Вы проиграли",
        "未使用": "Неиспользованный",
        "松开更新": "Отпустить для обновления",
        "查看你的竞猜记录": "Проверить свой прогноз",
        "查看全部": "Проверить все",
        "查看我邀请的好友": "Посмотреть мои приглашения",
        "查看明细": "Посмотреть условия",
        "查看竞猜玩法规则": "Посмотреть правила игры",
        "查看竞猜记录": "Проверить историю прогнозов",
        "正在加载": "Загрузка",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "Каждый пользователей имеет пригласительную страницу, сохранить ",
        "比赛已停止竞猜": "Прогнозы на матч больше не принимаются",
        "比赛已取消": "Матч отменен",
        "比赛结果:": "Результат матча:",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "Все GTO токены, полученные с помощью реферальных программ,  могут быть использованы только для внутренне-игровых ставок и не предназначаются для обмена или выкупа. Вывод возможен только после ",
        "消耗": "Потрачено",
        "清空": "Очистить",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "Платформа футбольных прогнозов, регистрируйся и привязывай свой пригласительный код что бы выиграть награды!",
        "点击复制": "Скопировать код",
        "热门直播": "Популярные трансляции",
        "特别提醒：": "Напоминание:",
        "猜中最大可获得": "Высшая награда",
        "猜中获得": "Победа",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "Награды за прогноз= общее количество от уставноленной суммы ставки * выигрышный коэффициент",
        "猜中记录": "Победы",
        "玩法": "Вид прогноза",
        "玩法规则": "Правила игры",
        "用户网络不稳定": "Слабый сигнал",
        "登出": "Выйти",
        "登录": "Логин",
        "登录后才能执行此操作": "Сперва войдите в систему",
        "知道了": "Я понимаю",
        "确定": "Подтвердить",
        "禁止绑定自己邀请码": "Нельзя использовать свой же пригласительный код",
        "立即参与": "Принять сейчас",
        "立即邀请好友，赢大奖": "Приглашай друзей, выигрывай призы!",
        "竞猜下单赠送": "Вознаграждения за друга, который делает прогнозы",
        "竞猜中奖赠送": "Вознаграждения за друга, который сделал правильный прогноз",
        "竞猜介绍": "Интро прогноза",
        "竞猜内容": "Детали прогноза",
        "竞猜方式": "Способы для предугадывания",
        "竞猜时间": "Время представления",
        "第<%=count%>次奖励": "<%=count%> наград",
        "筛选": "Фильтр",
        "类型": "Детали",
        "绑定成功立即获得<%=count%>GTO": "Получи <%=count%> GTO за успешно приглашенного друга ",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "Получи <%=count%> GTO за успешно приглашенного друга, каждый пользователь имеет свой собственный пригласительный код. Вы можете запросить пригласительный код у Ваших друзей. ",
        "绑定邀请码": "Привязать пригласительный код",
        "绑定邀请码成功!": "Привязка кода прошла успешно!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "GTO полученные путем приглашения друзей могут быть использованы только для прогнозов",
        "继续参与": "Продождить делать прогнозы",
        "继续游戏": "Продолжить играть",
        "网络有点问题哦": "Системная ошибка",
        "网络连接异常": "Сеть нестабильна",
        "联系我们": "Свяжитесь с нами",
        "胜": "Победа",
        "胜平负": "Сделай прогноз на победу, ничью или проигрыш домашней команды",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "Каждый раз приглашенный совершает успешный прогноз, пригласитель получает 3% от заработка приглашенного им пользователя. Эти бонусные награды будут зачислены самой системой и не поволияют на сумарнный выигрыш приглашенного. (Бонус активен в течении первых 6-ти месяцев игры)  ",
        "获得": "Победа",
        "获得<%=count%>个<%=currency%>": "Победа <%=count%> <%=currency%>",
        "被邀请人奖励：": "Награда приглашенного:",
        "设备标识为空": "Ваш девайс уже был использован",
        "话题竞猜": "Тема прогнозов",
        "该浏览器不支持自动复制": "Браузер не поддерживает автокопирование",
        "详情": "Условия",
        "请您至少选择一场比赛": "Пожалуйста, выберите хотя бы один матч",
        "请输入正确页码": "Пожалуйста, введите правильный номер страницы",
        "请输入邀请码": "Пожалуйста, введите код",
        "请选择最小筹码": "Пожалуйста, выберите минимум чипсов",
        "负": "Поражение",
        "贡献用户": "Участник",
        "赛事竞猜": "Прогноз на матч",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "Результаты матчей считаются заключительными за истечением 90 минут игры  ",
        "赢<%=count%>倍": "Количество побед <%=count%>",
        "足球竞猜": "Футбольный прогноз",
        "跳转": "Перейти на",
        "输入内容不能为空": "Поле ввода не может быть пустым",
        "输入的邀请码为空": "Пригласительный код уже использован",
        "返还": "Возврат",
        "选好了": "Выполнено",
        "选择国家或地区": "Пожалуйста выберите свою страну или регион",
        "选择语言": "Выберите язык",
        "邀请人奖励：": "Приз пригласителя: ",
        "邀请好友": "Пригласи друзей",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "Используй этот пригласительный код <span class='green bold'><%=count%> GTO</span> ",
        "邀请好友赢大奖": "Пригласи друзей и выиграй грандиозный приз",
        "邀请码不存在": "Неверный пригласительный код ",
        "重新加载": "Перезагрузить",
        "页": "Страница",
        "首页": "Главная страница",
        "马上去参与": "Присоединяйся сейчас!",
        "马上去竞猜": "Сделать прогноз сейчас",
        "马上开始竞猜": "Сделать прогноз сейчас"
    },
    "thth": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1，สำหรับการเชิญแต่ละยูสเซอร์, คุณจะได้รับ<%=gto%>GTO，ต่อ<%=count%>ครั้ง",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. การเดาหัวข้อจะขึ้นอยู่กับการเลือกตัวเลือกของการแข่งขันที่เป็นที่นิยมและการเดาหัวข้อส่วนบุคคล @@@@ 2. ผลการเดาการแข่งขันยึดตามเวลาปกติ 90 นาทีของการเล่นและทดเวลาเพิ่ม; ไม่รวมการขอเวลานอกและ แตะลูกโทษ@@@@ 3 หากผลการแข่งขันไม่สามารถกำหนดได้เนื่องจากมีการงดเว้นการเล่นเกมการเปลี่ยนแปลงหรือเหตุผลพิเศษอื่น ๆ การเดาการแข่งขันจะถูกยกเลิกและเงินทั้งหมดจะถูกส่งคืนให้กับผู้ใช้ @@@@ 4 อัตราต่อรองในหน้านี้ใช้สำหรับการอ้างอิงเท่านั้นอัตราต่อรองจริงจะขึ้นอยู่กับรายละเอียดการสั่งซื้อ",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2，แต่ล่ะครั้งที่ผู้ถูกเชิญเดาถูก，ผู้เชิญจะได้รับรางวัล",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "คุณสามารถวางการเดา <%=count%> ได้ในการแข่งขันนี้",
        "<%=count%>次奖励发放如下：": "<%=count%>รางวัลที่ได้ดังนี้: ",
        "<%=count%>竞猜记录": "บันทึกการเดาของ<%=count%>",
        "<%=name%>暂时没有贡献": "<%=name%> ปัจจุบันไม่มีส่วนร่วม",
        "<%=name%>的邀请码": "รหัสการเชิญของ<%=name%>",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> สนับสนุน <span><%=gto%> GTO</span><span><%=eth%> ETH</span><span><%=uz%> iเพชร</span>.",
        "<em><%=name%></em>的房间": "ห้องของ<em><%=name%></em> ",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p> ซื้อ GTO ณ ที่แลกเปลี่ยน </ p> <p> โอนไปยังที่อยู่ของกระเป๋าสตางค์ของ Gifto ของผู้ใช้ปัจจุบัน </ p> <p> ไปดูที่อยู่กระเป๋าสตางค์ตอนนี้หรือไม่? </ p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p> โอน ETH ไปยังที่อยู่กระเป๋าสตางค์ของ GIFTO </ p> <p> ดูที่กระเป๋าสตางค์ตอนนี้หรือไม่? </ p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@ การเดาฟุตบอลถูกสร้างขึ้นบนฐานการไลฟสดของ Uplive ผู้ใช้สามารถชนะเงินคริปโท โดยคาดการณ์ผลการแข่งขันฟุตบอลได้อย่างแม่นยำ @@@@ 1 คุณสามารถเลือกจากการเดา 3 ครั้งต่อการแข่งขันชนะ,เสมอ,แพ้ ทุกทางเลือกมีอัตราต่างกัน @@@@ 2 ขนาดตัวคูณมีสัดส่วนผกผันกับความแรงของทีม ทีมยิ่งแข็งแกร่งขึ้นตัวคูณยิ่งเล็กลง คุณสามารถตัดสินใจได้ว่าใครมีโอกาสที่จะได้รางวัลมากขึ้น @@@@ 3 การเดา ต้องมีการลงทุนจำนวนหนึ่งของเงินคริปโทฐานสนับสนุน Uเพชร, GTO และ ETH @@@@ 4 หลังจากที่คุณได้สั่งซื้อแล้วคุณสามารถเลือกจากการจับคู่หรือตรวจสอบรายละเอียดการสั่งซื้อของคุณได้ @@@@ 5 หากผลการแข่งขันตรงกันกับการเดาของคุณแล้ว, ขอแสดงความยินดีคุณจะชนะรางวัลที่ตรงกัน! ทำให้การเดาตอนนี้ชนะ!",
        "U钻": "Uเพชร",
        "上一页": "หน้าที่แล้ว",
        "下一页": "หน้าต่อไป",
        "下拉更新": "เลื่อนลงเพื่อรีเฟรช",
        "下载": "ดาวน์โหลด",
        "不中返本金": "ไม่สามารถย้อนกลับหน้าหลักได้หากไม่ชนะ",
        "不中返还": "ไม่สามารถย้อนกลับหน้าหลักได้หากไม่ชนะ",
        "不再提示": "ไม่ต้องเตือนอีก",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "ของขวัญสำหรับworld cupมาไม่ขาดสาย<br>ทายผลการแข่งขัน ได้รางวัลชิวๆ",
        "两个用户不能相互绑定邀请码,请重新填写": "คุณไม่สามารถอ้างอิงดดยเพื่อนที่คุณอ้างอิงแล้ว, กรุณาเลือกเพื่อนคนอื่น",
        "中奖计算": "คำนวณผลชนะ",
        "主胜": "ทีมเจ้าบ้านชนะ",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "เรียน <%=username%>， ขอแสดงความยินดีด้วยการเดาฟุตบอลของคุณชนะ，ได้รับรางวัล <%=count%> <%=currency%>",
        "充值": "เติมเงิน",
        "全选": "เลือกทั้งหมด",
        "全部": "ยอดรวม",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "รวมทั้งหมด<%=count%>ข้อ<span class=\"cur-page-box\">ตอนนี้หน้า<%=curPage%>/<%=pages%></span>",
        "关于我们": "เกี่ยวกับเรา",
        "分享到Facebook": "แชร์ไปยัง Facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "เปลี่ยนช่องทางการเติมเงิน, รวมตัวเลือก: <p class='green'>GTO, ETH และ Uเพชร</p>",
        "切换语言": "เปลี่ยนภาษา",
        "切换语言版本": "เปลี่ยนภาษา",
        "加载中……": "กำลังโหลด",
        "单个玩法竞猜金额超出上限": "ค่าธรรมเนียมการเดาของเกมเดี่ยวเกินขีดจำกัดแล้ว",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "เมื่อจำนวนโบนัสในเกมเดียวเกินจำนวนที่กำหนด, ฝ่ายบริการลูกค้าจะส่งรางวัลด้วยตนเอง โปรดรอสักครู่หรือติดต่อเราเมื่อมีคำถาม.",
        "单次最大可投<%=count%><%=unit%>": "คุณสามารถเดิมพันมากที่สุดในครั้งนี้คือ<%=count%><%=unit%>",
        "单次竞猜金额超出上限": "ค่าธรรมเนียมการเดาเดี่ยวเกินขีดจำกัดแล้ว",
        "去充值": "เติมเงิน",
        "去登录": "เข้าระบบ",
        "参与成功": "ขอบคุณสำหรับการเดา",
        "参与详情": "รายละเอียดการเข้าร่วมแข่งขัน",
        "反选": "ย้อนกลับ",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "ข้อกำหนดและเงื่อนไข: ทุกครั้งที่ผู้ถูกเชิญร่วมการเดา, ผู้ที่ทำการเชิญจะได้รับรางวัล!",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "ตามกฎหมายกำหนด，แอฟนี้ยังไม่สามารถใช้ได้ในเขตพื้นที่นี้",
        "同一台设备不可多次绑定邀请码": "อุปกรณ์เครื่องเดียวกันไม่สามารถผูกรหัสคำเชิญได้หลายครั้ง",
        "含获赠的": "รวมที่ได้รับ",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "ในการแข่งขัน<%=hostname%>vs<%=guestname%>，คุณสามารถเดิมพันมากที่สุดได้อีก<%=max%><%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "คุณจะได้รับ <%=count%> รางวัล GTO,  เมื่อคุณสร้างขอบเขตของรหัสการเชิญสำเร็จ. ",
        "复制成功": "คัดลอกสำเร็จ",
        "复制邀请地址": "คัดลอกลิ้งค์",
        "大奖派发": "การกระจายรายได้",
        "奖励": "รางวัล",
        "好友猜中比赛后，你也可以获得奖励哦~~": "เมื่อพวกเขาวางการคาดการณ์ไว้, คุณจะสามารถชนะรางวัลได้ด้วย ! ",
        "如何邀请？": "วิธีการเชิญ?",
        "客胜": "ทีมผู้มาเยือนชนะ",
        "小视频": "วีดีโอสั้น",
        "尾页": "หน้าสุดท้าย",
        "已中奖": "ชนะ",
        "已使用": "ใช้แล้ว",
        "已取消": "ยกเลิกแล้ว",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "คัดลอกที่อยู่การเชิญของคุณสำเร็จy~<br / >ส่งถึงเพื่อนคุณและชวนพวกเขมาร่วมเล่นด้วยกัน!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "การแข่งขันใด ๆ ไม่ได้รับการเดาอีกต่อไป <br/> กรุณารีเฟรชตัวเลือกการจับคู่ของคุณ",
        "已选<%=count%>场比赛": "เลือก <%=count%> ที่เลือกของการแข่งขัน",
        "帮助": "ช่วย",
        "平": "เสมอ",
        "平局": "เสมอ",
        "开赛": "เริ่มการแข่งขัน ",
        "当前是最后一页": "ตอนนี้เป็นหน้าสุดท้าย",
        "当前是第一页": "ตอนนี้เป็นหน้าแรก",
        "待揭晓": "จะทำการประกาศ",
        "快来和我一起赢大奖吧": "สิทธิประโยชน์ที่ดี, มาร่วมสนุกและชนะรางวัล ETH กับฉัน.",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "ยินดีด้วยคุณ <%=name%>ได้เชิญเพื่อนสำเร็จแล้วและได้รับ <%=count%> GTO",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "ยินดีด้วยคุณ <%=name%> ได้รับ<span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "รหัสการเชิญแบบจำกัด",
        "您最多还能投<%=max%><%=unit%>": "คุณสามารถเดิมพันมากที่สุดได้<%=max%><%=unit%>",
        "您的<%=type%>不足": "<%=type%> ยอดคงเหลือของคุณไม่เพียงพอ",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "รหัสคำเชิญที่ถูกต้อง <p> คุณจะได้รับ <span class = 'green bold'> <%=count%> GTO </ span> ทันที </ p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "แนะนำเพื่อน,ชนะ <%=count%> GTOs!",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "ถ้าคุณแนะนำเพื่อน,ชนะ <%=count%> GTO!",
        "我已成功邀请<%=count%>个好友": "ฉันเชิญเพื่อน<%=count%>สำเร็จ",
        "我的收益": "รายได้ของฉัน",
        "我的订单": "การสั่งของตัวเอง",
        "我的贡献": "การสนับสนุนของฉัน",
        "我的邀请码": "รหัสการเชิญของฉัน",
        "我邀请的好友": "การแนะนำของฉัน",
        "截止": "หมดเวลาการขาย",
        "抱歉,没有更多数据啦~": "ขอโทษด้วย, ไม่มีข้อมูลแล้ว",
        "提交": "เข้า",
        "提示：即使活动结束，此奖励政策依然有效。": "หมายเหตุ：แม้ว่ารายการนี้จะจบ，นโยบายการได้รางวัลยังคงใช้ได้。",
        "支持GTO、ETH、U钻": "สนับสนุนGTO、ETH、Uเพชร",
        "收益": "รายได้",
        "收益明细": "รายละเอียดรายได้",
        "收起": "ล้มละลาย",
        "时间": "เวลา",
        "星期一": "วันจันทร์",
        "星期三": "วันพุธ",
        "星期二": "วันอังคาร",
        "星期五": "วันศุกร์",
        "星期六": "วันเสาร์",
        "星期四": "วันพฤหัสบดี",
        "星期日": "วันอาทิตย์",
        "暂无记录": "ไม่มีบันทึก",
        "暂无赛事": "ปัจจุบันไม่มีการแข่งขัน",
        "更新中": "กำลังรีเฟรช",
        "最多选择8场比赛": "คุณสามารถเลือกได้มากที่สุด 8 รายการ",
        "最新中奖名单": "รายการสุดท้ายของผู้ชนะ",
        "服务器链接中断!": "การเชื่อมต่อเสียหาย!",
        "未中奖": "ไม่ชนะ",
        "未使用": "ไม่ได้ใช้แล้ว",
        "松开更新": "จบการเลื่อนลงเพื่อรีเฟรช",
        "查看你的竞猜记录": "ตรวจสอบการเดาย้อนหลัง",
        "查看全部": "ตรวจสอบทั้งหมด",
        "查看我邀请的好友": "ตรวจสอบการอ้างอิงของฉัน",
        "查看明细": "ตรวจสอบรายละเอียด",
        "查看竞猜玩法规则": "ดูกฎของเกมการเดา",
        "查看竞猜记录": "ตรวจสอบการเดาย้อนหลัง",
        "正在加载": "กำลังโหลด",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "ยูสเซอร์แต่ล่ะคนมีหน้าเพ็จการเชิญ, แชร์หน้าเพ็จกับคนอื่น, และถ้ายูสเซอร์ใหม่ทำการสมัครภายใน 24 ชม, ด้วยรหัสการเชิญของคุณ, คุณจะได้ Gifto!",
        "比赛已停止竞猜": "การส่งการเดาของเกมนี้ได้ปิดไปแล้ว",
        "比赛已取消": "ยกเลิกการแข่งขันแล้ว",
        "比赛结果:": "ผลการแข่งขัน",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "GTO ทั้งหมดที่ได้รับรางวัลผ่านโปรแกรมแนะนำจะใช้การเดาเท่านั้น, คุณจะไม่สามารถแลกหรือถอนได้. หลังจากชนะ, GTOs จะกลายเป็น GTO ที่ใช้งานตามปกติ",
        "消耗": "การจ่าย",
        "清空": "ไม่มีข้อมูล",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "ฐานการเดาฟุตบอลสุอฮิต, ลงทะเบียนและผูกรหัสคำเชิญของฉันเพื่อชนะรางวัล!",
        "点击复制": "คัดลอกลิ้งก์",
        "热门直播": "ไลฟ์ฮิต",
        "特别提醒：": "คำเตือนพิเศษ",
        "猜中最大可获得": "รางสูงสุด",
        "猜中获得": "ชนะ",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "เงินรางวัลที่ได้จากการเดา = จำนวนรวมของการวางเดิมพันหลักxราคาต่อรองสำหรับการชนะ",
        "猜中记录": "การเดาที่ถูกต้อง",
        "玩法": "วิธีเล่น",
        "玩法规则": "กฎของการเล่น",
        "用户网络不稳定": "เครือข่ายไม่เสถียร",
        "登出": "กดออก",
        "登录": "เข้าระบบ",
        "登录后才能执行此操作": "กรุณาเข้าสู่ระบบก่อน!",
        "知道了": "ฉันเข้าใจแล้ว",
        "确定": "ยืนยัน",
        "禁止绑定自己邀请码": "ไม่สามารถใช้รหัสการเชิญของคุณได้",
        "立即参与": "เข้าร่วมตอนนี้!",
        "立即邀请好友，赢大奖": "เชิญชวนเพื่อน, ชนะรางวัล!",
        "竞猜下单赠送": "รางวัลมาจากเพื่อนของคุณได้ทำการเดา",
        "竞猜中奖赠送": "รางวัลมาจากการเดาที่ถุกต้องของเพื่อนคุณ",
        "竞猜介绍": "การเดาเบื้องต้น",
        "竞猜内容": "รายละเอียดการเดา",
        "竞猜方式": "วิธีการเดา",
        "竞猜时间": "เวลาการเดา",
        "第<%=count%>次奖励": "<%=count%> รางวัล",
        "筛选": "ตรงกับการเดา",
        "类型": "ลักษณะ",
        "绑定成功立即获得<%=count%>GTO": "รับ <% = count%> GTO เพื่ออ้างอิงได้สำเร็จ",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "ผูกกับบัญชีนี้สำเร็จแล้วได้รับ<%=count%>GTOทันที，ยูสเซอร์ทุกคนมีรหัสคำเชิญส่วนตัว，รีบไปขอรหัสคำเชิญของเพื่อนกันเถอะ!",
        "绑定邀请码": "ซ่อนรหัสคำเชิญ",
        "绑定邀请码成功!": "ขอบเขตรหัสการเชิญสำเร็จ!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "รางวัลGTOที่ได้รับสามารถใช้ได้เฉพาะสำหรับการทำเดาและการถ่ายโอนและการนำเสนอเท่านั้น!",
        "继续参与": "ดำเนินการเดาต่อ",
        "继续游戏": "เล่นต่อ",
        "网络有点问题哦": "เครือข่ายเสียหาย",
        "网络连接异常": "การเชื่อมต่อเครือข่ายไม่เสถียร",
        "联系我们": "ติดต่อเรา",
        "胜": "ชนะ",
        "胜平负": "ทำนายว่าชนะ,เสมอ, หรือแพ้ต่อทีมเจ้าบ้าน",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "สำหรับในแต่ล่ะครั้งที่ผู้ถูกเชิญทำการเดาได้ถูกต้องภายใน 6 เดือนแรกของการอ้างอิง, ผู้เชิญจะได้รับ 3% จากผลรวมชนะของผู้ถูกเชิญ. เงินรางวัลพิเศษนี้จะออกโดยแอฟและไม่มีผลกระทบกับการชนะของผู้ถูกเชิญ",
        "获得": "ชนะ",
        "获得<%=count%>个<%=currency%>": "ชนะ <%=count%> <%=currency%>",
        "被邀请人奖励：": "รางวัลของผู้ถูกเชิญ",
        "设备标识为空": "อุปกรณ์เครื่องมีปัญหา",
        "话题竞猜": "หัวข้อการเดา",
        "该浏览器不支持自动复制": "เบราว์เซอร์ไม่รองรับการคัดลอกอัตโนมัติ",
        "详情": "รายละเอียด",
        "请您至少选择一场比赛": "กรุณาเลือกอย่างน้อย1รายการ",
        "请输入正确页码": "กรุณาใส่เลขหน้าที่ถูกต้อง",
        "请输入邀请码": "กรุุณากรอกรหัส",
        "请选择最小筹码": "กรุณาเลือกแต้มต่อที่น้อยที่สุด",
        "负": "แพ้",
        "贡献用户": "ผู้สนับสนุน",
        "赛事竞猜": "หมดการขาย",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "ผลการเดาการแข่งขันยึดตามเวลาปกติ 90 นาทีของการเล่นและทดเวลาเพิ่ม; ไม่รวมการขอเวลานอกและ แตะลูกโทษ",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "ผลลัพธ์ของเกมขึ้นอยู่กับเวลาปกติในการเล่นคือ 90 นาที",
        "赢<%=count%>倍": "ชนะ<%=count%>ครั้ง",
        "足球竞猜": "การเดาฟุตบอล",
        "跳转": "ไปยัง",
        "输入内容不能为空": "ข้อความป้อนต้องไม่ว่าง",
        "输入的邀请码为空": "ไม่ได้เขียนรหัสคำเชิญ",
        "返还": "ย้อนกลับ",
        "选好了": "เรียบร้อย",
        "选择国家或地区": "กรุณาเลือกประเทศของคุณหรือภูมิภาค",
        "选择语言": "เลือกภาษา",
        "邀请人奖励：": "รางวัลของผู้ถูกเชิญ",
        "邀请好友": "เชิญเพื่อน",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "ใช้รหัสอ้างอิงนี้เพื่อเชิญเพื่อนและสามารถชนะ <span class = 'green bold'> <%=count%> GTO </ span>",
        "邀请好友赢大奖": "ชวนเพื่อนลุ้นรับรางวัล",
        "邀请码不存在": "รหัสการเชิญไม่ถูกต้อง",
        "重新加载": "โหลด",
        "页": "หน้า",
        "首页": "หน้าแรก",
        "马上去参与": "เข้าร่วมตอนนี้!",
        "马上去竞猜": "เริ่มการเดาตอนนี้",
        "马上开始竞猜": "เริ่มการเดาตอนนี้ี้"
    },
    "vivn": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1. Mời thành công một người bạn sẽ nhận được <%=gto%> GTO，chia ra gửi trong <%=count%> lần ",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1. Tỉ lệ dự đoán của những trận đấu được đưa ra đều được tính toán dựa trên kết quả thực tế;@@@@2. Kết quả chung cuộc là kết quả của trận đấu kéo dài trong 90 phút (đã bao gồm thời gian xử lý chấn thương, không tính hiệp phụ và đá phạt đền). @@@@3. Nếu trận đấu xảy ra những vấn đề như dừng trận đấu giữa hiệp, đấu lại, thay đổi đội hình, hoặc những tình huống đặc biệt khác gây ra khó khăn trong việc phân định thắng thua thì sẽ hủy kết quả dự đoán của trận đó, số tiền người chơi dự đoán sẽ được hoàn trả. @@@@4. Tỉ lệ dự đoán ở trang chủ chỉ mang tính chất tham khảo, tỉ lệ dự đoán sẽ dược tính theo số tiền dự đoán so với tỉ lệ dự đoán của người chơi. ",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2. Một khi người được mời chơi dự đoán chính xác, chương trình sẽ trao giải thưởng",
        "<%=count%>GTO": "<%=count%> GTO",
        "<%=count%>场比赛可投": "Có thể dự đoán <%=count%> trận đấu",
        "<%=count%>次奖励发放如下：": "<%=count%> phần thưởng được phát như sau:",
        "<%=count%>竞猜记录": "Lịch sử dự đoán của <%=count%> ",
        "<%=name%>暂时没有贡献": "<%=name%> tạm thời chưa cống hiến",
        "<%=name%>的邀请码": "Mã giới thiệu của <%=name%>",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%> cống hiến <span><%=gto%> GTO</span><span><%=eth%>ETH</span><span><%=uz%> KC </span>",
        "<em><%=name%></em>的房间": "Phòng của <em><%=name%></em>",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Trên sàn giao dịch GTO mua,</p><p>có thể chuyển khoản đến địa chỉ ví Gifto hiện tại của người chơi ，</p><p> Kiểm tra địa chỉ ví Gifto ngay? </p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>Chỉ cần chuyển ETH đến địa chỉ ví Gifto hiện tại của người chơi，</p><p> Kiểm tra địa chỉ ví Gifto ngay? </p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@ Dự Đoán Bóng Đá, thuộc một trong những lĩnh vực game của Uplive, người chơi có thể thông qua việc dự đoán kết quả trận bóng để nhận được những đồng tiền ảo thật dễ dàng. @@@@1. Thông thường một trận đấu sẽ có 3 mục để chọn, Đội chủ nhả thắng, Hòa, Đội khách thắng, mỗi mục chọn đều có hệ số trúng thưởng khác nhau. @@@@2. Hệ số tiền thưởng sẽ tỷ lệ nghịch với sức mạnh của đội bóng, thực lực đội bóng càng mạnh thì hệ số tiền thưởng càng nhỏ. Bạn có thể tự đưa ra phán đoán của mình, rốt cuộc bên nào có tỷ lệ chiến thắng cao hơn. @@@@3. Để đặt dự đoán thì phải đặt một lượng đồng tiền ảo nhất định, trò chơi có hỗ trợ các loại tiền KC/ GTO/ ETH. @@@@4. Sau khi đặt dự đoán thành công, bạn có thể tiếp tục đặt dự đoán, cũng có thể xem chi tiết đặt dự đoán trước đó.@@@@5. Nếu kết quả trận đấu giống với dự đoán của bạn, thì xin chúc mừng bạn sẽ nhận được phần thưởng tương ứng.\n@@@@ Còn giờ thì mời bạn đến với trò chơi \"Dự Đoán Bóng Đá\", để dành lấy phần thưởng nhé~",
        "GTO投注量": "Số GTO đặt vào",
        "U钻": "KC",
        "U钻投注量": "Số kim cương đặt:",
        "U钻投注量奖励": "Số kim cương thắng được",
        "上一页": "Trang trước",
        "下一页": "Trang sau",
        "下拉更新": "Kéo xuống để cập nhật",
        "下载": "Tải xuống",
        "不中返本金": "Không trúng sẽ hoàn vốn",
        "不中返还": "Không hoàn lại",
        "不再提示": "Không hiển thị nữa",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "Quà Event World Cup cực nhiều <br> Cứ đoán đi bạn, Quà khủng chờ bạn",
        "两个用户不能相互绑定邀请码,请重新填写": "Người này bạn đã mời, xin hãy chọn người khác",
        "中奖计算": "Cách tính phần thưởng",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Nhằm tri ân khách hàng mới lẫn cũ, tich lũy 1 số lượng GTO nhất định trong thời gian diễn ra Event (Không bao gồm số GTO mời bạn, mở Lì xì, bạn bè dự đoán trúng mà có), bạn sẽ nhận được lượng GTO tương ứng, đặt càng nhiều phần thưởng càng hấp dẫn. Phần thưởng sẽ được phát sau 7 ngày làm việc kể từ khi kết thúc Event. ",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "Để cảm ơn sự ủng hộ của user đối với game \"Dự đoán bóng đá\", trong thời gian diễn ra hoạt động, khi số lượng kim cương đạt cược đạt được số lượng như quy định (không tính số kim cương đạt được nhờ thắng cược hoặc nhận từ nhiệm vụ mời bạn), sẽ nhận được phần thưởng tương ứng, đạt càng nhiều nhận thưởng càng nhiều. Giải thưởng sẽ được trao trong vòng 7 ngày làm việc sau khi hoạt động kết thúc.",
        "主胜": "Tỷ lệ thắng",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "Honey<%=username%>, chúc mừng  bạn đã thắng rồi, bạn sẽ nhận được <%=count%> <%=currency%>",
        "充值": "Nạp tiền",
        "全选": "Chọn hết ",
        "全部": "Toàn bộ trận đấu dự đoán",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "Tổng cộng <%=count%>trang lịch sử <span class=\"cur-page-box\"> hiện tại ở trang thứ<%=curPage%>/<%=pages%></span>",
        "关于我们": "Về chúng tôi",
        "分享到Facebook": "Chia sẻ trên Facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "Thay đổi phương thức thanh toán, có thể chọn cách thức sau: <p class='green'>GTO、ETH、KC</p>",
        "切换语言": "Thay đổi ngôn ngữ",
        "切换语言版本": "Thay đổi ngôn ngữ",
        "加载中……": "Đang tải",
        "单个玩法竞猜金额超出上限": "Bạn đã đặt dự đoán lớn hơn mức quy định",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "Nếu số tiền dự đoán của người chơi quá lớn, thì phần thưởng được trao tận tay thông qua công ty, nếu có thắc mắc xin liên hệ CS để được biết thêm chi tiết.",
        "单次最大可投<%=count%><%=unit%>": "Mức dự đoán lớn nhất có thể lên đến <%=count%><%=unit%>",
        "单次竞猜金额超出上限": "Số tiền dự đoán mỗi lượt đã vượt mức quy định",
        "去充值": "Nạp tiền",
        "去登录": "Đăng nhập",
        "参与成功": "Tham gia thành công",
        "参与详情": "Chi tiết trận đấu",
        "反选": "Bỏ chọn",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "Điều kiện phát thưởng: người chơi được mời mỗi khi gửi dự đoán thành công, sẽ được nhận một phần thưởng",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "Do hạn chế bởi pháp luật của khu vực, game này không thể triển khai trên khu vực đó.",
        "可领取奖励": "Phần thưởng được nhận",
        "可领取奖励：": "Phần thưởng được nhận là:",
        "同一台设备不可多次绑定邀请码": "Cùng một thiết bị không thể có nhiều mã xác minh",
        "含获赠的": "Đã bao gồm",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "Trong trận đấu <%=hostname%>vs<%=guestname%>, bạn còn có thể dự đoán <%=max%><%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "Sau khi xác minh mã giới thiệu thành công，có thể nhận ngay <%=count%> GTO。",
        "复制成功": "Sao chép thành công",
        "复制邀请地址": "Sao chép địa chỉ",
        "大奖派发": "Trao giải",
        "奖励": "Phần thưởng",
        "奖励规则如下：": "Thể lệ như sau:",
        "好友猜中比赛后，你也可以获得奖励哦~~": "Bạn bè dự đoán chính xác, thì bạn cũng được nhận thưởng đó~~",
        "如何邀请？": "Mời như thế nào?",
        "客胜": "Tỷ lệ thắng ",
        "小视频": "Video ngắn",
        "尾页": "Trang cuối",
        "已中奖": "Đã trúng thưởng",
        "已使用": "Đã sử dụng",
        "已取消": "Đã hủy",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "Đã khôi phục thành công địa chỉ của bạn ~<br/> Hãy nhanh tay gửi yêu cầu mời bạn bè cùng tham nhé!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "Đã hết thời gian dự đoán <br/> Chọn lại trận đấu khác",
        "已选<%=count%>场比赛": "Đã chọn <%=count%> trấn đấu",
        "帮助": "Trợ giúp",
        "平": "Hòa",
        "平局": "Hòa ",
        "开赛": "Bắt đầu",
        "当前是最后一页": "Hiện đang ở trang cuối cùng",
        "当前是第一页": "Hiện đang ở trang đầu tiên",
        "待揭晓": "Trận đấu đang diễn ra",
        "快来和我一起赢大奖吧": "Phần thưởng khủng, hãy nhanh chân cùng tôi thắng giải thưởng ETH",
        "总投注额10%": "10% tổng số đặt vào",
        "总投注额15%": "15% tổng số đặt vào",
        "总投注额20%": "20% tổng số đặt vào",
        "总投注额25%": "25% tổng số đặt vào",
        "总投注额3%": "3% tổng giá trị đặt",
        "总投注额30%": "30% tổng số đặt vào",
        "总投注额5%": "  5% tổng số đặt vào",
        "总投注额8%": "  8% tổng số đặt vào",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "Chúc mừng <%=name%> đã mời bạn thành công và nhận được <%=count%> GTO",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "Chúc mừng <%=name%> nhận được <span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "Bạn đã xác minh mã giới thiệu",
        "您最多还能投<%=max%><%=unit%>": "Bạn còn có thể dự đoán <%=max%><%=unit%>",
        "您的<%=type%>不足": "<%=type%> của bạn không dủ",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "Đã xác minh thành công, <p> có thể nhận ngay <span class='green bold'><%=count%> GTO </span></p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "Xác nhận mã giới thiệu thành công, có thể nhận ngay <%=count%> GTO",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "Mời bạn bè thành công, có thể nhận ngay <%=count%> GTO",
        "我已成功邀请<%=count%>个好友": "Tôi đã mời thành công <%=count%> người bạn",
        "我的投注量：": "Số lượng đặt của bạn:",
        "我的收益": "Lợi nhận của tôi",
        "我的订单": "Lịch sử dự đoán",
        "我的贡献": "Cống hiến của tôi",
        "我的邀请码": "Mã giới thiệu của tôi",
        "我邀请的好友": "Người bạn mà tôi mời",
        "截止": "Hết thời gian dự đoán",
        "投注越多 奖励越丰厚": "Đặt càng nhiều phần thưởng càng hấp dẫn",
        "抱歉,没有更多数据啦~": "Thật đáng tiếc, dữ liệu không còn nữa",
        "排行榜": "BXH",
        "提交": "Xác minh",
        "提示：即使活动结束，此奖励政策依然有效。": "Nhắc nhở: Dù cho Event kết thúc, chính sách giải thưởng vẫn còn hiệu lực",
        "支持GTO、ETH、U钻": "Hỗ trợ GTO、ETH、KC",
        "收益": "Lợi nhuận",
        "收益明细": "Chi tiết lợi nhuận",
        "收起": "Cất vào",
        "时间": "Thời gian",
        "星期一": "Thứ Hai",
        "星期三": "Thứ Tư",
        "星期二": "Thứ Ba",
        "星期五": "Thứ Sáu",
        "星期六": "Thứ Bảy",
        "星期四": "Thứ Năm",
        "星期日": "Chủ Nhật",
        "暂无满足奖励条件的用户": "Tạm thời bạn chưa thỏa mãn yêu cầu nhận thưởng",
        "暂无记录": "Tạm thời chưa có lịch sử",
        "暂无赛事": "Tạm thời chưa có trận đấu",
        "更新中": "Đang cập nhật",
        "最多选择8场比赛": "Không thể chọn hơn 8 trận đấu",
        "最新中奖名单": "Danh sách trúng thưởng mới nhất",
        "服务器链接中断!": "Ngắt liên kết với máy chủ",
        "未中奖": "Chưa trúng thưởng",
        "未使用": "Chưa sử dụng",
        "松开更新": "Bật cập nhật",
        "查看你的竞猜记录": "Tra lịch sử dự đoán",
        "查看全部": "Tra toàn bộ",
        "查看我邀请的好友": "Tra bạn bè mà tôi mời",
        "查看明细": "Xem chi tiết",
        "查看竞猜玩法规则": "Xem thể lệ trò chơi",
        "查看竞猜记录": "Tra lịch sử dự đoán",
        "正在加载": "Đang tải",
        "此邀请码绑定人数已达上限": "Không thể mời thêm do số lượng đã đạt mức tối đa",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "Mỗi một trò chơi, người chơi sẽ có trang mời bạn riêng (bao gồm mã giới thiệu), gởi lời mời bạn bè cho người chơi khác và người chơi mới đó phải đăng ký trong vòng 24h và sử dụng mã giới thiệu, tức là đã xác minh thành công.",
        "比赛已停止竞猜": "Đã hết thời gian dự đoán ",
        "比赛已取消": "Trận đấu đã hhủy",
        "比赛结果:": "Kết quả trận đấu:",
        "没有权限，如有疑问请联系客服！": "Không đủ điều kiện tham gia, xin vui lòng liên hệ CS để biết thêm thông tin.",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "Những đồng GTO được nhận trong Event, chỉ có thể dùng để dự đoán, không thể rút tiền mặt hoặc chuyển khoản. Sau khi trúng thưởng, sẽ trở  thành GTO thông dụng.",
        "活动时间：": "Thời gian:",
        "消耗": "Số tiền đặt",
        "清空": "Dọn sạch.",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "Sân chơi dự đoán bóng đá siêu Hot, những khoảng khác cảm xúc dâng trào, đăng ký và xác nhận ngay mã giới thiệu của bạn để được nhận thưởng nhé!",
        "点击复制": "Nhấp sao chép",
        "热门直播": "Trực tiếp",
        "特别提醒：": "Chú ý:",
        "猜中最大可获得": "Giải đặc biệt",
        "猜中获得": "Đoán trúng có thưởng",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "Số tiền trúng thưởng = Tổng số tiền dự đoán x tỉ lệ dự đoán",
        "猜中记录": "Lịch sử thắng dự đoán",
        "玩法": "Kiểu dự đoán",
        "玩法规则": "Thể lệ",
        "用户名": "User",
        "用户网络不稳定": "Đường truyền không ổn định",
        "登出": "Đăng xuất",
        "登录": "Đăng nhập",
        "登录后才能执行此操作": "Sau khi đăng nhập mới được thao tác",
        "知道了": "OK",
        "确定": "Xác nhận",
        "禁止绑定自己邀请码": "Không được nhập mã giới thiệu của mình",
        "立即参与": "Tham gia ngay",
        "立即参与竞猜": "Tham gia dự đoán ngay",
        "立即邀请好友，赢大奖": "Mời bạn thân, rinh quà lớn",
        "竞猜下单赠送": "Gửi dự đoán",
        "竞猜中奖赠送": "Gửi phần thưởng dự đoán chính xác",
        "竞猜介绍": "Giới thiệu dự đoán",
        "竞猜内容": "Nội dung dự đoán",
        "竞猜排行榜": "BXH Dự Đoán",
        "竞猜方式": "Loại tiền hỗ trợ",
        "竞猜时间": "Thời gian dự đoán",
        "第<%=count%>次奖励": "Phần thưởng lần thứ <%=count%>",
        "筛选": "Chọn lọc",
        "类型": "Diễn biến",
        "绑定成功立即获得<%=count%>GTO": "Xác nhận thành công có thể nhận ngay <%=count%> GTO",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "Xác minh thành công lập tức nhận được <%=count%> GTO, mỗi người chơi đều có 1 mã giới thiệu riêng, hãy nhanh tay mời bạn bè cùng tham gia nhé",
        "绑定邀请码": "Xác minh mã giới thiệu",
        "绑定邀请码成功!": "Xác nhận mã giới thiệu thành công!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "Phần thưởng GTO chỉ có thể dùng trong Dự Đoán Bóng Đá, không thể chuyển khoản hoặc rút tiền mặt ",
        "继续参与": "Đăt dự đoán tiếp",
        "继续游戏": "Tiếp tục trò chơi",
        "网络有点问题哦": "Mạng bị lỗi",
        "网络连接异常": "Đường truyền không ổn định",
        "联系我们": "Liện hệ",
        "胜": "Thắng",
        "胜平负": "Kết quả",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "Sáu tháng kể từ lúc được mời tham gia, mỗi lần người được mời dự đoán chính xác, chương trình sẽ trao phần thưởng cho người mời, phần lợi nhuận cụ thể sẽ được chiếm 3% trong  phần thưởng của người được mời (khoàng chênh lệch giữa tiền thưởng và số tiền dự đoán), phần thưởng này do chương trình trao tặng, không làm ảnh hưởng đến lợi ích của người được mời.",
        "获得": "Được nhận",
        "获得<%=count%>个<%=currency%>": "Được nhận <%=count%> <%=currency%>",
        "被邀请人奖励：": "Phần thưởng cho người được mời:",
        "设备标识为空": "Để trống đánh dấu thiết bị",
        "话题竞猜": "Chủ đề dự đoán",
        "该浏览器不支持自动复制": "Trình duyệt này không hỗ trợ sao chép tự động",
        "详情": "Chi tiết",
        "请您至少选择一场比赛": "Bạn hãy chọn ít nhất một mục",
        "请输入正确页码": "Xin vui lòng nhập mật khẩu",
        "请输入邀请码": "Hãy nhập mã giới thiệu",
        "请选择最小筹码": "Bạn hãy chọn mức dự đoán thấp nhất",
        "负": "Thua",
        "贡献用户": "Người chơi cống hiến",
        "赛事竞猜": "Dự đoán trận đấu",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "Kết quả chung cuộc là kết quả của trận đấu kéo dài trong 90 phút (đã bao gồm thời gian xử lý chấn thương, không tính hiệp phụ và đá phạt đền)",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "Kết quả trận đấu dựa trên kết quả mà bạn chọn sau 90 phút thi đấu (bao gồm thời gian xử lý chấn thương, không bao gồm hiệp phụ và phạt đền)",
        "赢<%=count%>倍": "Thắng được gấp <%=count%> lần",
        "足球竞猜": "Dự đoán bóng đá",
        "跳转": "Nhảy đến",
        "输入内容不能为空": "Không được để trống",
        "输入的邀请码为空": "Để trống mã xác minh",
        "返还": "Trờ về",
        "选好了": "Đã chọn xong",
        "选择国家或地区": "Chọn quốc gia hoặc khu vực",
        "选择登录方式": "Chọn hình thức đăng nhập",
        "选择语言": "Lựa chọn ngôn ngữ",
        "邀请人奖励：": "Phần thưởng từ việc mời bạn bè:",
        "邀请好友": "Mời bạn bè",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "Mời bạn bè xác minh mã giới thiệu thành công, có thể nhận được <span class='green bold'><%=count%> </span> GTO",
        "邀请好友赢大奖": "Mời bạn bè để cùng thắng giải nhất",
        "邀请码不存在": "Mã giới thiệu không chính xác",
        "重新加载": "Nhập lại",
        "页": "Trang",
        "首页": "Trang chủ",
        "马上去参与": "Tham gia ngay",
        "马上去竞猜": "Tham gia ngay",
        "马上开始竞猜": "Bắt đầu dự đoán"
    },
    "zhcn": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2，每次被邀请人竞猜中奖，平台发放奖励",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "<%=count%>场比赛可投",
        "<%=count%>次奖励发放如下：": "<%=count%>次奖励发放如下：",
        "<%=count%>竞猜记录": "<%=count%>竞猜记录",
        "<%=name%>暂时没有贡献": "<%=name%>暂时没有贡献",
        "<%=name%>的邀请码": "<%=name%>的邀请码",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>",
        "<em><%=name%></em>的房间": "<em><%=name%></em>的房间",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~",
        "GTO投注量": "GTO投注量",
        "U钻": "U钻",
        "U钻投注量": "U钻投注量",
        "U钻投注量奖励": "U钻投注量奖励",
        "上一页": "上一页",
        "下一页": "下一页",
        "下拉更新": "下拉更新",
        "下载": "下载",
        "不中返本金": "不中返本金",
        "不中返还": "不中返还",
        "不再提示": "不再提示",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "世界杯福利送不停<br>猜比赛结果，轻松赢大奖",
        "两个用户不能相互绑定邀请码,请重新填写": "两个用户不能相互绑定邀请码,请重新填写",
        "中奖计算": "中奖计算",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。",
        "主胜": "主胜",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "亲爱的<%=username%>，恭喜你的竞猜订单中奖啦，获得<%=count%><%=currency%>奖励",
        "充值": "充值",
        "全选": "全选",
        "全部": "全部",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>",
        "关于我们": "关于我们",
        "分享到Facebook": "分享到Facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>",
        "切换语言": "切换语言",
        "切换语言版本": "切换语言版本",
        "加载中……": "加载中……",
        "单个玩法竞猜金额超出上限": "单个玩法竞猜金额超出上限",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。",
        "单次最大可投<%=count%><%=unit%>": "单次最大可投<%=count%><%=unit%>",
        "单次竞猜金额超出上限": "单次竞猜金额超出上限",
        "去充值": "去充值",
        "去登录": "去登录",
        "参与成功": "参与成功",
        "参与详情": "参与详情",
        "反选": "反选",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "受当地法律政策限制，本产品在该地区暂不开放使用",
        "可领取奖励": "可领取奖励",
        "可领取奖励：": "可领取奖励：",
        "同一台设备不可多次绑定邀请码": "同一台设备不可多次绑定邀请码",
        "含获赠的": "含获赠的",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。",
        "复制成功": "复制成功",
        "复制邀请地址": "复制邀请地址",
        "大奖派发": "大奖派发",
        "奖励": "奖励",
        "奖励规则如下：": "奖励规则如下：",
        "好友猜中比赛后，你也可以获得奖励哦~~": "好友猜中比赛后，你也可以获得奖励哦~~",
        "如何邀请？": "如何邀请？",
        "客胜": "客胜",
        "小视频": "小视频",
        "尾页": "尾页",
        "已中奖": "已中奖",
        "已使用": "已使用",
        "已取消": "已取消",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "已经有比赛截止竞猜<br/>请重新选择比赛",
        "已选<%=count%>场比赛": "已选<%=count%>场比赛",
        "帮助": "帮助",
        "平": "平",
        "平局": "平局",
        "开赛": "开赛",
        "当前是最后一页": "当前是最后一页",
        "当前是第一页": "当前是第一页",
        "待揭晓": "待揭晓",
        "快来和我一起赢大奖吧": "快来和我一起赢大奖吧",
        "总投注额10%": "总投注额10%",
        "总投注额15%": "总投注额15%",
        "总投注额20%": "总投注额20%",
        "总投注额25%": "总投注额25%",
        "总投注额3%": "总投注额3%",
        "总投注额30%": "总投注额30%",
        "总投注额5%": "总投注额5%",
        "总投注额8%": "总投注额8%",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "恭喜<%=name%>获得<span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "您已绑定的邀请码",
        "您最多还能投<%=max%><%=unit%>": "您最多还能投<%=max%><%=unit%>",
        "您的<%=type%>不足": "您的<%=type%>不足",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "成功绑定邀请码，立即获得<%=count%>GTO奖励",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "成功邀请好友，立即获得<%=count%>GTO奖励",
        "我已成功邀请<%=count%>个好友": "我已成功邀请<%=count%>个好友",
        "我的投注量：": "我的投注量：",
        "我的收益": "我的收益",
        "我的订单": "我的订单",
        "我的贡献": "我的贡献",
        "我的邀请码": "我的邀请码",
        "我邀请的好友": "我邀请的好友",
        "截止": "截止",
        "投注越多 奖励越丰厚": "投注越多 奖励越丰厚",
        "抱歉,没有更多数据啦~": "抱歉,没有更多数据啦~",
        "排行榜": "排行榜",
        "提交": "提交",
        "提示：即使活动结束，此奖励政策依然有效。": "提示：即使活动结束，此奖励政策依然有效。",
        "支持GTO、ETH、U钻": "支持GTO、ETH、U钻",
        "收益": "收益",
        "收益明细": "收益明细",
        "收起": "收起",
        "时间": "时间",
        "星期一": "星期一",
        "星期三": "星期三",
        "星期二": "星期二",
        "星期五": "星期五",
        "星期六": "星期六",
        "星期四": "星期四",
        "星期日": "星期日",
        "暂无满足奖励条件的用户": "暂无满足奖励条件的用户",
        "暂无记录": "暂无记录",
        "暂无赛事": "暂无赛事",
        "更新中": "更新中",
        "最多选择8场比赛": "最多选择8场比赛",
        "最新中奖名单": "最新中奖名单",
        "服务器链接中断!": "服务器链接中断!",
        "未中奖": "未中奖",
        "未使用": "未使用",
        "松开更新": "松开更新",
        "查看你的竞猜记录": "查看你的竞猜记录",
        "查看全部": "查看全部",
        "查看我邀请的好友": "查看我邀请的好友",
        "查看明细": "查看明细",
        "查看竞猜玩法规则": "查看竞猜玩法规则",
        "查看竞猜记录": "查看竞猜记录",
        "正在加载": "正在加载",
        "此邀请码绑定人数已达上限": "此邀请码绑定人数已达上限",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。",
        "比赛已停止竞猜": "比赛已停止竞猜",
        "比赛已取消": "比赛已取消",
        "比赛结果:": "比赛结果:",
        "没有权限，如有疑问请联系客服！": "没有权限，如有疑问请联系客服！",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。",
        "活动时间：": "活动时间：",
        "消耗": "消耗",
        "清空": "清空",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！",
        "点击复制": "点击复制",
        "热门直播": "热门直播",
        "特别提醒：": "特别提醒：",
        "猜中最大可获得": "猜中最大可获得",
        "猜中获得": "猜中获得",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。",
        "猜中记录": "猜中记录",
        "玩法": "玩法",
        "玩法规则": "玩法规则",
        "用户名": "用户名",
        "用户网络不稳定": "用户网络不稳定",
        "登出": "登出",
        "登录": "登录",
        "登录后才能执行此操作": "登录后才能执行此操作",
        "知道了": "知道了",
        "确定": "确定",
        "禁止绑定自己邀请码": "禁止绑定自己邀请码",
        "立即参与": "立即参与",
        "立即参与竞猜": "立即参与竞猜",
        "立即邀请好友，赢大奖": "立即邀请好友，赢大奖",
        "竞猜下单赠送": "竞猜下单赠送",
        "竞猜中奖赠送": "竞猜中奖赠送",
        "竞猜介绍": "竞猜介绍",
        "竞猜内容": "竞猜内容",
        "竞猜排行榜": "竞猜排行榜",
        "竞猜方式": "竞猜方式",
        "竞猜时间": "竞猜时间",
        "第<%=count%>次奖励": "第<%=count%>次奖励",
        "筛选": "筛选",
        "类型": "类型",
        "绑定成功立即获得<%=count%>GTO": "绑定成功立即获得<%=count%>GTO",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧",
        "绑定邀请码": "绑定邀请码",
        "绑定邀请码成功!": "绑定邀请码成功!",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "\n绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！",
        "继续参与": "继续参与",
        "继续游戏": "继续游戏",
        "网络有点问题哦": "网络有点问题哦",
        "网络连接异常": "网络连接异常",
        "联系我们": "联系我们",
        "胜": "胜",
        "胜平负": "胜平负 ",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。",
        "获得": "获得",
        "获得<%=count%>个<%=currency%>": "获得<%=count%>个<%=currency%>",
        "被邀请人奖励：": "被邀请人奖励：",
        "设备标识为空": "设备标识为空",
        "话题竞猜": "话题竞猜",
        "该浏览器不支持自动复制": "该浏览器不支持自动复制",
        "详情": "详情",
        "请您至少选择一场比赛": "请您至少选择一场比赛",
        "请输入正确页码": "请输入正确页码",
        "请输入邀请码": "请输入邀请码",
        "请选择最小筹码": "请选择最小筹码",
        "负": "负",
        "贡献用户": "贡献用户",
        "赛事竞猜": "赛事竞猜",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果",
        "赢<%=count%>倍": "赢<%=count%>倍",
        "足球竞猜": "足球竞猜",
        "跳转": "跳转",
        "输入内容不能为空": "输入内容不能为空",
        "输入的邀请码为空": "输入的邀请码为空",
        "返还": "返还",
        "选好了": "选好了",
        "选择国家或地区": "选择国家或地区",
        "选择登录方式": "选择登录方式",
        "选择语言": "选择语言",
        "邀请人奖励：": "邀请人奖励：",
        "邀请好友": "邀请好友",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励",
        "邀请好友赢大奖": "邀请好友赢大奖",
        "邀请码不存在": "邀请码不存在",
        "重新加载": "重新加载",
        "页": "页",
        "首页": "首页",
        "马上去参与": "马上去参与",
        "马上去竞猜": "马上去竞猜",
        "马上开始竞猜": "马上开始竞猜"
    },
    "zhhk": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1、每邀請1個用戶獎勵<%=gto%>GTO，分<%=count%>次發放",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1、話題競猜為官方人員根據熱門賽事創建的自主話題競猜。@@@@2、賽事競猜內容為全場比賽90分鐘(含傷停補時，不含加時賽和點球)的比賽結果。\n@@@@3、當比賽由於棄權、重賽、對陣變更或其他特殊原因導致結果難以判定時，將取消該場競猜，用戶投入的競猜金額將退回給用戶。\n@@@@4、頁面的賠率僅供參考，實際賠率已訂單中的為準。",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2、每次被邀請人競猜中獎，平台發放獎勵",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "<%=count%>場比賽可投",
        "<%=count%>次奖励发放如下：": "<%=count%>次獎勵發放如下：",
        "<%=count%>竞猜记录": "<%=count%>競猜記錄",
        "<%=name%>暂时没有贡献": "<%=name%>暫時沒有貢獻",
        "<%=name%>的邀请码": "<%=name%>的邀請碼",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%>貢獻<span><%=gto%>個GTO</span><span><%=eth%>個ETH</span><span><%=uz%>個U鑽</span>",
        "<em><%=name%></em>的房间": "<em><%=name%></em>的房間",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>在交易所購買GTO，</p><p>轉帳到當前用戶的Gifto錢包地址即可，</p><p>立即前往查看錢包地址？</p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>將ETH轉帳到當前用戶的Gifto錢包地址即可，</p><p>立即前往查看錢包地址？</p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@足球預測，是Uplive旗下娛樂互動平台，用戶可以透過預測足球比賽賽果，輕鬆贏取豐厚的虛擬幣獎勵。\n@@@@通常一場比賽會設定三個預測選項，主隊勝、平局、客隊勝，每個選項對應不同的獎勵倍數。\n@@@@獎勵倍數大小和球隊實力的強弱成反比，球隊實力越強，應對獎勵倍數越小。你可以做出自己的判斷，哪個球隊獲勝的機率更大。\n@@@@競猜落注需投入一定數量的虛擬幣，平台支援U鑽/GTO/ETH。\n@@@@下單成功後，你可以繼續競猜，也可以前往訂單系統查看詳情。\n@@@@例如比賽結果和你的預測選擇一樣，那就恭喜你將獲得對應數量的獎勵！\n@@@@現在就去參與競猜，贏取獎勵吧~",
        "GTO投注量": "GTO投入量",
        "U钻": "U鑽",
        "U钻投注量": "U鑽投注量",
        "U钻投注量奖励": "U鑽投注量獎勵",
        "上一页": "上一頁",
        "下一页": "下一頁",
        "下拉更新": "拉下更新",
        "下载": "下載",
        "不中返本金": "不中獎返本金",
        "不中返还": "不中返還",
        "不再提示": "不再提示",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "世界盃福利送不停<br>估比賽結果，輕鬆贏大獎",
        "两个用户不能相互绑定邀请码,请重新填写": "兩個用戶不能相互綁定邀請碼，請重新填寫",
        "中奖计算": "中獎計算",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "為了回饋足球競猜平台的新老用戶，在活動期間累計投注GTO達到一定數量（投注量不包含邀請好友贈送獎勵、紅包獎勵、邀請的好友競猜中獎後額外贈送獎勵），將會獲得相應的GTO獎勵，投注越多獎勵越豐厚。活動獎勵將在活動結束後7個工作日內發放。",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "為了回饋足球競猜平台的新老用戶，在活動期間累計投注U鑽達到一定數量（投注量不包含邀請好友競猜中獎後額外贈送獎勵），將會獲得相應的U鑽獎勵，投注越多獎勵越豐厚。活動獎勵將在活動結束後7個工作日內發放。",
        "主胜": "主勝",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "親愛的<%=username%>，恭喜你預測中啦，獲得<%=count%><%=currency%>獎勵",
        "充值": "充值",
        "全选": "全選",
        "全部": "全部",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "共<%=count%>條紀錄 <span class=\"cur-page-box\">當前第<%=curPage%>/<%=pages%>頁</span>",
        "关于我们": "關於我們",
        "分享到Facebook": "分享到Facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "切換支付方式，可選方式包含：<p class='green'>GTO、ETH、U鑽</p>",
        "切换语言": "切換語言",
        "切换语言版本": "切換語言版本",
        "加载中……": "載入中...",
        "单个玩法竞猜金额超出上限": "單個玩法競猜金額超出上限",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "單場比賽累計中獎金額超過一定數量時，需工作人員手動發獎，請耐心等待或聯繫客服。",
        "单次最大可投<%=count%><%=unit%>": "單次最大可投<%=count%><%=unit%>",
        "单次竞猜金额超出上限": "單次競猜金額超出上限",
        "去充值": "去充值",
        "去登录": "去登入",
        "参与成功": "參與成功",
        "参与详情": "參與詳情",
        "反选": "反選",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "發放條件：被邀請用戶每完成一次競猜落單，即可獲得一次獎勵。",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "受當地法律政策限制，本產品在該地區暫不開放使用",
        "可领取奖励": "可領取獎勵",
        "可领取奖励：": "可領取獎勵：",
        "同一台设备不可多次绑定邀请码": "同一台設備不可多次綁定邀請碼",
        "含获赠的": "含獲贈的",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "在<%=hostname%>vs<%=guestname%>比賽中，您最多還能投<%=max%><%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "在成功綁定邀請碼後，立即可獲得<%=count%>GTO獎勵。",
        "复制成功": "複製成功",
        "复制邀请地址": "復制邀請連結",
        "大奖派发": "大獎發放",
        "奖励": "獎勵",
        "奖励规则如下：": "獎勵規則如下：",
        "好友猜中比赛后，你也可以获得奖励哦~~": "好友猜中比賽後，你也可以獲得獎勵哦",
        "如何邀请？": "如何邀請？",
        "客胜": "客勝",
        "小视频": "短片",
        "尾页": "尾頁",
        "已中奖": "已中獎",
        "已使用": "已使用",
        "已取消": "已取消",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "已成功複製您邀請地址~<br/>快發給朋友們邀請他們一起來玩吧!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "已經有比賽截止競猜<br/>請重新選擇比賽",
        "已选<%=count%>场比赛": "已選<%=count%>場比賽",
        "帮助": "幫助",
        "平": "平",
        "平局": "平局",
        "开赛": "開賽",
        "当前是最后一页": "當前是最後一頁",
        "当前是第一页": "當前是第一頁",
        "待揭晓": "待揭曉",
        "快来和我一起赢大奖吧": "快來和我一起赢大獎吧~",
        "总投注额10%": "總投入額10%",
        "总投注额15%": "總投入額15%",
        "总投注额20%": "總投入額20%",
        "总投注额25%": "總投入額25%",
        "总投注额3%": "總投注額3%",
        "总投注额30%": "總投入額30%",
        "总投注额5%": "總投入額5%",
        "总投注额8%": "總投入額8%",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "恭喜<%=name%>成功邀請好友獲得<%=count%>GTO獎勵",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "恭喜<%=name%>獲得<span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "您已綁定的邀請碼",
        "您最多还能投<%=max%><%=unit%>": "您最多還能投<%=max%><%=unit%>",
        "您的<%=type%>不足": "您的<%=type%>不足",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "成功綁定邀請碼，<p>立即獲得<span class='green bold'><%=count%>个GTO獎勵</span></p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "成功綁定邀請碼，立即獲得<%=count%>GTO獎勵",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "成功邀請好友，立即獲得<%=count%>GTO獎勵",
        "我已成功邀请<%=count%>个好友": "我已成功邀請<%=count%>個好友",
        "我的投注量：": "我的投入量：",
        "我的收益": "我的收益",
        "我的订单": "我的訂單",
        "我的贡献": "我的貢獻",
        "我的邀请码": "我的邀請碼",
        "我邀请的好友": "我邀請的好友",
        "截止": "截止",
        "投注越多 奖励越丰厚": "投注越多 獎勵越豐厚",
        "抱歉,没有更多数据啦~": "抱歉，沒有更多數據",
        "排行榜": "排行榜",
        "提交": "提交",
        "提示：即使活动结束，此奖励政策依然有效。": "提示：即使活動結束，此獎勵政策依然有效。",
        "支持GTO、ETH、U钻": "支援GTO、ETH、U鑽",
        "收益": "收益",
        "收益明细": "收益明細",
        "收起": "收起",
        "时间": "時間",
        "星期一": "星期一",
        "星期三": "星期三",
        "星期二": "星期二",
        "星期五": "星期五",
        "星期六": "星期六",
        "星期四": "星期四",
        "星期日": "星期日",
        "暂无满足奖励条件的用户": "暫無滿足獎勵條件的用戶",
        "暂无记录": "暫無紀錄",
        "暂无赛事": "暫無賽事",
        "更新中": "更新中",
        "最多选择8场比赛": "最多選擇8場比賽",
        "最新中奖名单": "最新中獎名單",
        "服务器链接中断!": "伺服器連結中斷！",
        "未中奖": "未中獎",
        "未使用": "未使用",
        "松开更新": "鬆開更新",
        "查看你的竞猜记录": "查看你的競猜記錄",
        "查看全部": "查看全部",
        "查看我邀请的好友": "查看我邀請的好友",
        "查看明细": "查看細節",
        "查看竞猜玩法规则": "查看競猜玩法規則",
        "查看竞猜记录": "查看競猜記錄",
        "正在加载": "正在載入",
        "此邀请码绑定人数已达上限": "此邀請碼綁定人數已達上限",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "每個平台用戶，都擁有專屬的邀請頁面(含邀請碼)，轉發邀請頁面給其他人，新用戶在註冊後24小時內成功綁定此邀請碼，即邀請成功",
        "比赛已停止竞猜": "比賽已停止競猜",
        "比赛已取消": "比賽已取消",
        "比赛结果:": "比賽結果:",
        "没有权限，如有疑问请联系客服！": "沒有權限，如有疑問請聯繫客服！",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "活動中所獲GTO獎勵，只能用於競猜落注，不可直接提現或轉帳。中獎後，則會變成通用GTO。",
        "活动时间：": "活動時間：",
        "消耗": "消耗",
        "清空": "清空",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "火熱足球賽事競猜平台，精彩世界杯等你黎玩，註冊並綁定我的邀請碼就送獎勵哦！",
        "点击复制": "點擊複製",
        "热门直播": "熱門直播",
        "特别提醒：": "特別提醒：",
        "猜中最大可获得": "猜中最大可獲得",
        "猜中获得": "猜中獲得",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "猜中獲得的金額 = 總消耗金額 x 選項可贏倍數。",
        "猜中记录": "猜中記錄",
        "玩法": "玩法",
        "玩法规则": "玩法規則",
        "用户名": "用戶名",
        "用户网络不稳定": "用戶網路不穩定",
        "登出": "登出",
        "登录": "登入",
        "登录后才能执行此操作": "登入後才能執行此操作",
        "知道了": "知道了",
        "确定": "確定",
        "禁止绑定自己邀请码": "禁止綁定自己邀請碼",
        "立即参与": "立即參與",
        "立即参与竞猜": "立即參與競猜",
        "立即邀请好友，赢大奖": "立即邀請好友，贏大獎",
        "竞猜下单赠送": "競猜落注贈送",
        "竞猜中奖赠送": "競猜中獎贈送",
        "竞猜介绍": "競猜介紹",
        "竞猜内容": "競猜內容",
        "竞猜排行榜": "競猜排行榜",
        "竞猜方式": "競猜方式",
        "竞猜时间": "競猜時間",
        "第<%=count%>次奖励": "第<%=count%>次獎勵",
        "筛选": "篩選",
        "类型": "類型",
        "绑定成功立即获得<%=count%>GTO": "綁定成功立即獲得<%=count%>GTO",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "綁定成功立即獲得<%=count%>GTO，每個用戶都有專屬邀請碼，快去向朋友索要邀請碼吧",
        "绑定邀请码": "綁定邀請碼",
        "绑定邀请码成功!": "綁定邀請碼成功！",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "綁定邀請碼獲得的GTO只能用於足球競猜，不能轉帳或兌現！",
        "继续参与": "繼續參與",
        "继续游戏": "繼續遊戲",
        "网络有点问题哦": "網路不穩定",
        "网络连接异常": "網路連結異常",
        "联系我们": "聯繫我們",
        "胜": "勝",
        "胜平负": "勝平負",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "自邀請成功6個月內，被邀請人每次競猜中獎，平台將發放獎勵給邀請人，具體規則為被邀請人實際中獎收益(中獎金額和競猜資金相差)的3%。此獎勵由平台承擔，不會影響被邀請人收益。",
        "获得": "獲得",
        "获得<%=count%>个<%=currency%>": "獲得<%=count%>个<%=currency%>",
        "被邀请人奖励：": "被邀請人獎勵：",
        "设备标识为空": "設備標示為空",
        "话题竞猜": "話題競猜",
        "该浏览器不支持自动复制": "此瀏覽器不支援自動複製",
        "详情": "詳情",
        "请您至少选择一场比赛": "請您至少選擇一場比賽",
        "请输入正确页码": "請輸入正確頁數",
        "请输入邀请码": "請輸入邀請碼",
        "请选择最小筹码": "請選擇最細籌碼",
        "负": "負",
        "贡献用户": "貢獻用戶",
        "赛事竞猜": "賽事競猜",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "賽事競猜內容為全場比賽90分鐘(含傷停補時，不含加時賽和互射十二碼)的比賽結果",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "賽果為所選比賽90分鐘(含傷停補時，不含加時賽和點球)的比賽結果",
        "赢<%=count%>倍": "贏<%=count%>倍",
        "足球竞猜": "足球預測",
        "跳转": "跳轉",
        "输入内容不能为空": "輸入內容不能為空",
        "输入的邀请码为空": "輸入的邀請碼為空",
        "返还": "返還",
        "选好了": "選好了",
        "选择国家或地区": "選擇國家或地區",
        "选择登录方式": "選擇登入方式",
        "选择语言": "選擇語言",
        "邀请人奖励：": "邀請人獎勵：",
        "邀请好友": "邀請好友",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "邀請好友成功綁定邀請碼，可獲得<span class='green bold'><%=count%>个GTO</span>獎勵",
        "邀请好友赢大奖": "邀請好友贏大獎",
        "邀请码不存在": "邀請碼不存在",
        "重新加载": "重新載入",
        "页": "頁",
        "首页": "首頁",
        "马上去参与": "馬上去參與",
        "马上去竞猜": "馬上去競猜",
        "马上开始竞猜": "開始競猜"
    },
    "zhtw": {
        "1，每邀请1个用户奖励<%=gto%>GTO，分<%=count%>次发放": "1、每邀請1個用戶獎勵<%=gto%>GTO，分<%=count%>次發放",
        "1，话题竞猜为运营人员根据热门赛事创建的自主话题竞猜；@@@@2，赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球）的比赛结果。@@@@3，当比赛由于弃权、重赛、对阵变更或其他特殊原因导致结果难以判定时将取消该场竞猜，用户投入的竞猜金额将退回给用户。@@@@4，页面的赔率仅供参考，实际赔率请以订单中的为准。": "1、話題預測為官方人員根據熱門賽事創建的自主話題預測。@@@@2、賽事預測內容為全場比賽90分鐘(含傷停補時，不含加時賽和點球大战)的比賽結果。@@@@3、當比賽由於棄權、重賽、對陣變更或其他特殊原因導致結果難以判定時，將取消該場預測，用戶投入的預測金額將退回給用戶。@@@@4、頁面的賠率僅供參考，實際賠率已訂單中的為準。",
        "2，每次被邀请人竞猜中奖，平台发放奖励": "2、每次被邀請人預測中獎，平台發放獎勵",
        "<%=count%>GTO": "<%=count%>GTO",
        "<%=count%>场比赛可投": "<%=count%>場比賽可投",
        "<%=count%>次奖励发放如下：": "<%=count%>次獎勵發放如下：",
        "<%=count%>竞猜记录": "<%=count%>預測記錄",
        "<%=name%>暂时没有贡献": "<%=name%>暫時沒有貢獻",
        "<%=name%>的邀请码": "<%=name%>的邀請碼",
        "<%=name%>贡献<span><%=gto%>个GTO</span><span><%=eth%>个ETH</span><span><%=uz%>个U钻</span>": "<%=name%>貢獻<span><%=gto%>個GTO</span><span><%=eth%>個ETH</span><span><%=uz%>個U鑽</span>",
        "<em><%=name%></em>的房间": "<em><%=name%></em>的房間",
        "<p>在交易所购买GTO，</p><p>转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>在交易所購買GTO，</p><p>轉帳到當前用戶的Gifto錢包地址即可，</p><p>立即前往查看錢包地址？</p>",
        "<p>将ETH转账到当前用户的Gifto钱包地址即可，</p><p>立即前往查看钱包地址？</p>": "<p>將ETH轉帳到當前用戶的Gifto錢包地址即可，</p><p>立即前往查看錢包地址？</p>",
        "@@@@足球竞猜，是Uplive旗下娱乐互动平台，用户可通过预测足球比赛赛果，轻松赢取丰厚的虚拟币奖励。@@@@1，通常一场比赛会设定三个竞猜选项，主队胜、平局、客队胜，每个选项对应不同的奖励倍数。@@@@2， 奖励倍数大小和球队实力的强弱成反比，球队实力越强，对应奖励倍数越小。你可以做出自己的判断，到底哪个球队获胜的概率更大。@@@@3，竞猜下单需投入一定数量的虚拟币哦，平台支持U钻 / GTO / ETH。@@@@4，下单成功后，你可以继续竞猜，也可以前往订单系统查看详情。@@@@5， 假如比赛结果和你的竞猜选项一样，那么恭喜你将获得对应数量的奖励。@@@@现在就去参与竞猜，赢取奖励吧~": "@@@@足球預測，是Uplive旗下娛樂互動平台，用戶可以透過預測足球比賽賽果，輕鬆贏取豐厚的虛擬幣獎勵。\n@@@@通常一場比賽會設定三個預測選項，主隊勝、平局、客隊勝，每個選項對應不同的獎勵倍數。\n@@@@獎勵倍數大小和球隊實力的強弱成反比，球隊實力越強，應對獎勵倍數越小。你可以做出自己的判斷，哪個球隊獲勝的機率更大。\n@@@@預測下單需投入一定數量的虛擬幣，平台支援U鑽/GTO/ETH。\n@@@@下單成功後，你可以繼續預測，也可以前往訂單系統查看詳情。\n@@@@例如比賽結果和你的預測選擇一樣，那就恭喜你將獲得對應數量的獎勵囉~\n@@@@現在就去參與預測，贏取獎勵吧~",
        "GTO投注量": "GTO投入量",
        "U钻": "U鑽",
        "U钻投注量": "U鑽投入量",
        "U钻投注量奖励": "U鑽投入量獎勵",
        "上一页": "上一頁",
        "下一页": "下一頁",
        "下拉更新": "下拉更新",
        "下载": "下載",
        "不中返本金": "不中獎返本金",
        "不中返还": "不中返還",
        "不再提示": "不再提示",
        "世界杯福利送不停<br>猜比赛结果，轻松赢大奖": "世界盃福利送不停<br>猜比賽結果，輕鬆贏大獎",
        "两个用户不能相互绑定邀请码,请重新填写": "兩個用戶不能相互綁定邀請碼，請重新填寫",
        "中奖计算": "中獎計算",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注GTO达到一定数量（投注量不包含邀请好友赠送奖励、红包奖励、邀请的好友竞猜中奖后额外赠送奖励），将会获得相应的GTO奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "為了回饋足球預測平台新老用戶，在活動期間累計投入GTO達到一定數量（投入量不包含邀請好友贈送獎勵、紅包獎勵、邀請的好友預測中獎後額外贈送獎勵），將會獲得相應的GTO獎勵，投入越多獎勵越豐富。活動獎勵將在活動結束後7個工作日內發放。",
        "为了回馈足球竞猜平台的新老用户，在活动期间累计投注U钻达到一定数量（投注量不包含邀请好友竞猜中奖后额外赠送奖励），将会获得相应的U钻奖励，投注越多奖励越丰厚。活动奖励将在活动结束后7个工作日内发放。": "為了回饋足球預測平台的所有用戶，在活動期間累計投入U鑽達到一定數量（投入量不包含邀請好友預測中獎後額外贈送獎勵），將會獲得相應的U鑽獎勵，投注越多獎勵越豐厚。活動獎勵將在活動結束後7個工作日內發放。",
        "主胜": "主勝",
        "亲爱的<%=username%>，恭喜你的足球竞猜订单中奖啦，获得<%=count%><%=currency%>奖励": "親愛的<%=username%>，恭喜你預測中啦，獲得<%=count%><%=currency%>獎勵",
        "充值": "儲值",
        "全选": "全選",
        "全部": "全部",
        "共<%=count%>条记录 <span class=\"cur-page-box\">当前第<%=curPage%>/<%=pages%>页</span>": "共<%=count%>條紀錄 <span class=\"cur-page-box\">當前第<%=curPage%>/<%=pages%>頁</span>",
        "关于我们": "關於我們",
        "分享到Facebook": "分享到Facebook",
        "切换支付方式，可选方式包含：<p class='green'>GTO、ETH、U钻</p>": "切換支付方式，可選方式包含：<p class='green'>GTO、ETH、U鑽</p>",
        "切换语言": "切換語言",
        "切换语言版本": "切換語言版本",
        "加载中……": "載入中...",
        "单个玩法竞猜金额超出上限": "單個玩法預測金額超出上限",
        "单场比赛累计中奖金数超过一定数量时，需工作人员手动派奖，请耐心等待或联系客服。": "單場比賽累計中獎金額超過一定數量時，需工作人員手動發獎，請耐心等待或聯繫客服。",
        "单次最大可投<%=count%><%=unit%>": "單次最大可投<%=count%><%=unit%>",
        "单次竞猜金额超出上限": "單次預測金額超出上限",
        "去充值": "去儲值",
        "去登录": "去登入",
        "参与成功": "參與成功",
        "参与详情": "參與詳情",
        "反选": "反選",
        "发放条件：被邀请用户每完成一次竞猜下单，即可获得一次奖励。": "發放條件：被邀請用戶每完成一次預測下單，即可獲得一次獎勵。",
        "受当地法律政策限制，本产品在该地区暂不开放使用": "受當地法律政策限制，本產品在該地區暫不開放使用",
        "可领取奖励": "可領取獎勵",
        "可领取奖励：": "可領取獎勵：",
        "同一台设备不可多次绑定邀请码": "同一台設備不可多次綁定邀請碼",
        "含获赠的": "含獲贈的",
        "在<%=hostname%>vs<%=guestname%>比赛中,您最多还能投<%=max%><%=unit%>": "在<%=hostname%>vs<%=guestname%>比賽中，您最多還能投<%=max%><%=unit%>",
        "在成功绑定邀请码后，立即可获得<%=count%>GTO奖励。": "在成功綁定邀請碼後，立即可獲得<%=count%>GTO獎勵。",
        "复制成功": "複製成功",
        "复制邀请地址": "複製邀請連結",
        "大奖派发": "大獎發放",
        "奖励": "獎勵",
        "奖励规则如下：": "獎勵規則如下：",
        "好友猜中比赛后，你也可以获得奖励哦~~": "好友猜中比賽後，你也可以獲得獎勵哦",
        "如何邀请？": "如何邀請？",
        "客胜": "客勝",
        "小视频": "短片",
        "尾页": "尾頁",
        "已中奖": "已中獎",
        "已使用": "已使用",
        "已取消": "已取消",
        "已成功复制您邀请地址~<br />快发给朋友们邀请他们一起来玩吧!": "已成功複製您邀請地址~<br/>快發給朋友們邀請他們一起來玩吧!",
        "已经有比赛截止竞猜<br/>请重新选择比赛": "已經有比賽截止預測<br/>請重新選擇比賽",
        "已选<%=count%>场比赛": "已選<%=count%>場比賽",
        "帮助": "幫助",
        "平": "平",
        "平局": "平局",
        "开赛": "開賽",
        "当前是最后一页": "當前是最後一頁",
        "当前是第一页": "當前是第一頁",
        "待揭晓": "待揭曉",
        "快来和我一起赢大奖吧": "快來和我一起赢大獎吧~",
        "总投注额10%": "總投入額10%",
        "总投注额15%": "總投入額15%",
        "总投注额20%": "總投入額20%",
        "总投注额25%": "總投入額25%",
        "总投注额3%": "總投入額3%",
        "总投注额30%": "總投入額30%",
        "总投注额5%": "總投入額5%",
        "总投注额8%": "總投入額8%",
        "恭喜<%=name%>成功邀请好友获得<%=count%>GTO奖励": "恭喜<%=name%>成功邀請好友獲得<%=count%>GTO獎勵",
        "恭喜<%=name%>获得<span><%=count%><%=type%></span>": "恭喜<%=name%>獲得<span><%=count%><%=type%></span>",
        "您已绑定的邀请码": "您已綁定的邀請碼",
        "您最多还能投<%=max%><%=unit%>": "您最多還能投<%=max%><%=unit%>",
        "您的<%=type%>不足": "您的<%=type%>不足",
        "成功绑定邀请码，<p>立即获得<span class='green bold'><%=count%>个GTO奖励</span></p>": "成功綁定邀請碼，<p>立即獲得<span class='green bold'><%=count%>个GTO獎勵</span></p>",
        "成功绑定邀请码，立即获得<%=count%>GTO奖励": "成功綁定邀請碼，立即獲得<%=count%>GTO獎勵",
        "成功邀请好友，立即获得<%=count%>GTO奖励": "成功邀請好友，立即獲得<%=count%>GTO獎勵",
        "我已成功邀请<%=count%>个好友": "我已成功邀請<%=count%>個好友",
        "我的投注量：": "我的投入量：",
        "我的收益": "我的收益",
        "我的订单": "我的訂單",
        "我的贡献": "我的貢獻",
        "我的邀请码": "我的邀請碼",
        "我邀请的好友": "我邀請的好友",
        "截止": "截止",
        "投注越多 奖励越丰厚": "投入越多 獎勵越豐富",
        "抱歉,没有更多数据啦~": "抱歉，沒有更多數據啦",
        "排行榜": "排行榜",
        "提交": "提交",
        "提示：即使活动结束，此奖励政策依然有效。": "提示：即使活動結束，此獎勵政策依然有效。",
        "支持GTO、ETH、U钻": "支援GTO、ETH、U鑽",
        "收益": "收益",
        "收益明细": "收益明細",
        "收起": "收起",
        "时间": "時間",
        "星期一": "星期一",
        "星期三": "星期三",
        "星期二": "星期二",
        "星期五": "星期五",
        "星期六": "星期六",
        "星期四": "星期四",
        "星期日": "星期日",
        "暂无满足奖励条件的用户": "暫無滿足獎勵條件的用戶",
        "暂无记录": "暫無紀錄",
        "暂无赛事": "暫無賽事",
        "更新中": "更新中",
        "最多选择8场比赛": "最多選擇8場比賽",
        "最新中奖名单": "最新中獎名單",
        "服务器链接中断!": "伺服器連結中斷！",
        "未中奖": "未中獎",
        "未使用": "未使用",
        "松开更新": "鬆開更新",
        "查看你的竞猜记录": "查看你的預測記錄",
        "查看全部": "查看全部",
        "查看我邀请的好友": "查看我邀請的好友",
        "查看明细": "查看明細",
        "查看竞猜玩法规则": "查看預測玩法規則",
        "查看竞猜记录": "查看預測記錄",
        "正在加载": "正在載入",
        "此邀请码绑定人数已达上限": "此邀請碼綁定人數已達上限",
        "每个平台用户，都拥有专属的邀请页面(含邀请码)，转发邀请页面给其他人，新用户在注册后24小时内成功绑定此邀请码，即邀请成功。": "每個平台用戶，都擁有專屬的邀請頁面(含邀請碼)，轉發邀請頁面給其他人，新用戶在註冊後24小時內成功綁定此邀請碼，即邀請成功",
        "比赛已停止竞猜": "比賽已停止預測",
        "比赛已取消": "比賽已取消",
        "比赛结果:": "比賽結果:",
        "没有权限，如有疑问请联系客服！": "沒有權限，如有疑問請聯繫客服！",
        "活动中所获GTO奖励，只能用于竞猜下单，不可直接提现或转账。中奖后，则会变成通用GTO。": "活動中所獲GTO獎勵，只能用於預測下單，不可直接提現或轉帳。中獎後，則會變成通用GTO。",
        "活动时间：": "活動時間：",
        "消耗": "消耗",
        "清空": "清空",
        "火热足球赛事竞猜平台，精彩世界杯等你来嗨，注册并绑定我的邀请码就送奖励哦！": "火熱足球賽事預測平台，精彩世界盃等你來玩，註冊並綁定我的邀請碼就送獎勵哦！",
        "点击复制": "點擊複製",
        "热门直播": "熱門直播",
        "特别提醒：": "特別提醒：",
        "猜中最大可获得": "猜中最大可獲得",
        "猜中获得": "猜中獲得",
        "猜中获得的金额 = 总消耗金额 × 选项可赢倍数。": "猜中獲得的金額 = 總消耗金額 x 選項可贏倍數。",
        "猜中记录": "猜中記錄",
        "玩法": "玩法",
        "玩法规则": "玩法規則",
        "用户名": "用戶名",
        "用户网络不稳定": "用戶網路不穩定",
        "登出": "登出",
        "登录": "登入",
        "登录后才能执行此操作": "登入後才能執行此操作",
        "知道了": "知道了",
        "确定": "確定",
        "禁止绑定自己邀请码": "禁止綁定自己邀請碼",
        "立即参与": "確認扣點",
        "立即参与竞猜": "立即參與預測",
        "立即邀请好友，赢大奖": "立即邀請好友，贏大獎",
        "竞猜下单赠送": "預測下單贈送",
        "竞猜中奖赠送": "預測中獎贈送",
        "竞猜介绍": "預測介紹",
        "竞猜内容": "預測內容",
        "竞猜排行榜": "預測排行榜",
        "竞猜方式": "預測方式",
        "竞猜时间": "預測時間",
        "第<%=count%>次奖励": "第<%=count%>次獎勵",
        "筛选": "篩選",
        "类型": "類型",
        "绑定成功立即获得<%=count%>GTO": "綁定成功立即獲得<%=count%>GTO",
        "绑定成功立即获得<%=count%>GTO，每个用户都有专属邀请码，快去向朋友索要邀请码吧": "綁定成功立即獲得<%=count%>GTO，每個用戶都有專屬邀請碼，快去向朋友索取邀請碼吧",
        "绑定邀请码": "綁定邀請碼",
        "绑定邀请码成功!": "綁定邀請碼成功！",
        "绑定邀请码获得的GTO仅能用于足球竞猜，不能转账或提现！": "綁定邀請碼獲得的GTO僅能用於足球預測，不能轉帳或提限！",
        "继续参与": "繼續參與",
        "继续游戏": "繼續遊戲",
        "网络有点问题哦": "網路不穩定",
        "网络连接异常": "網路連結異常",
        "联系我们": "聯繫我們",
        "胜": "勝",
        "胜平负": "勝平負",
        "自邀请成功6个月内，被邀请人每次竞猜中奖，平台将发放奖励给邀请人，具体规则为被邀请人实际中奖收益（中奖金额和竞猜本金的差）的3%，此奖励由平台承担，不会影响被邀请人收益。": "自邀請成功6個月內，被邀請人每次預測中獎，平台將發放獎勵給邀請人，具體規則為被邀請人實際中獎收益(中獎金額和預測本金的差)的3%。此獎勵由平台承擔，不會影響被邀請人收益。",
        "获得": "獲得",
        "获得<%=count%>个<%=currency%>": "獲得<%=count%>个<%=currency%>",
        "被邀请人奖励：": "被邀請人獎勵：",
        "设备标识为空": "設備標示為空",
        "话题竞猜": "話題預測",
        "该浏览器不支持自动复制": "此瀏覽器不支援自動複製",
        "详情": "詳情",
        "请您至少选择一场比赛": "請您至少選擇一場比賽",
        "请输入正确页码": "請輸入正確頁碼",
        "请输入邀请码": "請輸入邀請碼",
        "请选择最小筹码": "請選擇最小籌碼",
        "负": "負",
        "贡献用户": "貢獻用戶",
        "赛事竞猜": "賽事預測",
        "赛事竞猜内容为全场比赛90分钟（含伤停补时，不含加时赛和点球大战）的比赛结果": "賽事預測內容為全場比賽90分鐘(含傷停補時，不含加時賽和點球大战)的比賽結果",
        "赛果为所选比赛90分钟(含伤停补时,不含加时赛和点球)的比赛结果": "賽果為所選比賽90分鐘(含傷停補時，不含加時賽和點球)的比賽結果",
        "赢<%=count%>倍": "贏<%=count%>倍",
        "足球竞猜": "足球預測",
        "跳转": "跳轉",
        "输入内容不能为空": "輸入內容不能為空",
        "输入的邀请码为空": "輸入的邀請碼為空",
        "返还": "返還",
        "选好了": "選好了",
        "选择国家或地区": "選擇國家或地區",
        "选择登录方式": "選擇登入方式",
        "选择语言": "選擇語言",
        "邀请人奖励：": "邀請人獎勵：",
        "邀请好友": "邀請好友",
        "邀请好友成功绑定邀请码，可获得<span class='green bold'><%=count%>个GTO</span>奖励": "邀請好友成功綁定邀請碼，可獲得<span class='green bold'><%=count%>个GTO</span>獎勵",
        "邀请好友赢大奖": "邀請好友贏大獎",
        "邀请码不存在": "邀請碼不存在",
        "重新加载": "重新載入",
        "页": "頁",
        "首页": "首頁",
        "马上去参与": "馬上去參與",
        "马上去竞猜": "馬上去預測",
        "马上开始竞猜": "開始預測"
    }
}


// WEBPACK FOOTER //
// ./src/js/lang/pack.js